import ot, { useReducer as ln, useCallback as Ae, useEffect as ae, useState as J, useRef as Pn, useMemo as at, memo as on, useContext as Ne, createContext as Vi } from "react";
import { api as K, getSortDirection as Lr, axiosInstance as Yi, getReducerWithProduce as an, getCodeLanguageByFileExtension as Gi, createCrudEntityConfig as Wi, createSortingMethodListConfig as Qi, createFiltersPanelListConfig as Xi, createCrudMethodsListConfig as Ji, createMethodApiCreateListConfig as Ki, getUUID as Ln } from "@prometheus/utils";
import { Status as Z } from "@prometheus/types";
import { Grid as H, Skeleton as Zi, Autocomplete as it, useNotifications as Ct, Spinner as st, StudyStatusTag as Or, Typography as ve, EmptyTableStub as el, Button as ke, Icon as Fe, Block as tl, Divider as sn, Input as xt, Tooltip as Dr, Box as qt, Textarea as nl, Checkbox as rl, Popover as il, PopoverContent as ll, Paper as ol, Alert as al } from "@prometheus/components";
import { Favorite as un, Access as sl, SpinnerWidgetContainer as St, FavoritesHeader as ul, HomePageWidgetList as cl, HomePageWidgetListItem as On, FormElement as et, ImportJsonFile as pl, CodeEditor as dl, FileContentType as hl, FormActionsContainer as Nr, TabsNavigationNew as cn, CreateStudyFormBackdrop as fl, ModuleDescriptionCard as ml, TabWithCounter as He, EditButton as gl, RemoveButton as yl, BaseEntityContent as xl, StudyDetails as Sl, LastInteracted as bl, ErrorPage as kl, BaseContentWrapper as El, BaseInfoWrapper as wl, StudyBaseInfo as Cl, AcceptConsentDialog as Tl, ConfirmationDialog as Il, ID_COLUMN as vl, NAME_COLUMN as _l, ListCell as Dn, CREATED_COLUMN as Al, UPDATED_COLUMN as Rl, PageList as jl } from "@prometheus/features";
import { useNavigate as Ve, useParams as Pl, Routes as Fr, Route as Pe } from "react-router-dom";
import { studyStatuses as Ll, FileExtension as Nn, TypesOfContainer as Ie, StudyStatuses as pt } from "@prometheus/enums";
import { useSelector as Vt, useDispatch as Mr } from "react-redux";
import Tt from "@emotion/styled";
import { useRequest as Ol, ModalContext as zr, DialogContext as Ur, useEntityNew as Dl } from "@prometheus/hooks";
import { setBreadcrumbs as Nl, resetBreadcrumbs as Fl, getSummary as Fn, resetSummary as Ml } from "@prometheus/redux";
import { useTheme as zl } from "@emotion/react";
var bt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Br(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Yt = { exports: {} }, Xe = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Mn;
function Ul() {
  if (Mn) return Xe;
  Mn = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.fragment");
  function n(r, i, l) {
    var o = null;
    if (l !== void 0 && (o = "" + l), i.key !== void 0 && (o = "" + i.key), "key" in i) {
      l = {};
      for (var a in i)
        a !== "key" && (l[a] = i[a]);
    } else l = i;
    return i = l.ref, {
      $$typeof: e,
      type: r,
      key: o,
      ref: i !== void 0 ? i : null,
      props: l
    };
  }
  return Xe.Fragment = t, Xe.jsx = n, Xe.jsxs = n, Xe;
}
var Je = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var zn;
function Bl() {
  return zn || (zn = 1, process.env.NODE_ENV !== "production" && function() {
    function e(u) {
      if (u == null) return null;
      if (typeof u == "function")
        return u.$$typeof === z ? null : u.displayName || u.name || null;
      if (typeof u == "string") return u;
      switch (u) {
        case b:
          return "Fragment";
        case S:
          return "Profiler";
        case C:
          return "StrictMode";
        case j:
          return "Suspense";
        case k:
          return "SuspenseList";
        case F:
          return "Activity";
      }
      if (typeof u == "object")
        switch (typeof u.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), u.$$typeof) {
          case y:
            return "Portal";
          case E:
            return (u.displayName || "Context") + ".Provider";
          case T:
            return (u._context.displayName || "Context") + ".Consumer";
          case v:
            var R = u.render;
            return u = u.displayName, u || (u = R.displayName || R.name || "", u = u !== "" ? "ForwardRef(" + u + ")" : "ForwardRef"), u;
          case O:
            return R = u.displayName || null, R !== null ? R : e(u.type) || "Memo";
          case $:
            R = u._payload, u = u._init;
            try {
              return e(u(R));
            } catch {
            }
        }
      return null;
    }
    function t(u) {
      return "" + u;
    }
    function n(u) {
      try {
        t(u);
        var R = !1;
      } catch {
        R = !0;
      }
      if (R) {
        R = console;
        var U = R.error, g = typeof Symbol == "function" && Symbol.toStringTag && u[Symbol.toStringTag] || u.constructor.name || "Object";
        return U.call(
          R,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          g
        ), t(u);
      }
    }
    function r(u) {
      if (u === b) return "<>";
      if (typeof u == "object" && u !== null && u.$$typeof === $)
        return "<...>";
      try {
        var R = e(u);
        return R ? "<" + R + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function i() {
      var u = A.A;
      return u === null ? null : u.getOwner();
    }
    function l() {
      return Error("react-stack-top-frame");
    }
    function o(u) {
      if (_.call(u, "key")) {
        var R = Object.getOwnPropertyDescriptor(u, "key").get;
        if (R && R.isReactWarning) return !1;
      }
      return u.key !== void 0;
    }
    function a(u, R) {
      function U() {
        D || (D = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          R
        ));
      }
      U.isReactWarning = !0, Object.defineProperty(u, "key", {
        get: U,
        configurable: !0
      });
    }
    function s() {
      var u = e(this.type);
      return te[u] || (te[u] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), u = this.props.ref, u !== void 0 ? u : null;
    }
    function c(u, R, U, g, re, le, ne, we) {
      return U = le.ref, u = {
        $$typeof: d,
        type: u,
        key: R,
        props: le,
        _owner: re
      }, (U !== void 0 ? U : null) !== null ? Object.defineProperty(u, "ref", {
        enumerable: !1,
        get: s
      }) : Object.defineProperty(u, "ref", { enumerable: !1, value: null }), u._store = {}, Object.defineProperty(u._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(u, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(u, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: ne
      }), Object.defineProperty(u, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: we
      }), Object.freeze && (Object.freeze(u.props), Object.freeze(u)), u;
    }
    function p(u, R, U, g, re, le, ne, we) {
      var X = R.children;
      if (X !== void 0)
        if (g)
          if (q(X)) {
            for (g = 0; g < X.length; g++)
              h(X[g]);
            Object.freeze && Object.freeze(X);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else h(X);
      if (_.call(R, "key")) {
        X = e(u);
        var de = Object.keys(R).filter(function(ze) {
          return ze !== "key";
        });
        g = 0 < de.length ? "{key: someKey, " + de.join(": ..., ") + ": ...}" : "{key: someKey}", P[X + g] || (de = 0 < de.length ? "{" + de.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          g,
          X,
          de,
          X
        ), P[X + g] = !0);
      }
      if (X = null, U !== void 0 && (n(U), X = "" + U), o(R) && (n(R.key), X = "" + R.key), "key" in R) {
        U = {};
        for (var xe in R)
          xe !== "key" && (U[xe] = R[xe]);
      } else U = R;
      return X && a(
        U,
        typeof u == "function" ? u.displayName || u.name || "Unknown" : u
      ), c(
        u,
        X,
        le,
        re,
        i(),
        U,
        ne,
        we
      );
    }
    function h(u) {
      typeof u == "object" && u !== null && u.$$typeof === d && u._store && (u._store.validated = 1);
    }
    var m = ot, d = Symbol.for("react.transitional.element"), y = Symbol.for("react.portal"), b = Symbol.for("react.fragment"), C = Symbol.for("react.strict_mode"), S = Symbol.for("react.profiler"), T = Symbol.for("react.consumer"), E = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), j = Symbol.for("react.suspense"), k = Symbol.for("react.suspense_list"), O = Symbol.for("react.memo"), $ = Symbol.for("react.lazy"), F = Symbol.for("react.activity"), z = Symbol.for("react.client.reference"), A = m.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, _ = Object.prototype.hasOwnProperty, q = Array.isArray, Y = console.createTask ? console.createTask : function() {
      return null;
    };
    m = {
      react_stack_bottom_frame: function(u) {
        return u();
      }
    };
    var D, te = {}, ee = m.react_stack_bottom_frame.bind(
      m,
      l
    )(), oe = Y(r(l)), P = {};
    Je.Fragment = b, Je.jsx = function(u, R, U, g, re) {
      var le = 1e4 > A.recentlyCreatedOwnerStacks++;
      return p(
        u,
        R,
        U,
        !1,
        g,
        re,
        le ? Error("react-stack-top-frame") : ee,
        le ? Y(r(u)) : oe
      );
    }, Je.jsxs = function(u, R, U, g, re) {
      var le = 1e4 > A.recentlyCreatedOwnerStacks++;
      return p(
        u,
        R,
        U,
        !0,
        g,
        re,
        le ? Error("react-stack-top-frame") : ee,
        le ? Y(r(u)) : oe
      );
    };
  }()), Je;
}
process.env.NODE_ENV === "production" ? Yt.exports = Ul() : Yt.exports = Bl();
var f = Yt.exports;
const Un = (e) => {
  if (!e)
    return;
  const [t] = e.split("?");
  return t.split("/").filter(Boolean).pop();
}, pn = (e) => {
  var n, r, i, l, o, a, s, c, p;
  if (typeof e == "string" || typeof e == "number")
    return String(e);
  if (typeof (e == null ? void 0 : e.data) == "string" || typeof (e == null ? void 0 : e.data) == "number")
    return String(e.data);
  const t = (e == null ? void 0 : e.id) || ((n = e == null ? void 0 : e.data) == null ? void 0 : n.id) || ((r = e == null ? void 0 : e.study) == null ? void 0 : r.id) || ((i = e == null ? void 0 : e.result) == null ? void 0 : i.id) || ((o = (l = e == null ? void 0 : e.data) == null ? void 0 : l.study) == null ? void 0 : o.id) || ((s = (a = e == null ? void 0 : e.data) == null ? void 0 : a.result) == null ? void 0 : s.id) || Un((c = e == null ? void 0 : e.headers) == null ? void 0 : c.location) || Un((p = e == null ? void 0 : e.headers) == null ? void 0 : p.Location);
  return t ? String(t) : void 0;
}, Hr = (e) => {
  let t = !1, n;
  const r = () => {
    t || (t = !0, window.removeEventListener("popstate", r), window.removeEventListener("prometheus:location-change", r), n && window.clearTimeout(n), window.setTimeout(e));
  };
  window.addEventListener("popstate", r, { once: !0 }), window.addEventListener("prometheus:location-change", r, {
    once: !0
  }), n = window.setTimeout(r, 300);
}, $r = (e) => {
  const { pageNumber: t, pageSize: n, sortBy: r, query: i } = e, l = Lr(r), o = n || "", a = t || 0, s = kt(o, a, l, i);
  return !Hl(i) || !n ? K.get(s) : Vl(a, n, l, i);
}, kt = (e, t, n, r) => `/studies/list?size=${e}&page=${t}&sort=${n}&${r || ""}`, Hl = (e) => e ? new URLSearchParams(e).getAll("filter.study.userhasrole").some((n) => n === "filter.boolean.true" || n === "true") : !1, $l = async (e) => {
  const n = (await K.get(
    kt(50, 0, "modified.timestamp,desc")
  )).content || [], r = (o) => e.title ? o.title === e.title : !0, i = (o) => e.studyId && o.studyId ? o.studyId === e.studyId : !0, l = (o) => {
    var a, s;
    return (a = e.type) != null && a.id && ((s = o.type) != null && s.id) ? String(o.type.id) === String(e.type.id) : !0;
  };
  return n.find(
    (o) => r(o) && i(o) && l(o)
  ) || n.find((o) => r(o) && l(o)) || n.find(r);
}, ql = async (e) => {
  for (let t = 0; t < 5; t += 1) {
    const n = await $l(e);
    if (n)
      return n;
    await new Promise((r) => setTimeout(r, 500));
  }
}, Vl = async (e, t, n, r) => {
  const i = await K.get(
    kt(t, e, n, r)
  );
  if ((i.content || []).length >= t || i.last)
    return i;
  const l = e * t, o = l + t, a = [];
  let s = 0, c = i, p = i.totalPages || 1;
  for (; a.length < o && s < p; ) {
    const m = s === e ? c : await K.get(kt(t, s, n, r));
    a.push(...m.content || []), p = m.totalPages || p, s += 1;
  }
  const h = a.slice(l, o);
  return {
    ...c,
    content: h,
    numberOfElements: h.length,
    pageable: {
      ...c == null ? void 0 : c.pageable,
      pageNumber: e,
      pageSize: t
    }
  };
}, Yl = (e) => {
  const t = `/studies/filter?${e}`;
  return K.get(t);
}, Gl = () => K.get("/studies/sorts"), Wl = (e) => K.get(`/studies/${e}`), qr = (e) => K.delete(`/studies/${e}`), Vr = async (e) => {
  const t = await Yi.post("/api/studies", e, {
    withCredentials: !0
  }), r = t.data && (typeof t.data != "object" || Object.keys(t.data).length) ? t.data : t;
  return pn(r) ? r : await ql(e) || r;
}, Yr = (e, t) => K.post(`/studies/${e}/favorite`, t), Ql = () => K.get("/study-types"), Xl = (e, t) => K.put(`/studies/${t}`, e), Gr = (e) => K.get(`/study-types/${e}/consent`), Jl = (e, t) => K.post(`/studies/${e}/consent/${t}`), Kl = (e) => K.get(
  `/studies/${e}/cohorts/list?size=10&page=0&sort=modified.timestamp,desc`
), Zl = (e) => K.get(
  `/studies/${e}/concept-sets/list?size=10&page=0&sort=modified.timestamp,desc`
), eo = (e) => K.get(
  `/studies/${e}/analyses/list?size=10&page=0&sort=modified.timestamp,desc`
), to = (e) => K.get(
  `/studies/${e}/analyses-submissions/list?size=10&page=0&sort=modified.timestamp,desc`
), no = (e) => Promise.all([
  Kl(e),
  eo(e),
  Zl(e),
  to(e)
]), ro = (e) => K.get(`/studies/${e}/attributes`), io = (e, t) => K.post(`/studies/${e}/attributes`, t), lo = (e, t, n) => K.post(`/studies/${e}/attributes/${t}`, n), oo = (e, t) => K.delete(`/studies/${e}/attributes/${t}`), ao = () => K.get("/tenant/analysis-types"), so = (e) => {
  const { pageNumber: t, pageSize: n, sortBy: r, query: i } = e, l = Lr(r), o = `studies/export-list?size=${n || ""}&page=${t || 0}&sort=${l}&${i || ""}`;
  return K.get(o);
}, uo = (e) => K.get(`/external-study/search?term=${e}`);
var Oe = /* @__PURE__ */ ((e) => (e.GET_STUDY_TYPE = "GET_STUDY_TYPE", e.SET_STUDY_TYPE_SUCCESS = "SET_STUDY_TYPE_SUCCESS", e.SET_STUDY_TYPE_ERROR = "SET_STUDY_TYPE_ERROR", e))(Oe || {});
const co = {
  types: [],
  isLoading: !1,
  isStartHook: !1,
  error: null
}, po = (e, t) => an(e, (n) => {
  switch (t.type) {
    case Oe.GET_STUDY_TYPE:
      n.isLoading = !0, n.error = null;
      break;
    case Oe.SET_STUDY_TYPE_SUCCESS:
      n.isStartHook = !0, n.isLoading = !1, n.types = t.payload;
      break;
    case Oe.SET_STUDY_TYPE_ERROR:
      n.isLoading = !1, n.error = t.payload;
      break;
  }
}), Wr = () => {
  const [e, t] = ln(po, co), n = Ae(async () => {
    t({
      type: Oe.GET_STUDY_TYPE
    });
    try {
      const r = await Ql(), i = await ao();
      t({
        type: Oe.SET_STUDY_TYPE_SUCCESS,
        payload: r.content.map((l) => ({
          ...l,
          analysisTypes: l.analysisTypes.filter(
            (o) => i.includes(o)
          )
        })).filter((l) => l.analysisTypes.length > 0)
      });
    } catch (r) {
      console.error("STUDY TYPES ERROR", r), t({
        type: Oe.SET_STUDY_TYPE_ERROR,
        payload: r
      });
    }
  }, []);
  return ae(() => {
    n();
  }, []), {
    ...e,
    getTypesOfStudy: n
  };
};
var De = /* @__PURE__ */ ((e) => (e.GET_STUDIES_REQUEST = "GET_STUDIES_REQUEST", e.GET_STUDIES_REQUEST_DONE = "GET_STUDIES_REQUEST_DONE", e.GET_STUDIES_REQUEST_FAILED = "GET_STUDIES_REQUEST_FAILED", e))(De || {});
const ho = (e) => e.map((t) => ({
  value: t.id,
  name: t.title
})), fo = {
  status: Z.INITIAL,
  list: [],
  error: null
}, mo = (e, t) => an(e, (n) => {
  switch (t.type) {
    case De.GET_STUDIES_REQUEST:
      n.status = Z.IN_PROGRESS, n.list = [];
      break;
    case De.GET_STUDIES_REQUEST_DONE:
      n.status = Z.SUCCESS, n.list = t.payload;
      break;
    case De.GET_STUDIES_REQUEST_FAILED:
      n.status = Z.ERROR, n.list = [], n.error = t.payload;
  }
}), Qr = (e, t) => {
  const [n, r] = ln(mo, fo), i = Ae(async () => {
    r({
      type: De.GET_STUDIES_REQUEST
    });
    try {
      const l = await $r({
        pageNumber: 0,
        pageSize: 1e5,
        query: e
      }), o = t ? l.content : ho(l.content);
      r({
        type: De.GET_STUDIES_REQUEST_DONE,
        payload: o
      });
    } catch (l) {
      r({
        type: De.GET_STUDIES_REQUEST_FAILED,
        payload: l
      });
    }
  }, []);
  return ae(() => {
    i();
  }, []), {
    ...n
  };
}, jt = 50, Pt = { id: "modified.timestamp", desc: !0 }, go = "filter.search", yo = 300, Bn = (e = "") => {
  const t = e.trim();
  return t ? new URLSearchParams({ [go]: t }).toString() : "";
};
function xo(e) {
  const [t, n] = J([]), [r, i] = J(null), [l, o] = J(Z.INITIAL), [a, s] = J(0), [c, p] = J(!0), [h, m] = J(!1), [d, y] = J(""), b = Pn(0), C = Pn(r);
  ae(() => {
    C.current = r;
  }, [r]);
  const S = Ae(
    async (E = {
      pageNumber: 0,
      pageSize: jt,
      sortBy: Pt
    }) => {
      const v = E.pageNumber || 0, j = v === 0, k = ++b.current;
      j ? o(Z.IN_PROGRESS) : m(!0);
      try {
        const O = await so(E), $ = O.content || [];
        if (k !== b.current)
          return;
        if (n((F) => {
          if (j)
            return $;
          const z = new Set(F.map((_) => _ == null ? void 0 : _.id)), A = $.filter(
            (_) => (_ == null ? void 0 : _.id) && !z.has(_.id)
          );
          return [...F, ...A];
        }), s(v), p(!O.last), !C.current) {
          const F = $.find((z) => (z == null ? void 0 : z.id) === e);
          if (F)
            i(F);
          else if (e && !O.last && !E.query) {
            setTimeout(() => {
              S({
                ...E,
                pageNumber: v + 1
              });
            }, 0);
            return;
          }
        }
        o(Z.SUCCESS);
      } catch (O) {
        if (k !== b.current)
          return;
        console.error(O), o(Z.ERROR);
      } finally {
        k === b.current && m(!1);
      }
    },
    [e]
  ), T = Ae(async () => {
    l === Z.IN_PROGRESS || h || !c || await S({
      pageNumber: a + 1,
      pageSize: jt,
      sortBy: Pt,
      query: Bn(d)
    });
  }, [S, c, h, a, d, l]);
  return ae(() => {
    const E = setTimeout(() => {
      S({
        pageNumber: 0,
        pageSize: jt,
        sortBy: Pt,
        query: Bn(d)
      });
    }, yo);
    return () => clearTimeout(E);
  }, [S, d]), {
    studies: t,
    status: l,
    currentStudy: r,
    setCurrentStudy: i,
    loadMore: T,
    hasMore: c,
    isLoadingMore: h,
    searchTerm: d,
    setSearchTerm: y
  };
}
const So = (e) => {
  const { onChange: t, studyInitialId: n, analysisMode: r, pureControl: i } = e, [l, o] = J(null), { list: a, status: s } = Qr(), c = () => n ? !l : !0;
  ae(() => {
    l && t(l == null ? void 0 : l.value, l);
  }, [l]), ae(() => {
    if (a && a.length > 0 && n) {
      const m = a.find((d) => d.value === n);
      (r || i) && o(m);
      return;
    }
    i && !n && o(null);
  }, [a, n, r, i]);
  const p = at(() => i ? a : a.filter((m) => r ? m : m.value !== n), [a, r, n, i]), h = (s === Z.INITIAL || s === Z.IN_PROGRESS) && c();
  return s === Z.ERROR ? /* @__PURE__ */ f.jsx("p", { children: "Failed to load studies" }) : h ? /* @__PURE__ */ f.jsx(H, { item: !0, xs: 12, children: /* @__PURE__ */ f.jsx(Zi, { height: 30, width: "100%" }) }) : /* @__PURE__ */ f.jsx(
    it,
    {
      className: "",
      name: "studies",
      id: "studies",
      options: p || [],
      value: l,
      placeholder: h ? "Loading study list" : "Select study...",
      loadingText: "Loading study list...",
      fullWidth: !0,
      isOptionEqualToValue: (m, d) => m.value === d.value,
      loading: h,
      onChange: (m, d) => {
        o(d);
      },
      getOptionLabel: (m) => m.name,
      getOptionKey: (m) => m.value,
      disableClearable: !0
    }
  );
}, Xr = (e) => {
  const [t, n] = J(e.isFavorite), { enqueueSnackbar: r } = Ct(), i = (o) => {
    var a;
    return {
      success: /* @__PURE__ */ f.jsxs("span", { children: [
        /* @__PURE__ */ f.jsxs("b", { children: [
          " ",
          ((a = e.parent) == null ? void 0 : a.title) || "Study",
          " "
        ] }),
        o ? /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
          "was successfully marked as ",
          /* @__PURE__ */ f.jsx("b", { children: "favorite" })
        ] }) : /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
          "was successfully ",
          /* @__PURE__ */ f.jsx("b", { children: "removed from favorites" })
        ] })
      ] }),
      error: "Something went wrong, try again"
    };
  }, l = async () => {
    var o;
    try {
      const a = { favorite: !t };
      await Yr((o = e.parent) == null ? void 0 : o.id, a), n(a.favorite), r({
        message: i(a.favorite).success
      });
    } catch (a) {
      r({
        message: i().error,
        variant: "error"
      }), console.error("ERROR ADDING TO FAVORITE", a);
    }
  };
  return ae(() => {
    n(e.isFavorite);
  }, [e.isFavorite]), /* @__PURE__ */ f.jsxs(H, { container: !0, spacing: 1, wrap: "nowrap", alignContent: "center", children: [
    /* @__PURE__ */ f.jsx(H, { item: !0, children: /* @__PURE__ */ f.jsx(
      un,
      {
        isFavorite: t,
        onClick: l,
        size: e.size,
        viewMode: e.viewMode
      }
    ) }),
    /* @__PURE__ */ f.jsx(H, { item: !0, children: /* @__PURE__ */ f.jsx(sl, { viewMode: !0, isPrivate: e.isPrivate, size: e.size }) })
  ] });
}, Jr = (e) => {
  const t = Ve(), { list: n, status: r } = Qr(
    "filter.study.favorite.name=filter.boolean.true",
    !0
  ), [i, l] = J(!1), o = () => {
    l(!i);
  };
  return r === Z.INITIAL || r === Z.IN_PROGRESS ? /* @__PURE__ */ f.jsx(St, { children: /* @__PURE__ */ f.jsx(st, { size: 32 }) }) : /* @__PURE__ */ f.jsxs(H, { container: !0, children: [
    /* @__PURE__ */ f.jsx(H, { item: !0, xs: 12, children: /* @__PURE__ */ f.jsx(ul, { children: "My Favorite Studies" }) }),
    /* @__PURE__ */ f.jsxs(cl, { children: [
      r === Z.SUCCESS && (n != null && n.length ? n.slice(0, Math.min(n.length, i ? 10 : 5)).map((a) => {
        var c;
        const s = Ll.find(
          (p) => p.id === a.status
        );
        return /* @__PURE__ */ f.jsxs(
          On,
          {
            onClick: () => t(`/study-manager/${a.id}`),
            children: [
              /* @__PURE__ */ f.jsxs("div", { className: "list-item-section nowrap", children: [
                /* @__PURE__ */ f.jsx("div", { children: /* @__PURE__ */ f.jsx(
                  Xr,
                  {
                    isFavorite: a.favorite,
                    isPrivate: a.privacy,
                    parent: a,
                    viewMode: !0
                  }
                ) }),
                /* @__PURE__ */ f.jsx("div", { className: "list-item-title", title: a.title, children: a.title })
              ] }),
              /* @__PURE__ */ f.jsxs("div", { className: "list-item-section", children: [
                /* @__PURE__ */ f.jsx("div", { className: "light-text", children: a.type.name }),
                /* @__PURE__ */ f.jsx(
                  Or,
                  {
                    tooltipText: s == null ? void 0 : s.name,
                    iconName: (c = s == null ? void 0 : s.id) == null ? void 0 : c.toLowerCase(),
                    iconSize: 24
                  }
                )
              ] })
            ]
          },
          a.id + "favorite"
        );
      }) : /* @__PURE__ */ f.jsx(H, { item: !0, xs: 12, children: /* @__PURE__ */ f.jsxs(
        "div",
        {
          style: {
            backgroundColor: "#f6f8fa",
            borderRadius: "4px",
            padding: "40px 24px",
            textAlign: "center"
          },
          children: [
            /* @__PURE__ */ f.jsx(
              ve,
              {
                variant: "body2",
                sx: (a) => ({
                  color: a.palette.primary.main,
                  fontWeight: 600
                }),
                children: "Your favorite studies will be displayed here."
              }
            ),
            /* @__PURE__ */ f.jsxs(
              ve,
              {
                variant: "body2",
                sx: (a) => ({
                  color: a.palette.primary.main,
                  mt: 1,
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 0.75,
                  flexWrap: "wrap"
                }),
                children: [
                  /* @__PURE__ */ f.jsx("span", { children: "Use" }),
                  /* @__PURE__ */ f.jsx(
                    un,
                    {
                      isFavorite: !1,
                      onClick: () => {
                      },
                      viewMode: !0,
                      size: 16
                    }
                  ),
                  /* @__PURE__ */ f.jsx("span", { children: "button in studies listing or study details page to add/remove a study to/from favorites." })
                ]
              }
            )
          ]
        }
      ) })),
      r === Z.ERROR && /* @__PURE__ */ f.jsx(On, { light: !0, children: /* @__PURE__ */ f.jsx(
        el,
        {
          noDataText: "Failed to load studies",
          addButtonText: "",
          onAdd: () => {
          },
          dark: !0,
          buttonName: ""
        }
      ) })
    ] }),
    (n == null ? void 0 : n.length) > 5 && /* @__PURE__ */ f.jsx(H, { container: !0, justifyContent: "flex-end", mt: 2, children: /* @__PURE__ */ f.jsx(ke, { onClick: o, size: "small", variant: "text", color: "info", children: i ? "Show less" : "Show more..." }) })
  ] });
};
function bo(e, t) {
  const n = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
const ko = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, Eo = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, wo = {};
function Hn(e, t) {
  return (wo.jsx ? Eo : ko).test(e);
}
const Co = /[ \t\n\f\r]/g;
function To(e) {
  return typeof e == "object" ? e.type === "text" ? $n(e.value) : !1 : $n(e);
}
function $n(e) {
  return e.replace(Co, "") === "";
}
class ut {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(t, n, r) {
    this.normal = n, this.property = t, r && (this.space = r);
  }
}
ut.prototype.normal = {};
ut.prototype.property = {};
ut.prototype.space = void 0;
function Kr(e, t) {
  const n = {}, r = {};
  for (const i of e)
    Object.assign(n, i.property), Object.assign(r, i.normal);
  return new ut(n, r, t);
}
function Gt(e) {
  return e.toLowerCase();
}
class pe {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(t, n) {
    this.attribute = n, this.property = t;
  }
}
pe.prototype.attribute = "";
pe.prototype.booleanish = !1;
pe.prototype.boolean = !1;
pe.prototype.commaOrSpaceSeparated = !1;
pe.prototype.commaSeparated = !1;
pe.prototype.defined = !1;
pe.prototype.mustUseProperty = !1;
pe.prototype.number = !1;
pe.prototype.overloadedBoolean = !1;
pe.prototype.property = "";
pe.prototype.spaceSeparated = !1;
pe.prototype.space = void 0;
let Io = 0;
const M = Me(), ie = Me(), Wt = Me(), w = Me(), W = Me(), $e = Me(), fe = Me();
function Me() {
  return 2 ** ++Io;
}
const Qt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: M,
  booleanish: ie,
  commaOrSpaceSeparated: fe,
  commaSeparated: $e,
  number: w,
  overloadedBoolean: Wt,
  spaceSeparated: W
}, Symbol.toStringTag, { value: "Module" })), Lt = (
  /** @type {ReadonlyArray<keyof typeof types>} */
  Object.keys(Qt)
);
class dn extends pe {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(t, n, r, i) {
    let l = -1;
    if (super(t, n), qn(this, "space", i), typeof r == "number")
      for (; ++l < Lt.length; ) {
        const o = Lt[l];
        qn(this, Lt[l], (r & Qt[o]) === Qt[o]);
      }
  }
}
dn.prototype.defined = !0;
function qn(e, t, n) {
  n && (e[t] = n);
}
function Ye(e) {
  const t = {}, n = {};
  for (const [r, i] of Object.entries(e.properties)) {
    const l = new dn(
      r,
      e.transform(e.attributes || {}, r),
      i,
      e.space
    );
    e.mustUseProperty && e.mustUseProperty.includes(r) && (l.mustUseProperty = !0), t[r] = l, n[Gt(r)] = r, n[Gt(l.attribute)] = r;
  }
  return new ut(t, n, e.space);
}
const Zr = Ye({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: ie,
    ariaAutoComplete: null,
    ariaBusy: ie,
    ariaChecked: ie,
    ariaColCount: w,
    ariaColIndex: w,
    ariaColSpan: w,
    ariaControls: W,
    ariaCurrent: null,
    ariaDescribedBy: W,
    ariaDetails: null,
    ariaDisabled: ie,
    ariaDropEffect: W,
    ariaErrorMessage: null,
    ariaExpanded: ie,
    ariaFlowTo: W,
    ariaGrabbed: ie,
    ariaHasPopup: null,
    ariaHidden: ie,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: W,
    ariaLevel: w,
    ariaLive: null,
    ariaModal: ie,
    ariaMultiLine: ie,
    ariaMultiSelectable: ie,
    ariaOrientation: null,
    ariaOwns: W,
    ariaPlaceholder: null,
    ariaPosInSet: w,
    ariaPressed: ie,
    ariaReadOnly: ie,
    ariaRelevant: null,
    ariaRequired: ie,
    ariaRoleDescription: W,
    ariaRowCount: w,
    ariaRowIndex: w,
    ariaRowSpan: w,
    ariaSelected: ie,
    ariaSetSize: w,
    ariaSort: null,
    ariaValueMax: w,
    ariaValueMin: w,
    ariaValueNow: w,
    ariaValueText: null,
    role: null
  },
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  }
});
function ei(e, t) {
  return t in e ? e[t] : t;
}
function ti(e, t) {
  return ei(e, t.toLowerCase());
}
const vo = Ye({
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: $e,
    acceptCharset: W,
    accessKey: W,
    action: null,
    allow: null,
    allowFullScreen: M,
    allowPaymentRequest: M,
    allowUserMedia: M,
    alt: null,
    as: null,
    async: M,
    autoCapitalize: null,
    autoComplete: W,
    autoFocus: M,
    autoPlay: M,
    blocking: W,
    capture: null,
    charSet: null,
    checked: M,
    cite: null,
    className: W,
    cols: w,
    colSpan: null,
    content: null,
    contentEditable: ie,
    controls: M,
    controlsList: W,
    coords: w | $e,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: M,
    defer: M,
    dir: null,
    dirName: null,
    disabled: M,
    download: Wt,
    draggable: ie,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: M,
    formTarget: null,
    headers: W,
    height: w,
    hidden: Wt,
    high: w,
    href: null,
    hrefLang: null,
    htmlFor: W,
    httpEquiv: W,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: M,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: M,
    itemId: null,
    itemProp: W,
    itemRef: W,
    itemScope: M,
    itemType: W,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: M,
    low: w,
    manifest: null,
    max: null,
    maxLength: w,
    media: null,
    method: null,
    min: null,
    minLength: w,
    multiple: M,
    muted: M,
    name: null,
    nonce: null,
    noModule: M,
    noValidate: M,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: M,
    optimum: w,
    pattern: null,
    ping: W,
    placeholder: null,
    playsInline: M,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: M,
    referrerPolicy: null,
    rel: W,
    required: M,
    reversed: M,
    rows: w,
    rowSpan: w,
    sandbox: W,
    scope: null,
    scoped: M,
    seamless: M,
    selected: M,
    shadowRootClonable: M,
    shadowRootDelegatesFocus: M,
    shadowRootMode: null,
    shape: null,
    size: w,
    sizes: null,
    slot: null,
    span: w,
    spellCheck: ie,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: w,
    step: null,
    style: null,
    tabIndex: w,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: M,
    useMap: null,
    value: ie,
    width: w,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: W,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: w,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: w,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: M,
    // Lists. Use CSS to reduce space between items instead
    declare: M,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: w,
    // `<img>` and `<object>`
    leftMargin: w,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: w,
    // `<body>`
    marginWidth: w,
    // `<body>`
    noResize: M,
    // `<frame>`
    noHref: M,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: M,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: M,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: w,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: ie,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: w,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: w,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: M,
    disableRemotePlayback: M,
    prefix: null,
    property: null,
    results: w,
    security: null,
    unselectable: null
  },
  space: "html",
  transform: ti
}), _o = Ye({
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  properties: {
    about: fe,
    accentHeight: w,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: w,
    amplitude: w,
    arabicForm: null,
    ascent: w,
    attributeName: null,
    attributeType: null,
    azimuth: w,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: w,
    by: null,
    calcMode: null,
    capHeight: w,
    className: W,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: w,
    diffuseConstant: w,
    direction: null,
    display: null,
    dur: null,
    divisor: w,
    dominantBaseline: null,
    download: M,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: w,
    enableBackground: null,
    end: null,
    event: null,
    exponent: w,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: w,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: $e,
    g2: $e,
    glyphName: $e,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: w,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: w,
    horizOriginX: w,
    horizOriginY: w,
    id: null,
    ideographic: w,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: w,
    k: w,
    k1: w,
    k2: w,
    k3: w,
    k4: w,
    kernelMatrix: fe,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: w,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: w,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: w,
    overlineThickness: w,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: w,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: W,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: w,
    pointsAtY: w,
    pointsAtZ: w,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: fe,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: fe,
    rev: fe,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: fe,
    requiredFeatures: fe,
    requiredFonts: fe,
    requiredFormats: fe,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: w,
    specularExponent: w,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: w,
    strikethroughThickness: w,
    string: null,
    stroke: null,
    strokeDashArray: fe,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: w,
    strokeOpacity: w,
    strokeWidth: null,
    style: null,
    surfaceScale: w,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: fe,
    tabIndex: w,
    tableValues: null,
    target: null,
    targetX: w,
    targetY: w,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: fe,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: w,
    underlineThickness: w,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: w,
    values: null,
    vAlphabetic: w,
    vMathematical: w,
    vectorEffect: null,
    vHanging: w,
    vIdeographic: w,
    version: null,
    vertAdvY: w,
    vertOriginX: w,
    vertOriginY: w,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: w,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: "svg",
  transform: ei
}), ni = Ye({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  }
}), ri = Ye({
  attributes: { xmlnsxlink: "xmlns:xlink" },
  properties: { xmlnsXLink: null, xmlns: null },
  space: "xmlns",
  transform: ti
}), ii = Ye({
  properties: { xmlBase: null, xmlLang: null, xmlSpace: null },
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  }
}), Ao = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, Ro = /[A-Z]/g, Vn = /-[a-z]/g, jo = /^data[-\w.:]+$/i;
function Po(e, t) {
  const n = Gt(t);
  let r = t, i = pe;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && jo.test(t)) {
    if (t.charAt(4) === "-") {
      const l = t.slice(5).replace(Vn, Oo);
      r = "data" + l.charAt(0).toUpperCase() + l.slice(1);
    } else {
      const l = t.slice(4);
      if (!Vn.test(l)) {
        let o = l.replace(Ro, Lo);
        o.charAt(0) !== "-" && (o = "-" + o), t = "data" + o;
      }
    }
    i = dn;
  }
  return new i(r, t);
}
function Lo(e) {
  return "-" + e.toLowerCase();
}
function Oo(e) {
  return e.charAt(1).toUpperCase();
}
const Do = Kr([Zr, vo, ni, ri, ii], "html"), hn = Kr([Zr, _o, ni, ri, ii], "svg");
function No(e) {
  return e.join(" ").trim();
}
var fn = {}, Yn = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, Fo = /\n/g, Mo = /^\s*/, zo = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, Uo = /^:\s*/, Bo = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, Ho = /^[;\s]*/, $o = /^\s+|\s+$/g, qo = `
`, Gn = "/", Wn = "*", Le = "", Vo = "comment", Yo = "declaration", Go = function(e, t) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (!e) return [];
  t = t || {};
  var n = 1, r = 1;
  function i(y) {
    var b = y.match(Fo);
    b && (n += b.length);
    var C = y.lastIndexOf(qo);
    r = ~C ? y.length - C : r + y.length;
  }
  function l() {
    var y = { line: n, column: r };
    return function(b) {
      return b.position = new o(y), c(), b;
    };
  }
  function o(y) {
    this.start = y, this.end = { line: n, column: r }, this.source = t.source;
  }
  o.prototype.content = e;
  function a(y) {
    var b = new Error(
      t.source + ":" + n + ":" + r + ": " + y
    );
    if (b.reason = y, b.filename = t.source, b.line = n, b.column = r, b.source = e, !t.silent) throw b;
  }
  function s(y) {
    var b = y.exec(e);
    if (b) {
      var C = b[0];
      return i(C), e = e.slice(C.length), b;
    }
  }
  function c() {
    s(Mo);
  }
  function p(y) {
    var b;
    for (y = y || []; b = h(); )
      b !== !1 && y.push(b);
    return y;
  }
  function h() {
    var y = l();
    if (!(Gn != e.charAt(0) || Wn != e.charAt(1))) {
      for (var b = 2; Le != e.charAt(b) && (Wn != e.charAt(b) || Gn != e.charAt(b + 1)); )
        ++b;
      if (b += 2, Le === e.charAt(b - 1))
        return a("End of comment missing");
      var C = e.slice(2, b - 2);
      return r += 2, i(C), e = e.slice(b), r += 2, y({
        type: Vo,
        comment: C
      });
    }
  }
  function m() {
    var y = l(), b = s(zo);
    if (b) {
      if (h(), !s(Uo)) return a("property missing ':'");
      var C = s(Bo), S = y({
        type: Yo,
        property: Qn(b[0].replace(Yn, Le)),
        value: C ? Qn(C[0].replace(Yn, Le)) : Le
      });
      return s(Ho), S;
    }
  }
  function d() {
    var y = [];
    p(y);
    for (var b; b = m(); )
      b !== !1 && (y.push(b), p(y));
    return y;
  }
  return c(), d();
};
function Qn(e) {
  return e ? e.replace($o, Le) : Le;
}
var Wo = bt && bt.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(fn, "__esModule", { value: !0 });
fn.default = Xo;
var Qo = Wo(Go);
function Xo(e, t) {
  var n = null;
  if (!e || typeof e != "string")
    return n;
  var r = (0, Qo.default)(e), i = typeof t == "function";
  return r.forEach(function(l) {
    if (l.type === "declaration") {
      var o = l.property, a = l.value;
      i ? t(o, a, l) : a && (n = n || {}, n[o] = a);
    }
  }), n;
}
var It = {};
Object.defineProperty(It, "__esModule", { value: !0 });
It.camelCase = void 0;
var Jo = /^--[a-zA-Z0-9_-]+$/, Ko = /-([a-z])/g, Zo = /^[^-]+$/, ea = /^-(webkit|moz|ms|o|khtml)-/, ta = /^-(ms)-/, na = function(e) {
  return !e || Zo.test(e) || Jo.test(e);
}, ra = function(e, t) {
  return t.toUpperCase();
}, Xn = function(e, t) {
  return "".concat(t, "-");
}, ia = function(e, t) {
  return t === void 0 && (t = {}), na(e) ? e : (e = e.toLowerCase(), t.reactCompat ? e = e.replace(ta, Xn) : e = e.replace(ea, Xn), e.replace(Ko, ra));
};
It.camelCase = ia;
var la = bt && bt.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
}, oa = la(fn), aa = It;
function Xt(e, t) {
  var n = {};
  return !e || typeof e != "string" || (0, oa.default)(e, function(r, i) {
    r && i && (n[(0, aa.camelCase)(r, t)] = i);
  }), n;
}
Xt.default = Xt;
var sa = Xt;
const ua = /* @__PURE__ */ Br(sa), li = oi("end"), mn = oi("start");
function oi(e) {
  return t;
  function t(n) {
    const r = n && n.position && n.position[e] || {};
    if (typeof r.line == "number" && r.line > 0 && typeof r.column == "number" && r.column > 0)
      return {
        line: r.line,
        column: r.column,
        offset: typeof r.offset == "number" && r.offset > -1 ? r.offset : void 0
      };
  }
}
function ca(e) {
  const t = mn(e), n = li(e);
  if (t && n)
    return { start: t, end: n };
}
function tt(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? Jn(e.position) : "start" in e || "end" in e ? Jn(e) : "line" in e || "column" in e ? Jt(e) : "";
}
function Jt(e) {
  return Kn(e && e.line) + ":" + Kn(e && e.column);
}
function Jn(e) {
  return Jt(e && e.start) + "-" + Jt(e && e.end);
}
function Kn(e) {
  return e && typeof e == "number" ? e : 1;
}
class se extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(t, n, r) {
    super(), typeof n == "string" && (r = n, n = void 0);
    let i = "", l = {}, o = !1;
    if (n && ("line" in n && "column" in n ? l = { place: n } : "start" in n && "end" in n ? l = { place: n } : "type" in n ? l = {
      ancestors: [n],
      place: n.position
    } : l = { ...n }), typeof t == "string" ? i = t : !l.cause && t && (o = !0, i = t.message, l.cause = t), !l.ruleId && !l.source && typeof r == "string") {
      const s = r.indexOf(":");
      s === -1 ? l.ruleId = r : (l.source = r.slice(0, s), l.ruleId = r.slice(s + 1));
    }
    if (!l.place && l.ancestors && l.ancestors) {
      const s = l.ancestors[l.ancestors.length - 1];
      s && (l.place = s.position);
    }
    const a = l.place && "start" in l.place ? l.place.start : l.place;
    this.ancestors = l.ancestors || void 0, this.cause = l.cause || void 0, this.column = a ? a.column : void 0, this.fatal = void 0, this.file, this.message = i, this.line = a ? a.line : void 0, this.name = tt(l.place) || "1:1", this.place = l.place || void 0, this.reason = this.message, this.ruleId = l.ruleId || void 0, this.source = l.source || void 0, this.stack = o && l.cause && typeof l.cause.stack == "string" ? l.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
se.prototype.file = "";
se.prototype.name = "";
se.prototype.reason = "";
se.prototype.message = "";
se.prototype.stack = "";
se.prototype.column = void 0;
se.prototype.line = void 0;
se.prototype.ancestors = void 0;
se.prototype.cause = void 0;
se.prototype.fatal = void 0;
se.prototype.place = void 0;
se.prototype.ruleId = void 0;
se.prototype.source = void 0;
const gn = {}.hasOwnProperty, pa = /* @__PURE__ */ new Map(), da = /[A-Z]/g, ha = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), fa = /* @__PURE__ */ new Set(["td", "th"]), ai = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function ma(e, t) {
  if (!t || t.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const n = t.filePath || void 0;
  let r;
  if (t.development) {
    if (typeof t.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    r = wa(n, t.jsxDEV);
  } else {
    if (typeof t.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof t.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    r = Ea(n, t.jsx, t.jsxs);
  }
  const i = {
    Fragment: t.Fragment,
    ancestors: [],
    components: t.components || {},
    create: r,
    elementAttributeNameCase: t.elementAttributeNameCase || "react",
    evaluater: t.createEvaluater ? t.createEvaluater() : void 0,
    filePath: n,
    ignoreInvalidStyle: t.ignoreInvalidStyle || !1,
    passKeys: t.passKeys !== !1,
    passNode: t.passNode || !1,
    schema: t.space === "svg" ? hn : Do,
    stylePropertyNameCase: t.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: t.tableCellAlignToStyle !== !1
  }, l = si(i, e, void 0);
  return l && typeof l != "string" ? l : i.create(
    e,
    i.Fragment,
    { children: l || void 0 },
    void 0
  );
}
function si(e, t, n) {
  if (t.type === "element")
    return ga(e, t, n);
  if (t.type === "mdxFlowExpression" || t.type === "mdxTextExpression")
    return ya(e, t);
  if (t.type === "mdxJsxFlowElement" || t.type === "mdxJsxTextElement")
    return Sa(e, t, n);
  if (t.type === "mdxjsEsm")
    return xa(e, t);
  if (t.type === "root")
    return ba(e, t, n);
  if (t.type === "text")
    return ka(e, t);
}
function ga(e, t, n) {
  const r = e.schema;
  let i = r;
  t.tagName.toLowerCase() === "svg" && r.space === "html" && (i = hn, e.schema = i), e.ancestors.push(t);
  const l = ci(e, t.tagName, !1), o = Ca(e, t);
  let a = xn(e, t);
  return ha.has(t.tagName) && (a = a.filter(function(s) {
    return typeof s == "string" ? !To(s) : !0;
  })), ui(e, o, l, t), yn(o, a), e.ancestors.pop(), e.schema = r, e.create(t, l, o, n);
}
function ya(e, t) {
  if (t.data && t.data.estree && e.evaluater) {
    const r = t.data.estree.body[0];
    return r.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(r.expression);
  }
  lt(e, t.position);
}
function xa(e, t) {
  if (t.data && t.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(t.data.estree)
    );
  lt(e, t.position);
}
function Sa(e, t, n) {
  const r = e.schema;
  let i = r;
  t.name === "svg" && r.space === "html" && (i = hn, e.schema = i), e.ancestors.push(t);
  const l = t.name === null ? e.Fragment : ci(e, t.name, !0), o = Ta(e, t), a = xn(e, t);
  return ui(e, o, l, t), yn(o, a), e.ancestors.pop(), e.schema = r, e.create(t, l, o, n);
}
function ba(e, t, n) {
  const r = {};
  return yn(r, xn(e, t)), e.create(t, e.Fragment, r, n);
}
function ka(e, t) {
  return t.value;
}
function ui(e, t, n, r) {
  typeof n != "string" && n !== e.Fragment && e.passNode && (t.node = r);
}
function yn(e, t) {
  if (t.length > 0) {
    const n = t.length > 1 ? t : t[0];
    n && (e.children = n);
  }
}
function Ea(e, t, n) {
  return r;
  function r(i, l, o, a) {
    const c = Array.isArray(o.children) ? n : t;
    return a ? c(l, o, a) : c(l, o);
  }
}
function wa(e, t) {
  return n;
  function n(r, i, l, o) {
    const a = Array.isArray(l.children), s = mn(r);
    return t(
      i,
      l,
      o,
      a,
      {
        columnNumber: s ? s.column - 1 : void 0,
        fileName: e,
        lineNumber: s ? s.line : void 0
      },
      void 0
    );
  }
}
function Ca(e, t) {
  const n = {};
  let r, i;
  for (i in t.properties)
    if (i !== "children" && gn.call(t.properties, i)) {
      const l = Ia(e, i, t.properties[i]);
      if (l) {
        const [o, a] = l;
        e.tableCellAlignToStyle && o === "align" && typeof a == "string" && fa.has(t.tagName) ? r = a : n[o] = a;
      }
    }
  if (r) {
    const l = (
      /** @type {Style} */
      n.style || (n.style = {})
    );
    l[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = r;
  }
  return n;
}
function Ta(e, t) {
  const n = {};
  for (const r of t.attributes)
    if (r.type === "mdxJsxExpressionAttribute")
      if (r.data && r.data.estree && e.evaluater) {
        const l = r.data.estree.body[0];
        l.type;
        const o = l.expression;
        o.type;
        const a = o.properties[0];
        a.type, Object.assign(
          n,
          e.evaluater.evaluateExpression(a.argument)
        );
      } else
        lt(e, t.position);
    else {
      const i = r.name;
      let l;
      if (r.value && typeof r.value == "object")
        if (r.value.data && r.value.data.estree && e.evaluater) {
          const a = r.value.data.estree.body[0];
          a.type, l = e.evaluater.evaluateExpression(a.expression);
        } else
          lt(e, t.position);
      else
        l = r.value === null ? !0 : r.value;
      n[i] = /** @type {Props[keyof Props]} */
      l;
    }
  return n;
}
function xn(e, t) {
  const n = [];
  let r = -1;
  const i = e.passKeys ? /* @__PURE__ */ new Map() : pa;
  for (; ++r < t.children.length; ) {
    const l = t.children[r];
    let o;
    if (e.passKeys) {
      const s = l.type === "element" ? l.tagName : l.type === "mdxJsxFlowElement" || l.type === "mdxJsxTextElement" ? l.name : void 0;
      if (s) {
        const c = i.get(s) || 0;
        o = s + "-" + c, i.set(s, c + 1);
      }
    }
    const a = si(e, l, o);
    a !== void 0 && n.push(a);
  }
  return n;
}
function Ia(e, t, n) {
  const r = Po(e.schema, t);
  if (!(n == null || typeof n == "number" && Number.isNaN(n))) {
    if (Array.isArray(n) && (n = r.commaSeparated ? bo(n) : No(n)), r.property === "style") {
      let i = typeof n == "object" ? n : va(e, String(n));
      return e.stylePropertyNameCase === "css" && (i = _a(i)), ["style", i];
    }
    return [
      e.elementAttributeNameCase === "react" && r.space ? Ao[r.property] || r.property : r.attribute,
      n
    ];
  }
}
function va(e, t) {
  try {
    return ua(t, { reactCompat: !0 });
  } catch (n) {
    if (e.ignoreInvalidStyle)
      return {};
    const r = (
      /** @type {Error} */
      n
    ), i = new se("Cannot parse `style` attribute", {
      ancestors: e.ancestors,
      cause: r,
      ruleId: "style",
      source: "hast-util-to-jsx-runtime"
    });
    throw i.file = e.filePath || void 0, i.url = ai + "#cannot-parse-style-attribute", i;
  }
}
function ci(e, t, n) {
  let r;
  if (!n)
    r = { type: "Literal", value: t };
  else if (t.includes(".")) {
    const i = t.split(".");
    let l = -1, o;
    for (; ++l < i.length; ) {
      const a = Hn(i[l]) ? { type: "Identifier", name: i[l] } : { type: "Literal", value: i[l] };
      o = o ? {
        type: "MemberExpression",
        object: o,
        property: a,
        computed: !!(l && a.type === "Literal"),
        optional: !1
      } : a;
    }
    r = o;
  } else
    r = Hn(t) && !/^[a-z]/.test(t) ? { type: "Identifier", name: t } : { type: "Literal", value: t };
  if (r.type === "Literal") {
    const i = (
      /** @type {string | number} */
      r.value
    );
    return gn.call(e.components, i) ? e.components[i] : i;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(r);
  lt(e);
}
function lt(e, t) {
  const n = new se(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: t,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw n.file = e.filePath || void 0, n.url = ai + "#cannot-handle-mdx-estrees-without-createevaluater", n;
}
function _a(e) {
  const t = {};
  let n;
  for (n in e)
    gn.call(e, n) && (t[Aa(n)] = e[n]);
  return t;
}
function Aa(e) {
  let t = e.replace(da, Ra);
  return t.slice(0, 3) === "ms-" && (t = "-" + t), t;
}
function Ra(e) {
  return "-" + e.toLowerCase();
}
const Ot = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, ja = {};
function Pa(e, t) {
  const n = ja, r = typeof n.includeImageAlt == "boolean" ? n.includeImageAlt : !0, i = typeof n.includeHtml == "boolean" ? n.includeHtml : !0;
  return pi(e, r, i);
}
function pi(e, t, n) {
  if (La(e)) {
    if ("value" in e)
      return e.type === "html" && !n ? "" : e.value;
    if (t && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return Zn(e.children, t, n);
  }
  return Array.isArray(e) ? Zn(e, t, n) : "";
}
function Zn(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; )
    r[i] = pi(e[i], t, n);
  return r.join("");
}
function La(e) {
  return !!(e && typeof e == "object");
}
const er = document.createElement("i");
function Sn(e) {
  const t = "&" + e + ";";
  er.innerHTML = t;
  const n = er.textContent;
  return (
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    n.charCodeAt(n.length - 1) === 59 && e !== "semi" || n === t ? !1 : n
  );
}
function Ee(e, t, n, r) {
  const i = e.length;
  let l = 0, o;
  if (t < 0 ? t = -t > i ? 0 : i + t : t = t > i ? i : t, n = n > 0 ? n : 0, r.length < 1e4)
    o = Array.from(r), o.unshift(t, n), e.splice(...o);
  else
    for (n && e.splice(t, n); l < r.length; )
      o = r.slice(l, l + 1e4), o.unshift(t, 0), e.splice(...o), l += 1e4, t += 1e4;
}
function ge(e, t) {
  return e.length > 0 ? (Ee(e, e.length, 0, t), e) : t;
}
const tr = {}.hasOwnProperty;
function Oa(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    Da(t, e[n]);
  return t;
}
function Da(e, t) {
  let n;
  for (n in t) {
    const i = (tr.call(e, n) ? e[n] : void 0) || (e[n] = {}), l = t[n];
    let o;
    if (l)
      for (o in l) {
        tr.call(i, o) || (i[o] = []);
        const a = l[o];
        Na(
          // @ts-expect-error Looks like a list.
          i[o],
          Array.isArray(a) ? a : a ? [a] : []
        );
      }
  }
}
function Na(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; )
    (t[n].add === "after" ? e : r).push(t[n]);
  Ee(e, 0, 0, r);
}
function di(e, t) {
  const n = Number.parseInt(e, t);
  return (
    // C0 except for HT, LF, FF, CR, space.
    n < 9 || n === 11 || n > 13 && n < 32 || // Control character (DEL) of C0, and C1 controls.
    n > 126 && n < 160 || // Lone high surrogates and low surrogates.
    n > 55295 && n < 57344 || // Noncharacters.
    n > 64975 && n < 65008 || /* eslint-disable no-bitwise */
    (n & 65535) === 65535 || (n & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    n > 1114111 ? "�" : String.fromCodePoint(n)
  );
}
function qe(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const be = Re(/[A-Za-z]/), me = Re(/[\dA-Za-z]/), Fa = Re(/[#-'*+\--9=?A-Z^-~]/);
function Kt(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const Zt = Re(/\d/), Ma = Re(/[\dA-Fa-f]/), za = Re(/[!-/:-@[-`{-~]/);
function L(e) {
  return e !== null && e < -2;
}
function ce(e) {
  return e !== null && (e < 0 || e === 32);
}
function V(e) {
  return e === -2 || e === -1 || e === 32;
}
const Ua = Re(new RegExp("\\p{P}|\\p{S}", "u")), Ba = Re(/\s/);
function Re(e) {
  return t;
  function t(n) {
    return n !== null && n > -1 && e.test(String.fromCharCode(n));
  }
}
function Ge(e) {
  const t = [];
  let n = -1, r = 0, i = 0;
  for (; ++n < e.length; ) {
    const l = e.charCodeAt(n);
    let o = "";
    if (l === 37 && me(e.charCodeAt(n + 1)) && me(e.charCodeAt(n + 2)))
      i = 2;
    else if (l < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(l)) || (o = String.fromCharCode(l));
    else if (l > 55295 && l < 57344) {
      const a = e.charCodeAt(n + 1);
      l < 56320 && a > 56319 && a < 57344 ? (o = String.fromCharCode(l, a), i = 1) : o = "�";
    } else
      o = String.fromCharCode(l);
    o && (t.push(e.slice(r, n), encodeURIComponent(o)), r = n + i + 1, o = ""), i && (n += i, i = 0);
  }
  return t.join("") + e.slice(r);
}
function Q(e, t, n, r) {
  const i = r ? r - 1 : Number.POSITIVE_INFINITY;
  let l = 0;
  return o;
  function o(s) {
    return V(s) ? (e.enter(n), a(s)) : t(s);
  }
  function a(s) {
    return V(s) && l++ < i ? (e.consume(s), a) : (e.exit(n), t(s));
  }
}
const Ha = {
  tokenize: $a
};
function $a(e) {
  const t = e.attempt(this.parser.constructs.contentInitial, r, i);
  let n;
  return t;
  function r(a) {
    if (a === null) {
      e.consume(a);
      return;
    }
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), Q(e, t, "linePrefix");
  }
  function i(a) {
    return e.enter("paragraph"), l(a);
  }
  function l(a) {
    const s = e.enter("chunkText", {
      contentType: "text",
      previous: n
    });
    return n && (n.next = s), n = s, o(a);
  }
  function o(a) {
    if (a === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(a);
      return;
    }
    return L(a) ? (e.consume(a), e.exit("chunkText"), l) : (e.consume(a), o);
  }
}
const qa = {
  tokenize: Va
}, nr = {
  tokenize: Ya
};
function Va(e) {
  const t = this, n = [];
  let r = 0, i, l, o;
  return a;
  function a(E) {
    if (r < n.length) {
      const v = n[r];
      return t.containerState = v[1], e.attempt(v[0].continuation, s, c)(E);
    }
    return c(E);
  }
  function s(E) {
    if (r++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, i && T();
      const v = t.events.length;
      let j = v, k;
      for (; j--; )
        if (t.events[j][0] === "exit" && t.events[j][1].type === "chunkFlow") {
          k = t.events[j][1].end;
          break;
        }
      S(r);
      let O = v;
      for (; O < t.events.length; )
        t.events[O][1].end = {
          ...k
        }, O++;
      return Ee(t.events, j + 1, 0, t.events.slice(v)), t.events.length = O, c(E);
    }
    return a(E);
  }
  function c(E) {
    if (r === n.length) {
      if (!i)
        return m(E);
      if (i.currentConstruct && i.currentConstruct.concrete)
        return y(E);
      t.interrupt = !!(i.currentConstruct && !i._gfmTableDynamicInterruptHack);
    }
    return t.containerState = {}, e.check(nr, p, h)(E);
  }
  function p(E) {
    return i && T(), S(r), m(E);
  }
  function h(E) {
    return t.parser.lazy[t.now().line] = r !== n.length, o = t.now().offset, y(E);
  }
  function m(E) {
    return t.containerState = {}, e.attempt(nr, d, y)(E);
  }
  function d(E) {
    return r++, n.push([t.currentConstruct, t.containerState]), m(E);
  }
  function y(E) {
    if (E === null) {
      i && T(), S(0), e.consume(E);
      return;
    }
    return i = i || t.parser.flow(t.now()), e.enter("chunkFlow", {
      _tokenizer: i,
      contentType: "flow",
      previous: l
    }), b(E);
  }
  function b(E) {
    if (E === null) {
      C(e.exit("chunkFlow"), !0), S(0), e.consume(E);
      return;
    }
    return L(E) ? (e.consume(E), C(e.exit("chunkFlow")), r = 0, t.interrupt = void 0, a) : (e.consume(E), b);
  }
  function C(E, v) {
    const j = t.sliceStream(E);
    if (v && j.push(null), E.previous = l, l && (l.next = E), l = E, i.defineSkip(E.start), i.write(j), t.parser.lazy[E.start.line]) {
      let k = i.events.length;
      for (; k--; )
        if (
          // The token starts before the line ending…
          i.events[k][1].start.offset < o && // …and either is not ended yet…
          (!i.events[k][1].end || // …or ends after it.
          i.events[k][1].end.offset > o)
        )
          return;
      const O = t.events.length;
      let $ = O, F, z;
      for (; $--; )
        if (t.events[$][0] === "exit" && t.events[$][1].type === "chunkFlow") {
          if (F) {
            z = t.events[$][1].end;
            break;
          }
          F = !0;
        }
      for (S(r), k = O; k < t.events.length; )
        t.events[k][1].end = {
          ...z
        }, k++;
      Ee(t.events, $ + 1, 0, t.events.slice(O)), t.events.length = k;
    }
  }
  function S(E) {
    let v = n.length;
    for (; v-- > E; ) {
      const j = n[v];
      t.containerState = j[1], j[0].exit.call(t, e);
    }
    n.length = E;
  }
  function T() {
    i.write([null]), l = void 0, i = void 0, t.containerState._closeFlow = void 0;
  }
}
function Ya(e, t, n) {
  return Q(e, e.attempt(this.parser.constructs.document, t, n), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function rr(e) {
  if (e === null || ce(e) || Ba(e))
    return 1;
  if (Ua(e))
    return 2;
}
function bn(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; ) {
    const l = e[i].resolveAll;
    l && !r.includes(l) && (t = l(t, n), r.push(l));
  }
  return t;
}
const en = {
  name: "attention",
  resolveAll: Ga,
  tokenize: Wa
};
function Ga(e, t) {
  let n = -1, r, i, l, o, a, s, c, p;
  for (; ++n < e.length; )
    if (e[n][0] === "enter" && e[n][1].type === "attentionSequence" && e[n][1]._close) {
      for (r = n; r--; )
        if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && // If the markers are the same:
        t.sliceSerialize(e[r][1]).charCodeAt(0) === t.sliceSerialize(e[n][1]).charCodeAt(0)) {
          if ((e[r][1]._close || e[n][1]._open) && (e[n][1].end.offset - e[n][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[n][1].end.offset - e[n][1].start.offset) % 3))
            continue;
          s = e[r][1].end.offset - e[r][1].start.offset > 1 && e[n][1].end.offset - e[n][1].start.offset > 1 ? 2 : 1;
          const h = {
            ...e[r][1].end
          }, m = {
            ...e[n][1].start
          };
          ir(h, -s), ir(m, s), o = {
            type: s > 1 ? "strongSequence" : "emphasisSequence",
            start: h,
            end: {
              ...e[r][1].end
            }
          }, a = {
            type: s > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[n][1].start
            },
            end: m
          }, l = {
            type: s > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[r][1].end
            },
            end: {
              ...e[n][1].start
            }
          }, i = {
            type: s > 1 ? "strong" : "emphasis",
            start: {
              ...o.start
            },
            end: {
              ...a.end
            }
          }, e[r][1].end = {
            ...o.start
          }, e[n][1].start = {
            ...a.end
          }, c = [], e[r][1].end.offset - e[r][1].start.offset && (c = ge(c, [["enter", e[r][1], t], ["exit", e[r][1], t]])), c = ge(c, [["enter", i, t], ["enter", o, t], ["exit", o, t], ["enter", l, t]]), c = ge(c, bn(t.parser.constructs.insideSpan.null, e.slice(r + 1, n), t)), c = ge(c, [["exit", l, t], ["enter", a, t], ["exit", a, t], ["exit", i, t]]), e[n][1].end.offset - e[n][1].start.offset ? (p = 2, c = ge(c, [["enter", e[n][1], t], ["exit", e[n][1], t]])) : p = 0, Ee(e, r - 1, n - r + 3, c), n = r + c.length - p - 2;
          break;
        }
    }
  for (n = -1; ++n < e.length; )
    e[n][1].type === "attentionSequence" && (e[n][1].type = "data");
  return e;
}
function Wa(e, t) {
  const n = this.parser.constructs.attentionMarkers.null, r = this.previous, i = rr(r);
  let l;
  return o;
  function o(s) {
    return l = s, e.enter("attentionSequence"), a(s);
  }
  function a(s) {
    if (s === l)
      return e.consume(s), a;
    const c = e.exit("attentionSequence"), p = rr(s), h = !p || p === 2 && i || n.includes(s), m = !i || i === 2 && p || n.includes(r);
    return c._open = !!(l === 42 ? h : h && (i || !m)), c._close = !!(l === 42 ? m : m && (p || !h)), t(s);
  }
}
function ir(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
const Qa = {
  name: "autolink",
  tokenize: Xa
};
function Xa(e, t, n) {
  let r = 0;
  return i;
  function i(d) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(d), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), l;
  }
  function l(d) {
    return be(d) ? (e.consume(d), o) : d === 64 ? n(d) : c(d);
  }
  function o(d) {
    return d === 43 || d === 45 || d === 46 || me(d) ? (r = 1, a(d)) : c(d);
  }
  function a(d) {
    return d === 58 ? (e.consume(d), r = 0, s) : (d === 43 || d === 45 || d === 46 || me(d)) && r++ < 32 ? (e.consume(d), a) : (r = 0, c(d));
  }
  function s(d) {
    return d === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(d), e.exit("autolinkMarker"), e.exit("autolink"), t) : d === null || d === 32 || d === 60 || Kt(d) ? n(d) : (e.consume(d), s);
  }
  function c(d) {
    return d === 64 ? (e.consume(d), p) : Fa(d) ? (e.consume(d), c) : n(d);
  }
  function p(d) {
    return me(d) ? h(d) : n(d);
  }
  function h(d) {
    return d === 46 ? (e.consume(d), r = 0, p) : d === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(d), e.exit("autolinkMarker"), e.exit("autolink"), t) : m(d);
  }
  function m(d) {
    if ((d === 45 || me(d)) && r++ < 63) {
      const y = d === 45 ? m : h;
      return e.consume(d), y;
    }
    return n(d);
  }
}
const vt = {
  partial: !0,
  tokenize: Ja
};
function Ja(e, t, n) {
  return r;
  function r(l) {
    return V(l) ? Q(e, i, "linePrefix")(l) : i(l);
  }
  function i(l) {
    return l === null || L(l) ? t(l) : n(l);
  }
}
const hi = {
  continuation: {
    tokenize: Za
  },
  exit: es,
  name: "blockQuote",
  tokenize: Ka
};
function Ka(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    if (o === 62) {
      const a = r.containerState;
      return a.open || (e.enter("blockQuote", {
        _container: !0
      }), a.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(o), e.exit("blockQuoteMarker"), l;
    }
    return n(o);
  }
  function l(o) {
    return V(o) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(o), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(o));
  }
}
function Za(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return V(o) ? Q(e, l, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(o) : l(o);
  }
  function l(o) {
    return e.attempt(hi, t, n)(o);
  }
}
function es(e) {
  e.exit("blockQuote");
}
const fi = {
  name: "characterEscape",
  tokenize: ts
};
function ts(e, t, n) {
  return r;
  function r(l) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(l), e.exit("escapeMarker"), i;
  }
  function i(l) {
    return za(l) ? (e.enter("characterEscapeValue"), e.consume(l), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : n(l);
  }
}
const mi = {
  name: "characterReference",
  tokenize: ns
};
function ns(e, t, n) {
  const r = this;
  let i = 0, l, o;
  return a;
  function a(h) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(h), e.exit("characterReferenceMarker"), s;
  }
  function s(h) {
    return h === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(h), e.exit("characterReferenceMarkerNumeric"), c) : (e.enter("characterReferenceValue"), l = 31, o = me, p(h));
  }
  function c(h) {
    return h === 88 || h === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(h), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), l = 6, o = Ma, p) : (e.enter("characterReferenceValue"), l = 7, o = Zt, p(h));
  }
  function p(h) {
    if (h === 59 && i) {
      const m = e.exit("characterReferenceValue");
      return o === me && !Sn(r.sliceSerialize(m)) ? n(h) : (e.enter("characterReferenceMarker"), e.consume(h), e.exit("characterReferenceMarker"), e.exit("characterReference"), t);
    }
    return o(h) && i++ < l ? (e.consume(h), p) : n(h);
  }
}
const lr = {
  partial: !0,
  tokenize: is
}, or = {
  concrete: !0,
  name: "codeFenced",
  tokenize: rs
};
function rs(e, t, n) {
  const r = this, i = {
    partial: !0,
    tokenize: j
  };
  let l = 0, o = 0, a;
  return s;
  function s(k) {
    return c(k);
  }
  function c(k) {
    const O = r.events[r.events.length - 1];
    return l = O && O[1].type === "linePrefix" ? O[2].sliceSerialize(O[1], !0).length : 0, a = k, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), p(k);
  }
  function p(k) {
    return k === a ? (o++, e.consume(k), p) : o < 3 ? n(k) : (e.exit("codeFencedFenceSequence"), V(k) ? Q(e, h, "whitespace")(k) : h(k));
  }
  function h(k) {
    return k === null || L(k) ? (e.exit("codeFencedFence"), r.interrupt ? t(k) : e.check(lr, b, v)(k)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), m(k));
  }
  function m(k) {
    return k === null || L(k) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), h(k)) : V(k) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), Q(e, d, "whitespace")(k)) : k === 96 && k === a ? n(k) : (e.consume(k), m);
  }
  function d(k) {
    return k === null || L(k) ? h(k) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), y(k));
  }
  function y(k) {
    return k === null || L(k) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), h(k)) : k === 96 && k === a ? n(k) : (e.consume(k), y);
  }
  function b(k) {
    return e.attempt(i, v, C)(k);
  }
  function C(k) {
    return e.enter("lineEnding"), e.consume(k), e.exit("lineEnding"), S;
  }
  function S(k) {
    return l > 0 && V(k) ? Q(e, T, "linePrefix", l + 1)(k) : T(k);
  }
  function T(k) {
    return k === null || L(k) ? e.check(lr, b, v)(k) : (e.enter("codeFlowValue"), E(k));
  }
  function E(k) {
    return k === null || L(k) ? (e.exit("codeFlowValue"), T(k)) : (e.consume(k), E);
  }
  function v(k) {
    return e.exit("codeFenced"), t(k);
  }
  function j(k, O, $) {
    let F = 0;
    return z;
    function z(D) {
      return k.enter("lineEnding"), k.consume(D), k.exit("lineEnding"), A;
    }
    function A(D) {
      return k.enter("codeFencedFence"), V(D) ? Q(k, _, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(D) : _(D);
    }
    function _(D) {
      return D === a ? (k.enter("codeFencedFenceSequence"), q(D)) : $(D);
    }
    function q(D) {
      return D === a ? (F++, k.consume(D), q) : F >= o ? (k.exit("codeFencedFenceSequence"), V(D) ? Q(k, Y, "whitespace")(D) : Y(D)) : $(D);
    }
    function Y(D) {
      return D === null || L(D) ? (k.exit("codeFencedFence"), O(D)) : $(D);
    }
  }
}
function is(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return o === null ? n(o) : (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), l);
  }
  function l(o) {
    return r.parser.lazy[r.now().line] ? n(o) : t(o);
  }
}
const Dt = {
  name: "codeIndented",
  tokenize: os
}, ls = {
  partial: !0,
  tokenize: as
};
function os(e, t, n) {
  const r = this;
  return i;
  function i(c) {
    return e.enter("codeIndented"), Q(e, l, "linePrefix", 5)(c);
  }
  function l(c) {
    const p = r.events[r.events.length - 1];
    return p && p[1].type === "linePrefix" && p[2].sliceSerialize(p[1], !0).length >= 4 ? o(c) : n(c);
  }
  function o(c) {
    return c === null ? s(c) : L(c) ? e.attempt(ls, o, s)(c) : (e.enter("codeFlowValue"), a(c));
  }
  function a(c) {
    return c === null || L(c) ? (e.exit("codeFlowValue"), o(c)) : (e.consume(c), a);
  }
  function s(c) {
    return e.exit("codeIndented"), t(c);
  }
}
function as(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return r.parser.lazy[r.now().line] ? n(o) : L(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), i) : Q(e, l, "linePrefix", 5)(o);
  }
  function l(o) {
    const a = r.events[r.events.length - 1];
    return a && a[1].type === "linePrefix" && a[2].sliceSerialize(a[1], !0).length >= 4 ? t(o) : L(o) ? i(o) : n(o);
  }
}
const ss = {
  name: "codeText",
  previous: cs,
  resolve: us,
  tokenize: ps
};
function us(e) {
  let t = e.length - 4, n = 3, r, i;
  if ((e[n][1].type === "lineEnding" || e[n][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (r = n; ++r < t; )
      if (e[r][1].type === "codeTextData") {
        e[n][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", n += 2, t -= 2;
        break;
      }
  }
  for (r = n - 1, t++; ++r <= t; )
    i === void 0 ? r !== t && e[r][1].type !== "lineEnding" && (i = r) : (r === t || e[r][1].type === "lineEnding") && (e[i][1].type = "codeTextData", r !== i + 2 && (e[i][1].end = e[r - 1][1].end, e.splice(i + 2, r - i - 2), t -= r - i - 2, r = i + 2), i = void 0);
  return e;
}
function cs(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function ps(e, t, n) {
  let r = 0, i, l;
  return o;
  function o(h) {
    return e.enter("codeText"), e.enter("codeTextSequence"), a(h);
  }
  function a(h) {
    return h === 96 ? (e.consume(h), r++, a) : (e.exit("codeTextSequence"), s(h));
  }
  function s(h) {
    return h === null ? n(h) : h === 32 ? (e.enter("space"), e.consume(h), e.exit("space"), s) : h === 96 ? (l = e.enter("codeTextSequence"), i = 0, p(h)) : L(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), s) : (e.enter("codeTextData"), c(h));
  }
  function c(h) {
    return h === null || h === 32 || h === 96 || L(h) ? (e.exit("codeTextData"), s(h)) : (e.consume(h), c);
  }
  function p(h) {
    return h === 96 ? (e.consume(h), i++, p) : i === r ? (e.exit("codeTextSequence"), e.exit("codeText"), t(h)) : (l.type = "codeTextData", c(h));
  }
}
class ds {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(t) {
    this.left = t ? [...t] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(t) {
    if (t < 0 || t >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + t + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return t < this.left.length ? this.left[t] : this.right[this.right.length - t + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(t, n) {
    const r = n ?? Number.POSITIVE_INFINITY;
    return r < this.left.length ? this.left.slice(t, r) : t > this.left.length ? this.right.slice(this.right.length - r + this.left.length, this.right.length - t + this.left.length).reverse() : this.left.slice(t).concat(this.right.slice(this.right.length - r + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(t, n, r) {
    const i = n || 0;
    this.setCursor(Math.trunc(t));
    const l = this.right.splice(this.right.length - i, Number.POSITIVE_INFINITY);
    return r && Ke(this.left, r), l.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(t) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(t);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(t) {
    this.setCursor(Number.POSITIVE_INFINITY), Ke(this.left, t);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(t) {
    this.setCursor(0), this.right.push(t);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(t) {
    this.setCursor(0), Ke(this.right, t.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(t) {
    if (!(t === this.left.length || t > this.left.length && this.right.length === 0 || t < 0 && this.left.length === 0))
      if (t < this.left.length) {
        const n = this.left.splice(t, Number.POSITIVE_INFINITY);
        Ke(this.right, n.reverse());
      } else {
        const n = this.right.splice(this.left.length + this.right.length - t, Number.POSITIVE_INFINITY);
        Ke(this.left, n.reverse());
      }
  }
}
function Ke(e, t) {
  let n = 0;
  if (t.length < 1e4)
    e.push(...t);
  else
    for (; n < t.length; )
      e.push(...t.slice(n, n + 1e4)), n += 1e4;
}
function gi(e) {
  const t = {};
  let n = -1, r, i, l, o, a, s, c;
  const p = new ds(e);
  for (; ++n < p.length; ) {
    for (; n in t; )
      n = t[n];
    if (r = p.get(n), n && r[1].type === "chunkFlow" && p.get(n - 1)[1].type === "listItemPrefix" && (s = r[1]._tokenizer.events, l = 0, l < s.length && s[l][1].type === "lineEndingBlank" && (l += 2), l < s.length && s[l][1].type === "content"))
      for (; ++l < s.length && s[l][1].type !== "content"; )
        s[l][1].type === "chunkText" && (s[l][1]._isInFirstContentOfListItem = !0, l++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(t, hs(p, n)), n = t[n], c = !0);
    else if (r[1]._container) {
      for (l = n, i = void 0; l--; )
        if (o = p.get(l), o[1].type === "lineEnding" || o[1].type === "lineEndingBlank")
          o[0] === "enter" && (i && (p.get(i)[1].type = "lineEndingBlank"), o[1].type = "lineEnding", i = l);
        else if (!(o[1].type === "linePrefix" || o[1].type === "listItemIndent")) break;
      i && (r[1].end = {
        ...p.get(i)[1].start
      }, a = p.slice(i, n), a.unshift(r), p.splice(i, n - i + 1, a));
    }
  }
  return Ee(e, 0, Number.POSITIVE_INFINITY, p.slice(0)), !c;
}
function hs(e, t) {
  const n = e.get(t)[1], r = e.get(t)[2];
  let i = t - 1;
  const l = [];
  let o = n._tokenizer;
  o || (o = r.parser[n.contentType](n.start), n._contentTypeTextTrailing && (o._contentTypeTextTrailing = !0));
  const a = o.events, s = [], c = {};
  let p, h, m = -1, d = n, y = 0, b = 0;
  const C = [b];
  for (; d; ) {
    for (; e.get(++i)[1] !== d; )
      ;
    l.push(i), d._tokenizer || (p = r.sliceStream(d), d.next || p.push(null), h && o.defineSkip(d.start), d._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = !0), o.write(p), d._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = void 0)), h = d, d = d.next;
  }
  for (d = n; ++m < a.length; )
    // Find a void token that includes a break.
    a[m][0] === "exit" && a[m - 1][0] === "enter" && a[m][1].type === a[m - 1][1].type && a[m][1].start.line !== a[m][1].end.line && (b = m + 1, C.push(b), d._tokenizer = void 0, d.previous = void 0, d = d.next);
  for (o.events = [], d ? (d._tokenizer = void 0, d.previous = void 0) : C.pop(), m = C.length; m--; ) {
    const S = a.slice(C[m], C[m + 1]), T = l.pop();
    s.push([T, T + S.length - 1]), e.splice(T, 2, S);
  }
  for (s.reverse(), m = -1; ++m < s.length; )
    c[y + s[m][0]] = y + s[m][1], y += s[m][1] - s[m][0] - 1;
  return c;
}
const fs = {
  resolve: gs,
  tokenize: ys
}, ms = {
  partial: !0,
  tokenize: xs
};
function gs(e) {
  return gi(e), e;
}
function ys(e, t) {
  let n;
  return r;
  function r(a) {
    return e.enter("content"), n = e.enter("chunkContent", {
      contentType: "content"
    }), i(a);
  }
  function i(a) {
    return a === null ? l(a) : L(a) ? e.check(ms, o, l)(a) : (e.consume(a), i);
  }
  function l(a) {
    return e.exit("chunkContent"), e.exit("content"), t(a);
  }
  function o(a) {
    return e.consume(a), e.exit("chunkContent"), n.next = e.enter("chunkContent", {
      contentType: "content",
      previous: n
    }), n = n.next, i;
  }
}
function xs(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), Q(e, l, "linePrefix");
  }
  function l(o) {
    if (o === null || L(o))
      return n(o);
    const a = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && a && a[1].type === "linePrefix" && a[2].sliceSerialize(a[1], !0).length >= 4 ? t(o) : e.interrupt(r.parser.constructs.flow, n, t)(o);
  }
}
function yi(e, t, n, r, i, l, o, a, s) {
  const c = s || Number.POSITIVE_INFINITY;
  let p = 0;
  return h;
  function h(S) {
    return S === 60 ? (e.enter(r), e.enter(i), e.enter(l), e.consume(S), e.exit(l), m) : S === null || S === 32 || S === 41 || Kt(S) ? n(S) : (e.enter(r), e.enter(o), e.enter(a), e.enter("chunkString", {
      contentType: "string"
    }), b(S));
  }
  function m(S) {
    return S === 62 ? (e.enter(l), e.consume(S), e.exit(l), e.exit(i), e.exit(r), t) : (e.enter(a), e.enter("chunkString", {
      contentType: "string"
    }), d(S));
  }
  function d(S) {
    return S === 62 ? (e.exit("chunkString"), e.exit(a), m(S)) : S === null || S === 60 || L(S) ? n(S) : (e.consume(S), S === 92 ? y : d);
  }
  function y(S) {
    return S === 60 || S === 62 || S === 92 ? (e.consume(S), d) : d(S);
  }
  function b(S) {
    return !p && (S === null || S === 41 || ce(S)) ? (e.exit("chunkString"), e.exit(a), e.exit(o), e.exit(r), t(S)) : p < c && S === 40 ? (e.consume(S), p++, b) : S === 41 ? (e.consume(S), p--, b) : S === null || S === 32 || S === 40 || Kt(S) ? n(S) : (e.consume(S), S === 92 ? C : b);
  }
  function C(S) {
    return S === 40 || S === 41 || S === 92 ? (e.consume(S), b) : b(S);
  }
}
function xi(e, t, n, r, i, l) {
  const o = this;
  let a = 0, s;
  return c;
  function c(d) {
    return e.enter(r), e.enter(i), e.consume(d), e.exit(i), e.enter(l), p;
  }
  function p(d) {
    return a > 999 || d === null || d === 91 || d === 93 && !s || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    d === 94 && !a && "_hiddenFootnoteSupport" in o.parser.constructs ? n(d) : d === 93 ? (e.exit(l), e.enter(i), e.consume(d), e.exit(i), e.exit(r), t) : L(d) ? (e.enter("lineEnding"), e.consume(d), e.exit("lineEnding"), p) : (e.enter("chunkString", {
      contentType: "string"
    }), h(d));
  }
  function h(d) {
    return d === null || d === 91 || d === 93 || L(d) || a++ > 999 ? (e.exit("chunkString"), p(d)) : (e.consume(d), s || (s = !V(d)), d === 92 ? m : h);
  }
  function m(d) {
    return d === 91 || d === 92 || d === 93 ? (e.consume(d), a++, h) : h(d);
  }
}
function Si(e, t, n, r, i, l) {
  let o;
  return a;
  function a(m) {
    return m === 34 || m === 39 || m === 40 ? (e.enter(r), e.enter(i), e.consume(m), e.exit(i), o = m === 40 ? 41 : m, s) : n(m);
  }
  function s(m) {
    return m === o ? (e.enter(i), e.consume(m), e.exit(i), e.exit(r), t) : (e.enter(l), c(m));
  }
  function c(m) {
    return m === o ? (e.exit(l), s(o)) : m === null ? n(m) : L(m) ? (e.enter("lineEnding"), e.consume(m), e.exit("lineEnding"), Q(e, c, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), p(m));
  }
  function p(m) {
    return m === o || m === null || L(m) ? (e.exit("chunkString"), c(m)) : (e.consume(m), m === 92 ? h : p);
  }
  function h(m) {
    return m === o || m === 92 ? (e.consume(m), p) : p(m);
  }
}
function nt(e, t) {
  let n;
  return r;
  function r(i) {
    return L(i) ? (e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), n = !0, r) : V(i) ? Q(e, r, n ? "linePrefix" : "lineSuffix")(i) : t(i);
  }
}
const Ss = {
  name: "definition",
  tokenize: ks
}, bs = {
  partial: !0,
  tokenize: Es
};
function ks(e, t, n) {
  const r = this;
  let i;
  return l;
  function l(d) {
    return e.enter("definition"), o(d);
  }
  function o(d) {
    return xi.call(
      r,
      e,
      a,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(d);
  }
  function a(d) {
    return i = qe(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)), d === 58 ? (e.enter("definitionMarker"), e.consume(d), e.exit("definitionMarker"), s) : n(d);
  }
  function s(d) {
    return ce(d) ? nt(e, c)(d) : c(d);
  }
  function c(d) {
    return yi(
      e,
      p,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(d);
  }
  function p(d) {
    return e.attempt(bs, h, h)(d);
  }
  function h(d) {
    return V(d) ? Q(e, m, "whitespace")(d) : m(d);
  }
  function m(d) {
    return d === null || L(d) ? (e.exit("definition"), r.parser.defined.push(i), t(d)) : n(d);
  }
}
function Es(e, t, n) {
  return r;
  function r(a) {
    return ce(a) ? nt(e, i)(a) : n(a);
  }
  function i(a) {
    return Si(e, l, n, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(a);
  }
  function l(a) {
    return V(a) ? Q(e, o, "whitespace")(a) : o(a);
  }
  function o(a) {
    return a === null || L(a) ? t(a) : n(a);
  }
}
const ws = {
  name: "hardBreakEscape",
  tokenize: Cs
};
function Cs(e, t, n) {
  return r;
  function r(l) {
    return e.enter("hardBreakEscape"), e.consume(l), i;
  }
  function i(l) {
    return L(l) ? (e.exit("hardBreakEscape"), t(l)) : n(l);
  }
}
const Ts = {
  name: "headingAtx",
  resolve: Is,
  tokenize: vs
};
function Is(e, t) {
  let n = e.length - 2, r = 3, i, l;
  return e[r][1].type === "whitespace" && (r += 2), n - 2 > r && e[n][1].type === "whitespace" && (n -= 2), e[n][1].type === "atxHeadingSequence" && (r === n - 1 || n - 4 > r && e[n - 2][1].type === "whitespace") && (n -= r + 1 === n ? 2 : 4), n > r && (i = {
    type: "atxHeadingText",
    start: e[r][1].start,
    end: e[n][1].end
  }, l = {
    type: "chunkText",
    start: e[r][1].start,
    end: e[n][1].end,
    contentType: "text"
  }, Ee(e, r, n - r + 1, [["enter", i, t], ["enter", l, t], ["exit", l, t], ["exit", i, t]])), e;
}
function vs(e, t, n) {
  let r = 0;
  return i;
  function i(p) {
    return e.enter("atxHeading"), l(p);
  }
  function l(p) {
    return e.enter("atxHeadingSequence"), o(p);
  }
  function o(p) {
    return p === 35 && r++ < 6 ? (e.consume(p), o) : p === null || ce(p) ? (e.exit("atxHeadingSequence"), a(p)) : n(p);
  }
  function a(p) {
    return p === 35 ? (e.enter("atxHeadingSequence"), s(p)) : p === null || L(p) ? (e.exit("atxHeading"), t(p)) : V(p) ? Q(e, a, "whitespace")(p) : (e.enter("atxHeadingText"), c(p));
  }
  function s(p) {
    return p === 35 ? (e.consume(p), s) : (e.exit("atxHeadingSequence"), a(p));
  }
  function c(p) {
    return p === null || p === 35 || ce(p) ? (e.exit("atxHeadingText"), a(p)) : (e.consume(p), c);
  }
}
const _s = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], ar = ["pre", "script", "style", "textarea"], As = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: Ps,
  tokenize: Ls
}, Rs = {
  partial: !0,
  tokenize: Ds
}, js = {
  partial: !0,
  tokenize: Os
};
function Ps(e) {
  let t = e.length;
  for (; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"); )
    ;
  return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function Ls(e, t, n) {
  const r = this;
  let i, l, o, a, s;
  return c;
  function c(g) {
    return p(g);
  }
  function p(g) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(g), h;
  }
  function h(g) {
    return g === 33 ? (e.consume(g), m) : g === 47 ? (e.consume(g), l = !0, b) : g === 63 ? (e.consume(g), i = 3, r.interrupt ? t : u) : be(g) ? (e.consume(g), o = String.fromCharCode(g), C) : n(g);
  }
  function m(g) {
    return g === 45 ? (e.consume(g), i = 2, d) : g === 91 ? (e.consume(g), i = 5, a = 0, y) : be(g) ? (e.consume(g), i = 4, r.interrupt ? t : u) : n(g);
  }
  function d(g) {
    return g === 45 ? (e.consume(g), r.interrupt ? t : u) : n(g);
  }
  function y(g) {
    const re = "CDATA[";
    return g === re.charCodeAt(a++) ? (e.consume(g), a === re.length ? r.interrupt ? t : _ : y) : n(g);
  }
  function b(g) {
    return be(g) ? (e.consume(g), o = String.fromCharCode(g), C) : n(g);
  }
  function C(g) {
    if (g === null || g === 47 || g === 62 || ce(g)) {
      const re = g === 47, le = o.toLowerCase();
      return !re && !l && ar.includes(le) ? (i = 1, r.interrupt ? t(g) : _(g)) : _s.includes(o.toLowerCase()) ? (i = 6, re ? (e.consume(g), S) : r.interrupt ? t(g) : _(g)) : (i = 7, r.interrupt && !r.parser.lazy[r.now().line] ? n(g) : l ? T(g) : E(g));
    }
    return g === 45 || me(g) ? (e.consume(g), o += String.fromCharCode(g), C) : n(g);
  }
  function S(g) {
    return g === 62 ? (e.consume(g), r.interrupt ? t : _) : n(g);
  }
  function T(g) {
    return V(g) ? (e.consume(g), T) : z(g);
  }
  function E(g) {
    return g === 47 ? (e.consume(g), z) : g === 58 || g === 95 || be(g) ? (e.consume(g), v) : V(g) ? (e.consume(g), E) : z(g);
  }
  function v(g) {
    return g === 45 || g === 46 || g === 58 || g === 95 || me(g) ? (e.consume(g), v) : j(g);
  }
  function j(g) {
    return g === 61 ? (e.consume(g), k) : V(g) ? (e.consume(g), j) : E(g);
  }
  function k(g) {
    return g === null || g === 60 || g === 61 || g === 62 || g === 96 ? n(g) : g === 34 || g === 39 ? (e.consume(g), s = g, O) : V(g) ? (e.consume(g), k) : $(g);
  }
  function O(g) {
    return g === s ? (e.consume(g), s = null, F) : g === null || L(g) ? n(g) : (e.consume(g), O);
  }
  function $(g) {
    return g === null || g === 34 || g === 39 || g === 47 || g === 60 || g === 61 || g === 62 || g === 96 || ce(g) ? j(g) : (e.consume(g), $);
  }
  function F(g) {
    return g === 47 || g === 62 || V(g) ? E(g) : n(g);
  }
  function z(g) {
    return g === 62 ? (e.consume(g), A) : n(g);
  }
  function A(g) {
    return g === null || L(g) ? _(g) : V(g) ? (e.consume(g), A) : n(g);
  }
  function _(g) {
    return g === 45 && i === 2 ? (e.consume(g), te) : g === 60 && i === 1 ? (e.consume(g), ee) : g === 62 && i === 4 ? (e.consume(g), R) : g === 63 && i === 3 ? (e.consume(g), u) : g === 93 && i === 5 ? (e.consume(g), P) : L(g) && (i === 6 || i === 7) ? (e.exit("htmlFlowData"), e.check(Rs, U, q)(g)) : g === null || L(g) ? (e.exit("htmlFlowData"), q(g)) : (e.consume(g), _);
  }
  function q(g) {
    return e.check(js, Y, U)(g);
  }
  function Y(g) {
    return e.enter("lineEnding"), e.consume(g), e.exit("lineEnding"), D;
  }
  function D(g) {
    return g === null || L(g) ? q(g) : (e.enter("htmlFlowData"), _(g));
  }
  function te(g) {
    return g === 45 ? (e.consume(g), u) : _(g);
  }
  function ee(g) {
    return g === 47 ? (e.consume(g), o = "", oe) : _(g);
  }
  function oe(g) {
    if (g === 62) {
      const re = o.toLowerCase();
      return ar.includes(re) ? (e.consume(g), R) : _(g);
    }
    return be(g) && o.length < 8 ? (e.consume(g), o += String.fromCharCode(g), oe) : _(g);
  }
  function P(g) {
    return g === 93 ? (e.consume(g), u) : _(g);
  }
  function u(g) {
    return g === 62 ? (e.consume(g), R) : g === 45 && i === 2 ? (e.consume(g), u) : _(g);
  }
  function R(g) {
    return g === null || L(g) ? (e.exit("htmlFlowData"), U(g)) : (e.consume(g), R);
  }
  function U(g) {
    return e.exit("htmlFlow"), t(g);
  }
}
function Os(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return L(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), l) : n(o);
  }
  function l(o) {
    return r.parser.lazy[r.now().line] ? n(o) : t(o);
  }
}
function Ds(e, t, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), e.attempt(vt, t, n);
  }
}
const Ns = {
  name: "htmlText",
  tokenize: Fs
};
function Fs(e, t, n) {
  const r = this;
  let i, l, o;
  return a;
  function a(u) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(u), s;
  }
  function s(u) {
    return u === 33 ? (e.consume(u), c) : u === 47 ? (e.consume(u), j) : u === 63 ? (e.consume(u), E) : be(u) ? (e.consume(u), $) : n(u);
  }
  function c(u) {
    return u === 45 ? (e.consume(u), p) : u === 91 ? (e.consume(u), l = 0, y) : be(u) ? (e.consume(u), T) : n(u);
  }
  function p(u) {
    return u === 45 ? (e.consume(u), d) : n(u);
  }
  function h(u) {
    return u === null ? n(u) : u === 45 ? (e.consume(u), m) : L(u) ? (o = h, ee(u)) : (e.consume(u), h);
  }
  function m(u) {
    return u === 45 ? (e.consume(u), d) : h(u);
  }
  function d(u) {
    return u === 62 ? te(u) : u === 45 ? m(u) : h(u);
  }
  function y(u) {
    const R = "CDATA[";
    return u === R.charCodeAt(l++) ? (e.consume(u), l === R.length ? b : y) : n(u);
  }
  function b(u) {
    return u === null ? n(u) : u === 93 ? (e.consume(u), C) : L(u) ? (o = b, ee(u)) : (e.consume(u), b);
  }
  function C(u) {
    return u === 93 ? (e.consume(u), S) : b(u);
  }
  function S(u) {
    return u === 62 ? te(u) : u === 93 ? (e.consume(u), S) : b(u);
  }
  function T(u) {
    return u === null || u === 62 ? te(u) : L(u) ? (o = T, ee(u)) : (e.consume(u), T);
  }
  function E(u) {
    return u === null ? n(u) : u === 63 ? (e.consume(u), v) : L(u) ? (o = E, ee(u)) : (e.consume(u), E);
  }
  function v(u) {
    return u === 62 ? te(u) : E(u);
  }
  function j(u) {
    return be(u) ? (e.consume(u), k) : n(u);
  }
  function k(u) {
    return u === 45 || me(u) ? (e.consume(u), k) : O(u);
  }
  function O(u) {
    return L(u) ? (o = O, ee(u)) : V(u) ? (e.consume(u), O) : te(u);
  }
  function $(u) {
    return u === 45 || me(u) ? (e.consume(u), $) : u === 47 || u === 62 || ce(u) ? F(u) : n(u);
  }
  function F(u) {
    return u === 47 ? (e.consume(u), te) : u === 58 || u === 95 || be(u) ? (e.consume(u), z) : L(u) ? (o = F, ee(u)) : V(u) ? (e.consume(u), F) : te(u);
  }
  function z(u) {
    return u === 45 || u === 46 || u === 58 || u === 95 || me(u) ? (e.consume(u), z) : A(u);
  }
  function A(u) {
    return u === 61 ? (e.consume(u), _) : L(u) ? (o = A, ee(u)) : V(u) ? (e.consume(u), A) : F(u);
  }
  function _(u) {
    return u === null || u === 60 || u === 61 || u === 62 || u === 96 ? n(u) : u === 34 || u === 39 ? (e.consume(u), i = u, q) : L(u) ? (o = _, ee(u)) : V(u) ? (e.consume(u), _) : (e.consume(u), Y);
  }
  function q(u) {
    return u === i ? (e.consume(u), i = void 0, D) : u === null ? n(u) : L(u) ? (o = q, ee(u)) : (e.consume(u), q);
  }
  function Y(u) {
    return u === null || u === 34 || u === 39 || u === 60 || u === 61 || u === 96 ? n(u) : u === 47 || u === 62 || ce(u) ? F(u) : (e.consume(u), Y);
  }
  function D(u) {
    return u === 47 || u === 62 || ce(u) ? F(u) : n(u);
  }
  function te(u) {
    return u === 62 ? (e.consume(u), e.exit("htmlTextData"), e.exit("htmlText"), t) : n(u);
  }
  function ee(u) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(u), e.exit("lineEnding"), oe;
  }
  function oe(u) {
    return V(u) ? Q(e, P, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(u) : P(u);
  }
  function P(u) {
    return e.enter("htmlTextData"), o(u);
  }
}
const kn = {
  name: "labelEnd",
  resolveAll: Bs,
  resolveTo: Hs,
  tokenize: $s
}, Ms = {
  tokenize: qs
}, zs = {
  tokenize: Vs
}, Us = {
  tokenize: Ys
};
function Bs(e) {
  let t = -1;
  const n = [];
  for (; ++t < e.length; ) {
    const r = e[t][1];
    if (n.push(e[t]), r.type === "labelImage" || r.type === "labelLink" || r.type === "labelEnd") {
      const i = r.type === "labelImage" ? 4 : 2;
      r.type = "data", t += i;
    }
  }
  return e.length !== n.length && Ee(e, 0, e.length, n), e;
}
function Hs(e, t) {
  let n = e.length, r = 0, i, l, o, a;
  for (; n--; )
    if (i = e[n][1], l) {
      if (i.type === "link" || i.type === "labelLink" && i._inactive)
        break;
      e[n][0] === "enter" && i.type === "labelLink" && (i._inactive = !0);
    } else if (o) {
      if (e[n][0] === "enter" && (i.type === "labelImage" || i.type === "labelLink") && !i._balanced && (l = n, i.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else i.type === "labelEnd" && (o = n);
  const s = {
    type: e[l][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[l][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, c = {
    type: "label",
    start: {
      ...e[l][1].start
    },
    end: {
      ...e[o][1].end
    }
  }, p = {
    type: "labelText",
    start: {
      ...e[l + r + 2][1].end
    },
    end: {
      ...e[o - 2][1].start
    }
  };
  return a = [["enter", s, t], ["enter", c, t]], a = ge(a, e.slice(l + 1, l + r + 3)), a = ge(a, [["enter", p, t]]), a = ge(a, bn(t.parser.constructs.insideSpan.null, e.slice(l + r + 4, o - 3), t)), a = ge(a, [["exit", p, t], e[o - 2], e[o - 1], ["exit", c, t]]), a = ge(a, e.slice(o + 1)), a = ge(a, [["exit", s, t]]), Ee(e, l, e.length, a), e;
}
function $s(e, t, n) {
  const r = this;
  let i = r.events.length, l, o;
  for (; i--; )
    if ((r.events[i][1].type === "labelImage" || r.events[i][1].type === "labelLink") && !r.events[i][1]._balanced) {
      l = r.events[i][1];
      break;
    }
  return a;
  function a(m) {
    return l ? l._inactive ? h(m) : (o = r.parser.defined.includes(qe(r.sliceSerialize({
      start: l.end,
      end: r.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(m), e.exit("labelMarker"), e.exit("labelEnd"), s) : n(m);
  }
  function s(m) {
    return m === 40 ? e.attempt(Ms, p, o ? p : h)(m) : m === 91 ? e.attempt(zs, p, o ? c : h)(m) : o ? p(m) : h(m);
  }
  function c(m) {
    return e.attempt(Us, p, h)(m);
  }
  function p(m) {
    return t(m);
  }
  function h(m) {
    return l._balanced = !0, n(m);
  }
}
function qs(e, t, n) {
  return r;
  function r(h) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(h), e.exit("resourceMarker"), i;
  }
  function i(h) {
    return ce(h) ? nt(e, l)(h) : l(h);
  }
  function l(h) {
    return h === 41 ? p(h) : yi(e, o, a, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(h);
  }
  function o(h) {
    return ce(h) ? nt(e, s)(h) : p(h);
  }
  function a(h) {
    return n(h);
  }
  function s(h) {
    return h === 34 || h === 39 || h === 40 ? Si(e, c, n, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(h) : p(h);
  }
  function c(h) {
    return ce(h) ? nt(e, p)(h) : p(h);
  }
  function p(h) {
    return h === 41 ? (e.enter("resourceMarker"), e.consume(h), e.exit("resourceMarker"), e.exit("resource"), t) : n(h);
  }
}
function Vs(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return xi.call(r, e, l, o, "reference", "referenceMarker", "referenceString")(a);
  }
  function l(a) {
    return r.parser.defined.includes(qe(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1))) ? t(a) : n(a);
  }
  function o(a) {
    return n(a);
  }
}
function Ys(e, t, n) {
  return r;
  function r(l) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(l), e.exit("referenceMarker"), i;
  }
  function i(l) {
    return l === 93 ? (e.enter("referenceMarker"), e.consume(l), e.exit("referenceMarker"), e.exit("reference"), t) : n(l);
  }
}
const Gs = {
  name: "labelStartImage",
  resolveAll: kn.resolveAll,
  tokenize: Ws
};
function Ws(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(a), e.exit("labelImageMarker"), l;
  }
  function l(a) {
    return a === 91 ? (e.enter("labelMarker"), e.consume(a), e.exit("labelMarker"), e.exit("labelImage"), o) : n(a);
  }
  function o(a) {
    return a === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(a) : t(a);
  }
}
const Qs = {
  name: "labelStartLink",
  resolveAll: kn.resolveAll,
  tokenize: Xs
};
function Xs(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(o), e.exit("labelMarker"), e.exit("labelLink"), l;
  }
  function l(o) {
    return o === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(o) : t(o);
  }
}
const Nt = {
  name: "lineEnding",
  tokenize: Js
};
function Js(e, t) {
  return n;
  function n(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), Q(e, t, "linePrefix");
  }
}
const mt = {
  name: "thematicBreak",
  tokenize: Ks
};
function Ks(e, t, n) {
  let r = 0, i;
  return l;
  function l(c) {
    return e.enter("thematicBreak"), o(c);
  }
  function o(c) {
    return i = c, a(c);
  }
  function a(c) {
    return c === i ? (e.enter("thematicBreakSequence"), s(c)) : r >= 3 && (c === null || L(c)) ? (e.exit("thematicBreak"), t(c)) : n(c);
  }
  function s(c) {
    return c === i ? (e.consume(c), r++, s) : (e.exit("thematicBreakSequence"), V(c) ? Q(e, a, "whitespace")(c) : a(c));
  }
}
const ue = {
  continuation: {
    tokenize: nu
  },
  exit: iu,
  name: "list",
  tokenize: tu
}, Zs = {
  partial: !0,
  tokenize: lu
}, eu = {
  partial: !0,
  tokenize: ru
};
function tu(e, t, n) {
  const r = this, i = r.events[r.events.length - 1];
  let l = i && i[1].type === "linePrefix" ? i[2].sliceSerialize(i[1], !0).length : 0, o = 0;
  return a;
  function a(d) {
    const y = r.containerState.type || (d === 42 || d === 43 || d === 45 ? "listUnordered" : "listOrdered");
    if (y === "listUnordered" ? !r.containerState.marker || d === r.containerState.marker : Zt(d)) {
      if (r.containerState.type || (r.containerState.type = y, e.enter(y, {
        _container: !0
      })), y === "listUnordered")
        return e.enter("listItemPrefix"), d === 42 || d === 45 ? e.check(mt, n, c)(d) : c(d);
      if (!r.interrupt || d === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), s(d);
    }
    return n(d);
  }
  function s(d) {
    return Zt(d) && ++o < 10 ? (e.consume(d), s) : (!r.interrupt || o < 2) && (r.containerState.marker ? d === r.containerState.marker : d === 41 || d === 46) ? (e.exit("listItemValue"), c(d)) : n(d);
  }
  function c(d) {
    return e.enter("listItemMarker"), e.consume(d), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || d, e.check(
      vt,
      // Can’t be empty when interrupting.
      r.interrupt ? n : p,
      e.attempt(Zs, m, h)
    );
  }
  function p(d) {
    return r.containerState.initialBlankLine = !0, l++, m(d);
  }
  function h(d) {
    return V(d) ? (e.enter("listItemPrefixWhitespace"), e.consume(d), e.exit("listItemPrefixWhitespace"), m) : n(d);
  }
  function m(d) {
    return r.containerState.size = l + r.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(d);
  }
}
function nu(e, t, n) {
  const r = this;
  return r.containerState._closeFlow = void 0, e.check(vt, i, l);
  function i(a) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, Q(e, t, "listItemIndent", r.containerState.size + 1)(a);
  }
  function l(a) {
    return r.containerState.furtherBlankLines || !V(a) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, o(a)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt(eu, t, o)(a));
  }
  function o(a) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, Q(e, e.attempt(ue, t, n), "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(a);
  }
}
function ru(e, t, n) {
  const r = this;
  return Q(e, i, "listItemIndent", r.containerState.size + 1);
  function i(l) {
    const o = r.events[r.events.length - 1];
    return o && o[1].type === "listItemIndent" && o[2].sliceSerialize(o[1], !0).length === r.containerState.size ? t(l) : n(l);
  }
}
function iu(e) {
  e.exit(this.containerState.type);
}
function lu(e, t, n) {
  const r = this;
  return Q(e, i, "listItemPrefixWhitespace", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function i(l) {
    const o = r.events[r.events.length - 1];
    return !V(l) && o && o[1].type === "listItemPrefixWhitespace" ? t(l) : n(l);
  }
}
const sr = {
  name: "setextUnderline",
  resolveTo: ou,
  tokenize: au
};
function ou(e, t) {
  let n = e.length, r, i, l;
  for (; n--; )
    if (e[n][0] === "enter") {
      if (e[n][1].type === "content") {
        r = n;
        break;
      }
      e[n][1].type === "paragraph" && (i = n);
    } else
      e[n][1].type === "content" && e.splice(n, 1), !l && e[n][1].type === "definition" && (l = n);
  const o = {
    type: "setextHeading",
    start: {
      ...e[r][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[i][1].type = "setextHeadingText", l ? (e.splice(i, 0, ["enter", o, t]), e.splice(l + 1, 0, ["exit", e[r][1], t]), e[r][1].end = {
    ...e[l][1].end
  }) : e[r][1] = o, e.push(["exit", o, t]), e;
}
function au(e, t, n) {
  const r = this;
  let i;
  return l;
  function l(c) {
    let p = r.events.length, h;
    for (; p--; )
      if (r.events[p][1].type !== "lineEnding" && r.events[p][1].type !== "linePrefix" && r.events[p][1].type !== "content") {
        h = r.events[p][1].type === "paragraph";
        break;
      }
    return !r.parser.lazy[r.now().line] && (r.interrupt || h) ? (e.enter("setextHeadingLine"), i = c, o(c)) : n(c);
  }
  function o(c) {
    return e.enter("setextHeadingLineSequence"), a(c);
  }
  function a(c) {
    return c === i ? (e.consume(c), a) : (e.exit("setextHeadingLineSequence"), V(c) ? Q(e, s, "lineSuffix")(c) : s(c));
  }
  function s(c) {
    return c === null || L(c) ? (e.exit("setextHeadingLine"), t(c)) : n(c);
  }
}
const su = {
  tokenize: uu
};
function uu(e) {
  const t = this, n = e.attempt(
    // Try to parse a blank line.
    vt,
    r,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, i, Q(e, e.attempt(this.parser.constructs.flow, i, e.attempt(fs, i)), "linePrefix"))
  );
  return n;
  function r(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(l), e.exit("lineEndingBlank"), t.currentConstruct = void 0, n;
  }
  function i(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), t.currentConstruct = void 0, n;
  }
}
const cu = {
  resolveAll: ki()
}, pu = bi("string"), du = bi("text");
function bi(e) {
  return {
    resolveAll: ki(e === "text" ? hu : void 0),
    tokenize: t
  };
  function t(n) {
    const r = this, i = this.parser.constructs[e], l = n.attempt(i, o, a);
    return o;
    function o(p) {
      return c(p) ? l(p) : a(p);
    }
    function a(p) {
      if (p === null) {
        n.consume(p);
        return;
      }
      return n.enter("data"), n.consume(p), s;
    }
    function s(p) {
      return c(p) ? (n.exit("data"), l(p)) : (n.consume(p), s);
    }
    function c(p) {
      if (p === null)
        return !0;
      const h = i[p];
      let m = -1;
      if (h)
        for (; ++m < h.length; ) {
          const d = h[m];
          if (!d.previous || d.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function ki(e) {
  return t;
  function t(n, r) {
    let i = -1, l;
    for (; ++i <= n.length; )
      l === void 0 ? n[i] && n[i][1].type === "data" && (l = i, i++) : (!n[i] || n[i][1].type !== "data") && (i !== l + 2 && (n[l][1].end = n[i - 1][1].end, n.splice(l + 2, i - l - 2), i = l + 2), l = void 0);
    return e ? e(n, r) : n;
  }
}
function hu(e, t) {
  let n = 0;
  for (; ++n <= e.length; )
    if ((n === e.length || e[n][1].type === "lineEnding") && e[n - 1][1].type === "data") {
      const r = e[n - 1][1], i = t.sliceStream(r);
      let l = i.length, o = -1, a = 0, s;
      for (; l--; ) {
        const c = i[l];
        if (typeof c == "string") {
          for (o = c.length; c.charCodeAt(o - 1) === 32; )
            a++, o--;
          if (o) break;
          o = -1;
        } else if (c === -2)
          s = !0, a++;
        else if (c !== -1) {
          l++;
          break;
        }
      }
      if (t._contentTypeTextTrailing && n === e.length && (a = 0), a) {
        const c = {
          type: n === e.length || s || a < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: l ? o : r.start._bufferIndex + o,
            _index: r.start._index + l,
            line: r.end.line,
            column: r.end.column - a,
            offset: r.end.offset - a
          },
          end: {
            ...r.end
          }
        };
        r.end = {
          ...c.start
        }, r.start.offset === r.end.offset ? Object.assign(r, c) : (e.splice(n, 0, ["enter", c, t], ["exit", c, t]), n += 2);
      }
      n++;
    }
  return e;
}
const fu = {
  42: ue,
  43: ue,
  45: ue,
  48: ue,
  49: ue,
  50: ue,
  51: ue,
  52: ue,
  53: ue,
  54: ue,
  55: ue,
  56: ue,
  57: ue,
  62: hi
}, mu = {
  91: Ss
}, gu = {
  [-2]: Dt,
  [-1]: Dt,
  32: Dt
}, yu = {
  35: Ts,
  42: mt,
  45: [sr, mt],
  60: As,
  61: sr,
  95: mt,
  96: or,
  126: or
}, xu = {
  38: mi,
  92: fi
}, Su = {
  [-5]: Nt,
  [-4]: Nt,
  [-3]: Nt,
  33: Gs,
  38: mi,
  42: en,
  60: [Qa, Ns],
  91: Qs,
  92: [ws, fi],
  93: kn,
  95: en,
  96: ss
}, bu = {
  null: [en, cu]
}, ku = {
  null: [42, 95]
}, Eu = {
  null: []
}, wu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: ku,
  contentInitial: mu,
  disable: Eu,
  document: fu,
  flow: yu,
  flowInitial: gu,
  insideSpan: bu,
  string: xu,
  text: Su
}, Symbol.toStringTag, { value: "Module" }));
function Cu(e, t, n) {
  let r = {
    _bufferIndex: -1,
    _index: 0,
    line: n && n.line || 1,
    column: n && n.column || 1,
    offset: n && n.offset || 0
  };
  const i = {}, l = [];
  let o = [], a = [];
  const s = {
    attempt: O(j),
    check: O(k),
    consume: T,
    enter: E,
    exit: v,
    interrupt: O(k, {
      interrupt: !0
    })
  }, c = {
    code: null,
    containerState: {},
    defineSkip: b,
    events: [],
    now: y,
    parser: e,
    previous: null,
    sliceSerialize: m,
    sliceStream: d,
    write: h
  };
  let p = t.tokenize.call(c, s);
  return t.resolveAll && l.push(t), c;
  function h(A) {
    return o = ge(o, A), C(), o[o.length - 1] !== null ? [] : ($(t, 0), c.events = bn(l, c.events, c), c.events);
  }
  function m(A, _) {
    return Iu(d(A), _);
  }
  function d(A) {
    return Tu(o, A);
  }
  function y() {
    const {
      _bufferIndex: A,
      _index: _,
      line: q,
      column: Y,
      offset: D
    } = r;
    return {
      _bufferIndex: A,
      _index: _,
      line: q,
      column: Y,
      offset: D
    };
  }
  function b(A) {
    i[A.line] = A.column, z();
  }
  function C() {
    let A;
    for (; r._index < o.length; ) {
      const _ = o[r._index];
      if (typeof _ == "string")
        for (A = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === A && r._bufferIndex < _.length; )
          S(_.charCodeAt(r._bufferIndex));
      else
        S(_);
    }
  }
  function S(A) {
    p = p(A);
  }
  function T(A) {
    L(A) ? (r.line++, r.column = 1, r.offset += A === -3 ? 2 : 1, z()) : A !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    o[r._index].length && (r._bufferIndex = -1, r._index++)), c.previous = A;
  }
  function E(A, _) {
    const q = _ || {};
    return q.type = A, q.start = y(), c.events.push(["enter", q, c]), a.push(q), q;
  }
  function v(A) {
    const _ = a.pop();
    return _.end = y(), c.events.push(["exit", _, c]), _;
  }
  function j(A, _) {
    $(A, _.from);
  }
  function k(A, _) {
    _.restore();
  }
  function O(A, _) {
    return q;
    function q(Y, D, te) {
      let ee, oe, P, u;
      return Array.isArray(Y) ? (
        /* c8 ignore next 1 */
        U(Y)
      ) : "tokenize" in Y ? (
        // Looks like a construct.
        U([
          /** @type {Construct} */
          Y
        ])
      ) : R(Y);
      function R(ne) {
        return we;
        function we(X) {
          const de = X !== null && ne[X], xe = X !== null && ne.null, ze = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(de) ? de : de ? [de] : [],
            ...Array.isArray(xe) ? xe : xe ? [xe] : []
          ];
          return U(ze)(X);
        }
      }
      function U(ne) {
        return ee = ne, oe = 0, ne.length === 0 ? te : g(ne[oe]);
      }
      function g(ne) {
        return we;
        function we(X) {
          return u = F(), P = ne, ne.partial || (c.currentConstruct = ne), ne.name && c.parser.constructs.disable.null.includes(ne.name) ? le() : ne.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            _ ? Object.assign(Object.create(c), _) : c,
            s,
            re,
            le
          )(X);
        }
      }
      function re(ne) {
        return A(P, u), D;
      }
      function le(ne) {
        return u.restore(), ++oe < ee.length ? g(ee[oe]) : te;
      }
    }
  }
  function $(A, _) {
    A.resolveAll && !l.includes(A) && l.push(A), A.resolve && Ee(c.events, _, c.events.length - _, A.resolve(c.events.slice(_), c)), A.resolveTo && (c.events = A.resolveTo(c.events, c));
  }
  function F() {
    const A = y(), _ = c.previous, q = c.currentConstruct, Y = c.events.length, D = Array.from(a);
    return {
      from: Y,
      restore: te
    };
    function te() {
      r = A, c.previous = _, c.currentConstruct = q, c.events.length = Y, a = D, z();
    }
  }
  function z() {
    r.line in i && r.column < 2 && (r.column = i[r.line], r.offset += i[r.line] - 1);
  }
}
function Tu(e, t) {
  const n = t.start._index, r = t.start._bufferIndex, i = t.end._index, l = t.end._bufferIndex;
  let o;
  if (n === i)
    o = [e[n].slice(r, l)];
  else {
    if (o = e.slice(n, i), r > -1) {
      const a = o[0];
      typeof a == "string" ? o[0] = a.slice(r) : o.shift();
    }
    l > 0 && o.push(e[i].slice(0, l));
  }
  return o;
}
function Iu(e, t) {
  let n = -1;
  const r = [];
  let i;
  for (; ++n < e.length; ) {
    const l = e[n];
    let o;
    if (typeof l == "string")
      o = l;
    else switch (l) {
      case -5: {
        o = "\r";
        break;
      }
      case -4: {
        o = `
`;
        break;
      }
      case -3: {
        o = `\r
`;
        break;
      }
      case -2: {
        o = t ? " " : "	";
        break;
      }
      case -1: {
        if (!t && i) continue;
        o = " ";
        break;
      }
      default:
        o = String.fromCharCode(l);
    }
    i = l === -2, r.push(o);
  }
  return r.join("");
}
function vu(e) {
  const r = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      Oa([wu, ...(e || {}).extensions || []])
    ),
    content: i(Ha),
    defined: [],
    document: i(qa),
    flow: i(su),
    lazy: {},
    string: i(pu),
    text: i(du)
  };
  return r;
  function i(l) {
    return o;
    function o(a) {
      return Cu(r, l, a);
    }
  }
}
function _u(e) {
  for (; !gi(e); )
    ;
  return e;
}
const ur = /[\0\t\n\r]/g;
function Au() {
  let e = 1, t = "", n = !0, r;
  return i;
  function i(l, o, a) {
    const s = [];
    let c, p, h, m, d;
    for (l = t + (typeof l == "string" ? l.toString() : new TextDecoder(o || void 0).decode(l)), h = 0, t = "", n && (l.charCodeAt(0) === 65279 && h++, n = void 0); h < l.length; ) {
      if (ur.lastIndex = h, c = ur.exec(l), m = c && c.index !== void 0 ? c.index : l.length, d = l.charCodeAt(m), !c) {
        t = l.slice(h);
        break;
      }
      if (d === 10 && h === m && r)
        s.push(-3), r = void 0;
      else
        switch (r && (s.push(-5), r = void 0), h < m && (s.push(l.slice(h, m)), e += m - h), d) {
          case 0: {
            s.push(65533), e++;
            break;
          }
          case 9: {
            for (p = Math.ceil(e / 4) * 4, s.push(-2); e++ < p; ) s.push(-1);
            break;
          }
          case 10: {
            s.push(-4), e = 1;
            break;
          }
          default:
            r = !0, e = 1;
        }
      h = m + 1;
    }
    return a && (r && s.push(-5), t && s.push(t), s.push(null)), s;
  }
}
const Ru = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function ju(e) {
  return e.replace(Ru, Pu);
}
function Pu(e, t, n) {
  if (t)
    return t;
  if (n.charCodeAt(0) === 35) {
    const i = n.charCodeAt(1), l = i === 120 || i === 88;
    return di(n.slice(l ? 2 : 1), l ? 16 : 10);
  }
  return Sn(n) || e;
}
const Ei = {}.hasOwnProperty;
function Lu(e, t, n) {
  return typeof t != "string" && (n = t, t = void 0), Ou(n)(_u(vu(n).document().write(Au()(e, t, !0))));
}
function Ou(e) {
  const t = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: l(Rn),
      autolinkProtocol: F,
      autolinkEmail: F,
      atxHeading: l(vn),
      blockQuote: l(xe),
      characterEscape: F,
      characterReference: F,
      codeFenced: l(ze),
      codeFencedFenceInfo: o,
      codeFencedFenceMeta: o,
      codeIndented: l(ze, o),
      codeText: l(Ni, o),
      codeTextData: F,
      data: F,
      codeFlowValue: F,
      definition: l(Fi),
      definitionDestinationString: o,
      definitionLabelString: o,
      definitionTitleString: o,
      emphasis: l(Mi),
      hardBreakEscape: l(_n),
      hardBreakTrailing: l(_n),
      htmlFlow: l(An, o),
      htmlFlowData: F,
      htmlText: l(An, o),
      htmlTextData: F,
      image: l(zi),
      label: o,
      link: l(Rn),
      listItem: l(Ui),
      listItemValue: m,
      listOrdered: l(jn, h),
      listUnordered: l(jn),
      paragraph: l(Bi),
      reference: g,
      referenceString: o,
      resourceDestinationString: o,
      resourceTitleString: o,
      setextHeading: l(vn),
      strong: l(Hi),
      thematicBreak: l(qi)
    },
    exit: {
      atxHeading: s(),
      atxHeadingSequence: j,
      autolink: s(),
      autolinkEmail: de,
      autolinkProtocol: X,
      blockQuote: s(),
      characterEscapeValue: z,
      characterReferenceMarkerHexadecimal: le,
      characterReferenceMarkerNumeric: le,
      characterReferenceValue: ne,
      characterReference: we,
      codeFenced: s(C),
      codeFencedFence: b,
      codeFencedFenceInfo: d,
      codeFencedFenceMeta: y,
      codeFlowValue: z,
      codeIndented: s(S),
      codeText: s(D),
      codeTextData: z,
      data: z,
      definition: s(),
      definitionDestinationString: v,
      definitionLabelString: T,
      definitionTitleString: E,
      emphasis: s(),
      hardBreakEscape: s(_),
      hardBreakTrailing: s(_),
      htmlFlow: s(q),
      htmlFlowData: z,
      htmlText: s(Y),
      htmlTextData: z,
      image: s(ee),
      label: P,
      labelText: oe,
      lineEnding: A,
      link: s(te),
      listItem: s(),
      listOrdered: s(),
      listUnordered: s(),
      paragraph: s(),
      referenceString: re,
      resourceDestinationString: u,
      resourceTitleString: R,
      resource: U,
      setextHeading: s($),
      setextHeadingLineSequence: O,
      setextHeadingText: k,
      strong: s(),
      thematicBreak: s()
    }
  };
  wi(t, (e || {}).mdastExtensions || []);
  const n = {};
  return r;
  function r(x) {
    let I = {
      type: "root",
      children: []
    };
    const N = {
      stack: [I],
      tokenStack: [],
      config: t,
      enter: a,
      exit: c,
      buffer: o,
      resume: p,
      data: n
    }, B = [];
    let G = -1;
    for (; ++G < x.length; )
      if (x[G][1].type === "listOrdered" || x[G][1].type === "listUnordered")
        if (x[G][0] === "enter")
          B.push(G);
        else {
          const ye = B.pop();
          G = i(x, ye, G);
        }
    for (G = -1; ++G < x.length; ) {
      const ye = t[x[G][0]];
      Ei.call(ye, x[G][1].type) && ye[x[G][1].type].call(Object.assign({
        sliceSerialize: x[G][2].sliceSerialize
      }, N), x[G][1]);
    }
    if (N.tokenStack.length > 0) {
      const ye = N.tokenStack[N.tokenStack.length - 1];
      (ye[1] || cr).call(N, void 0, ye[0]);
    }
    for (I.position = {
      start: _e(x.length > 0 ? x[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: _e(x.length > 0 ? x[x.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, G = -1; ++G < t.transforms.length; )
      I = t.transforms[G](I) || I;
    return I;
  }
  function i(x, I, N) {
    let B = I - 1, G = -1, ye = !1, je, Ce, We, Qe;
    for (; ++B <= N; ) {
      const he = x[B];
      switch (he[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          he[0] === "enter" ? G++ : G--, Qe = void 0;
          break;
        }
        case "lineEndingBlank": {
          he[0] === "enter" && (je && !Qe && !G && !We && (We = B), Qe = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          Qe = void 0;
      }
      if (!G && he[0] === "enter" && he[1].type === "listItemPrefix" || G === -1 && he[0] === "exit" && (he[1].type === "listUnordered" || he[1].type === "listOrdered")) {
        if (je) {
          let Ue = B;
          for (Ce = void 0; Ue--; ) {
            const Te = x[Ue];
            if (Te[1].type === "lineEnding" || Te[1].type === "lineEndingBlank") {
              if (Te[0] === "exit") continue;
              Ce && (x[Ce][1].type = "lineEndingBlank", ye = !0), Te[1].type = "lineEnding", Ce = Ue;
            } else if (!(Te[1].type === "linePrefix" || Te[1].type === "blockQuotePrefix" || Te[1].type === "blockQuotePrefixWhitespace" || Te[1].type === "blockQuoteMarker" || Te[1].type === "listItemIndent")) break;
          }
          We && (!Ce || We < Ce) && (je._spread = !0), je.end = Object.assign({}, Ce ? x[Ce][1].start : he[1].end), x.splice(Ce || B, 0, ["exit", je, he[2]]), B++, N++;
        }
        if (he[1].type === "listItemPrefix") {
          const Ue = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, he[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          je = Ue, x.splice(B, 0, ["enter", Ue, he[2]]), B++, N++, We = void 0, Qe = !0;
        }
      }
    }
    return x[I][1]._spread = ye, N;
  }
  function l(x, I) {
    return N;
    function N(B) {
      a.call(this, x(B), B), I && I.call(this, B);
    }
  }
  function o() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function a(x, I, N) {
    this.stack[this.stack.length - 1].children.push(x), this.stack.push(x), this.tokenStack.push([I, N || void 0]), x.position = {
      start: _e(I.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function s(x) {
    return I;
    function I(N) {
      x && x.call(this, N), c.call(this, N);
    }
  }
  function c(x, I) {
    const N = this.stack.pop(), B = this.tokenStack.pop();
    if (B)
      B[0].type !== x.type && (I ? I.call(this, x, B[0]) : (B[1] || cr).call(this, x, B[0]));
    else throw new Error("Cannot close `" + x.type + "` (" + tt({
      start: x.start,
      end: x.end
    }) + "): it’s not open");
    N.position.end = _e(x.end);
  }
  function p() {
    return Pa(this.stack.pop());
  }
  function h() {
    this.data.expectingFirstListItemValue = !0;
  }
  function m(x) {
    if (this.data.expectingFirstListItemValue) {
      const I = this.stack[this.stack.length - 2];
      I.start = Number.parseInt(this.sliceSerialize(x), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function d() {
    const x = this.resume(), I = this.stack[this.stack.length - 1];
    I.lang = x;
  }
  function y() {
    const x = this.resume(), I = this.stack[this.stack.length - 1];
    I.meta = x;
  }
  function b() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function C() {
    const x = this.resume(), I = this.stack[this.stack.length - 1];
    I.value = x.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function S() {
    const x = this.resume(), I = this.stack[this.stack.length - 1];
    I.value = x.replace(/(\r?\n|\r)$/g, "");
  }
  function T(x) {
    const I = this.resume(), N = this.stack[this.stack.length - 1];
    N.label = I, N.identifier = qe(this.sliceSerialize(x)).toLowerCase();
  }
  function E() {
    const x = this.resume(), I = this.stack[this.stack.length - 1];
    I.title = x;
  }
  function v() {
    const x = this.resume(), I = this.stack[this.stack.length - 1];
    I.url = x;
  }
  function j(x) {
    const I = this.stack[this.stack.length - 1];
    if (!I.depth) {
      const N = this.sliceSerialize(x).length;
      I.depth = N;
    }
  }
  function k() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function O(x) {
    const I = this.stack[this.stack.length - 1];
    I.depth = this.sliceSerialize(x).codePointAt(0) === 61 ? 1 : 2;
  }
  function $() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function F(x) {
    const N = this.stack[this.stack.length - 1].children;
    let B = N[N.length - 1];
    (!B || B.type !== "text") && (B = $i(), B.position = {
      start: _e(x.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, N.push(B)), this.stack.push(B);
  }
  function z(x) {
    const I = this.stack.pop();
    I.value += this.sliceSerialize(x), I.position.end = _e(x.end);
  }
  function A(x) {
    const I = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const N = I.children[I.children.length - 1];
      N.position.end = _e(x.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && t.canContainEols.includes(I.type) && (F.call(this, x), z.call(this, x));
  }
  function _() {
    this.data.atHardBreak = !0;
  }
  function q() {
    const x = this.resume(), I = this.stack[this.stack.length - 1];
    I.value = x;
  }
  function Y() {
    const x = this.resume(), I = this.stack[this.stack.length - 1];
    I.value = x;
  }
  function D() {
    const x = this.resume(), I = this.stack[this.stack.length - 1];
    I.value = x;
  }
  function te() {
    const x = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const I = this.data.referenceType || "shortcut";
      x.type += "Reference", x.referenceType = I, delete x.url, delete x.title;
    } else
      delete x.identifier, delete x.label;
    this.data.referenceType = void 0;
  }
  function ee() {
    const x = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const I = this.data.referenceType || "shortcut";
      x.type += "Reference", x.referenceType = I, delete x.url, delete x.title;
    } else
      delete x.identifier, delete x.label;
    this.data.referenceType = void 0;
  }
  function oe(x) {
    const I = this.sliceSerialize(x), N = this.stack[this.stack.length - 2];
    N.label = ju(I), N.identifier = qe(I).toLowerCase();
  }
  function P() {
    const x = this.stack[this.stack.length - 1], I = this.resume(), N = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, N.type === "link") {
      const B = x.children;
      N.children = B;
    } else
      N.alt = I;
  }
  function u() {
    const x = this.resume(), I = this.stack[this.stack.length - 1];
    I.url = x;
  }
  function R() {
    const x = this.resume(), I = this.stack[this.stack.length - 1];
    I.title = x;
  }
  function U() {
    this.data.inReference = void 0;
  }
  function g() {
    this.data.referenceType = "collapsed";
  }
  function re(x) {
    const I = this.resume(), N = this.stack[this.stack.length - 1];
    N.label = I, N.identifier = qe(this.sliceSerialize(x)).toLowerCase(), this.data.referenceType = "full";
  }
  function le(x) {
    this.data.characterReferenceType = x.type;
  }
  function ne(x) {
    const I = this.sliceSerialize(x), N = this.data.characterReferenceType;
    let B;
    N ? (B = di(I, N === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : B = Sn(I);
    const G = this.stack[this.stack.length - 1];
    G.value += B;
  }
  function we(x) {
    const I = this.stack.pop();
    I.position.end = _e(x.end);
  }
  function X(x) {
    z.call(this, x);
    const I = this.stack[this.stack.length - 1];
    I.url = this.sliceSerialize(x);
  }
  function de(x) {
    z.call(this, x);
    const I = this.stack[this.stack.length - 1];
    I.url = "mailto:" + this.sliceSerialize(x);
  }
  function xe() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function ze() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function Ni() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function Fi() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function Mi() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function vn() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function _n() {
    return {
      type: "break"
    };
  }
  function An() {
    return {
      type: "html",
      value: ""
    };
  }
  function zi() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Rn() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function jn(x) {
    return {
      type: "list",
      ordered: x.type === "listOrdered",
      start: null,
      spread: x._spread,
      children: []
    };
  }
  function Ui(x) {
    return {
      type: "listItem",
      spread: x._spread,
      checked: null,
      children: []
    };
  }
  function Bi() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function Hi() {
    return {
      type: "strong",
      children: []
    };
  }
  function $i() {
    return {
      type: "text",
      value: ""
    };
  }
  function qi() {
    return {
      type: "thematicBreak"
    };
  }
}
function _e(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function wi(e, t) {
  let n = -1;
  for (; ++n < t.length; ) {
    const r = t[n];
    Array.isArray(r) ? wi(e, r) : Du(e, r);
  }
}
function Du(e, t) {
  let n;
  for (n in t)
    if (Ei.call(t, n))
      switch (n) {
        case "canContainEols": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "transforms": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "enter":
        case "exit": {
          const r = t[n];
          r && Object.assign(e[n], r);
          break;
        }
      }
}
function cr(e, t) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + tt({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + t.type + "`, " + tt({
    start: t.start,
    end: t.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + t.type + "`, " + tt({
    start: t.start,
    end: t.end
  }) + ") is still open");
}
function Nu(e) {
  const t = this;
  t.parser = n;
  function n(r) {
    return Lu(r, {
      ...t.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: t.data("micromarkExtensions") || [],
      mdastExtensions: t.data("fromMarkdownExtensions") || []
    });
  }
}
function Fu(e, t) {
  const n = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(t), !0)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function Mu(e, t) {
  const n = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(t, n), [e.applyData(t, n), { type: "text", value: `
` }];
}
function zu(e, t) {
  const n = t.value ? t.value + `
` : "", r = {};
  t.lang && (r.className = ["language-" + t.lang]);
  let i = {
    type: "element",
    tagName: "code",
    properties: r,
    children: [{ type: "text", value: n }]
  };
  return t.meta && (i.data = { meta: t.meta }), e.patch(t, i), i = e.applyData(t, i), i = { type: "element", tagName: "pre", properties: {}, children: [i] }, e.patch(t, i), i;
}
function Uu(e, t) {
  const n = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function Bu(e, t) {
  const n = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function Hu(e, t) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = String(t.identifier).toUpperCase(), i = Ge(r.toLowerCase()), l = e.footnoteOrder.indexOf(r);
  let o, a = e.footnoteCounts.get(r);
  a === void 0 ? (a = 0, e.footnoteOrder.push(r), o = e.footnoteOrder.length) : o = l + 1, a += 1, e.footnoteCounts.set(r, a);
  const s = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + n + "fn-" + i,
      id: n + "fnref-" + i + (a > 1 ? "-" + a : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(o) }]
  };
  e.patch(t, s);
  const c = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [s]
  };
  return e.patch(t, c), e.applyData(t, c);
}
function $u(e, t) {
  const n = {
    type: "element",
    tagName: "h" + t.depth,
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function qu(e, t) {
  if (e.options.allowDangerousHtml) {
    const n = { type: "raw", value: t.value };
    return e.patch(t, n), e.applyData(t, n);
  }
}
function Ci(e, t) {
  const n = t.referenceType;
  let r = "]";
  if (n === "collapsed" ? r += "[]" : n === "full" && (r += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference")
    return [{ type: "text", value: "![" + t.alt + r }];
  const i = e.all(t), l = i[0];
  l && l.type === "text" ? l.value = "[" + l.value : i.unshift({ type: "text", value: "[" });
  const o = i[i.length - 1];
  return o && o.type === "text" ? o.value += r : i.push({ type: "text", value: r }), i;
}
function Vu(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return Ci(e, t);
  const i = { src: Ge(r.url || ""), alt: t.alt };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const l = { type: "element", tagName: "img", properties: i, children: [] };
  return e.patch(t, l), e.applyData(t, l);
}
function Yu(e, t) {
  const n = { src: Ge(t.url) };
  t.alt !== null && t.alt !== void 0 && (n.alt = t.alt), t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = { type: "element", tagName: "img", properties: n, children: [] };
  return e.patch(t, r), e.applyData(t, r);
}
function Gu(e, t) {
  const n = { type: "text", value: t.value.replace(/\r?\n|\r/g, " ") };
  e.patch(t, n);
  const r = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [n]
  };
  return e.patch(t, r), e.applyData(t, r);
}
function Wu(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return Ci(e, t);
  const i = { href: Ge(r.url || "") };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const l = {
    type: "element",
    tagName: "a",
    properties: i,
    children: e.all(t)
  };
  return e.patch(t, l), e.applyData(t, l);
}
function Qu(e, t) {
  const n = { href: Ge(t.url) };
  t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = {
    type: "element",
    tagName: "a",
    properties: n,
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function Xu(e, t, n) {
  const r = e.all(t), i = n ? Ju(n) : Ti(t), l = {}, o = [];
  if (typeof t.checked == "boolean") {
    const p = r[0];
    let h;
    p && p.type === "element" && p.tagName === "p" ? h = p : (h = { type: "element", tagName: "p", properties: {}, children: [] }, r.unshift(h)), h.children.length > 0 && h.children.unshift({ type: "text", value: " " }), h.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: t.checked, disabled: !0 },
      children: []
    }), l.className = ["task-list-item"];
  }
  let a = -1;
  for (; ++a < r.length; ) {
    const p = r[a];
    (i || a !== 0 || p.type !== "element" || p.tagName !== "p") && o.push({ type: "text", value: `
` }), p.type === "element" && p.tagName === "p" && !i ? o.push(...p.children) : o.push(p);
  }
  const s = r[r.length - 1];
  s && (i || s.type !== "element" || s.tagName !== "p") && o.push({ type: "text", value: `
` });
  const c = { type: "element", tagName: "li", properties: l, children: o };
  return e.patch(t, c), e.applyData(t, c);
}
function Ju(e) {
  let t = !1;
  if (e.type === "list") {
    t = e.spread || !1;
    const n = e.children;
    let r = -1;
    for (; !t && ++r < n.length; )
      t = Ti(n[r]);
  }
  return t;
}
function Ti(e) {
  const t = e.spread;
  return t ?? e.children.length > 1;
}
function Ku(e, t) {
  const n = {}, r = e.all(t);
  let i = -1;
  for (typeof t.start == "number" && t.start !== 1 && (n.start = t.start); ++i < r.length; ) {
    const o = r[i];
    if (o.type === "element" && o.tagName === "li" && o.properties && Array.isArray(o.properties.className) && o.properties.className.includes("task-list-item")) {
      n.className = ["contains-task-list"];
      break;
    }
  }
  const l = {
    type: "element",
    tagName: t.ordered ? "ol" : "ul",
    properties: n,
    children: e.wrap(r, !0)
  };
  return e.patch(t, l), e.applyData(t, l);
}
function Zu(e, t) {
  const n = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function ec(e, t) {
  const n = { type: "root", children: e.wrap(e.all(t)) };
  return e.patch(t, n), e.applyData(t, n);
}
function tc(e, t) {
  const n = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function nc(e, t) {
  const n = e.all(t), r = n.shift(), i = [];
  if (r) {
    const o = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([r], !0)
    };
    e.patch(t.children[0], o), i.push(o);
  }
  if (n.length > 0) {
    const o = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(n, !0)
    }, a = mn(t.children[1]), s = li(t.children[t.children.length - 1]);
    a && s && (o.position = { start: a, end: s }), i.push(o);
  }
  const l = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(i, !0)
  };
  return e.patch(t, l), e.applyData(t, l);
}
function rc(e, t, n) {
  const r = n ? n.children : void 0, l = (r ? r.indexOf(t) : 1) === 0 ? "th" : "td", o = n && n.type === "table" ? n.align : void 0, a = o ? o.length : t.children.length;
  let s = -1;
  const c = [];
  for (; ++s < a; ) {
    const h = t.children[s], m = {}, d = o ? o[s] : void 0;
    d && (m.align = d);
    let y = { type: "element", tagName: l, properties: m, children: [] };
    h && (y.children = e.all(h), e.patch(h, y), y = e.applyData(h, y)), c.push(y);
  }
  const p = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(c, !0)
  };
  return e.patch(t, p), e.applyData(t, p);
}
function ic(e, t) {
  const n = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
const pr = 9, dr = 32;
function lc(e) {
  const t = String(e), n = /\r?\n|\r/g;
  let r = n.exec(t), i = 0;
  const l = [];
  for (; r; )
    l.push(
      hr(t.slice(i, r.index), i > 0, !0),
      r[0]
    ), i = r.index + r[0].length, r = n.exec(t);
  return l.push(hr(t.slice(i), i > 0, !1)), l.join("");
}
function hr(e, t, n) {
  let r = 0, i = e.length;
  if (t) {
    let l = e.codePointAt(r);
    for (; l === pr || l === dr; )
      r++, l = e.codePointAt(r);
  }
  if (n) {
    let l = e.codePointAt(i - 1);
    for (; l === pr || l === dr; )
      i--, l = e.codePointAt(i - 1);
  }
  return i > r ? e.slice(r, i) : "";
}
function oc(e, t) {
  const n = { type: "text", value: lc(String(t.value)) };
  return e.patch(t, n), e.applyData(t, n);
}
function ac(e, t) {
  const n = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(t, n), e.applyData(t, n);
}
const sc = {
  blockquote: Fu,
  break: Mu,
  code: zu,
  delete: Uu,
  emphasis: Bu,
  footnoteReference: Hu,
  heading: $u,
  html: qu,
  imageReference: Vu,
  image: Yu,
  inlineCode: Gu,
  linkReference: Wu,
  link: Qu,
  listItem: Xu,
  list: Ku,
  paragraph: Zu,
  // @ts-expect-error: root is different, but hard to type.
  root: ec,
  strong: tc,
  table: nc,
  tableCell: ic,
  tableRow: rc,
  text: oc,
  thematicBreak: ac,
  toml: dt,
  yaml: dt,
  definition: dt,
  footnoteDefinition: dt
};
function dt() {
}
const Ii = -1, _t = 0, rt = 1, Et = 2, En = 3, wn = 4, Cn = 5, Tn = 6, vi = 7, _i = 8, fr = typeof self == "object" ? self : globalThis, uc = (e, t) => {
  const n = (i, l) => (e.set(l, i), i), r = (i) => {
    if (e.has(i))
      return e.get(i);
    const [l, o] = t[i];
    switch (l) {
      case _t:
      case Ii:
        return n(o, i);
      case rt: {
        const a = n([], i);
        for (const s of o)
          a.push(r(s));
        return a;
      }
      case Et: {
        const a = n({}, i);
        for (const [s, c] of o)
          a[r(s)] = r(c);
        return a;
      }
      case En:
        return n(new Date(o), i);
      case wn: {
        const { source: a, flags: s } = o;
        return n(new RegExp(a, s), i);
      }
      case Cn: {
        const a = n(/* @__PURE__ */ new Map(), i);
        for (const [s, c] of o)
          a.set(r(s), r(c));
        return a;
      }
      case Tn: {
        const a = n(/* @__PURE__ */ new Set(), i);
        for (const s of o)
          a.add(r(s));
        return a;
      }
      case vi: {
        const { name: a, message: s } = o;
        return n(new fr[a](s), i);
      }
      case _i:
        return n(BigInt(o), i);
      case "BigInt":
        return n(Object(BigInt(o)), i);
      case "ArrayBuffer":
        return n(new Uint8Array(o).buffer, o);
      case "DataView": {
        const { buffer: a } = new Uint8Array(o);
        return n(new DataView(a), o);
      }
    }
    return n(new fr[l](o), i);
  };
  return r;
}, mr = (e) => uc(/* @__PURE__ */ new Map(), e)(0), Be = "", { toString: cc } = {}, { keys: pc } = Object, Ze = (e) => {
  const t = typeof e;
  if (t !== "object" || !e)
    return [_t, t];
  const n = cc.call(e).slice(8, -1);
  switch (n) {
    case "Array":
      return [rt, Be];
    case "Object":
      return [Et, Be];
    case "Date":
      return [En, Be];
    case "RegExp":
      return [wn, Be];
    case "Map":
      return [Cn, Be];
    case "Set":
      return [Tn, Be];
    case "DataView":
      return [rt, n];
  }
  return n.includes("Array") ? [rt, n] : n.includes("Error") ? [vi, n] : [Et, n];
}, ht = ([e, t]) => e === _t && (t === "function" || t === "symbol"), dc = (e, t, n, r) => {
  const i = (o, a) => {
    const s = r.push(o) - 1;
    return n.set(a, s), s;
  }, l = (o) => {
    if (n.has(o))
      return n.get(o);
    let [a, s] = Ze(o);
    switch (a) {
      case _t: {
        let p = o;
        switch (s) {
          case "bigint":
            a = _i, p = o.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + s);
            p = null;
            break;
          case "undefined":
            return i([Ii], o);
        }
        return i([a, p], o);
      }
      case rt: {
        if (s) {
          let m = o;
          return s === "DataView" ? m = new Uint8Array(o.buffer) : s === "ArrayBuffer" && (m = new Uint8Array(o)), i([s, [...m]], o);
        }
        const p = [], h = i([a, p], o);
        for (const m of o)
          p.push(l(m));
        return h;
      }
      case Et: {
        if (s)
          switch (s) {
            case "BigInt":
              return i([s, o.toString()], o);
            case "Boolean":
            case "Number":
            case "String":
              return i([s, o.valueOf()], o);
          }
        if (t && "toJSON" in o)
          return l(o.toJSON());
        const p = [], h = i([a, p], o);
        for (const m of pc(o))
          (e || !ht(Ze(o[m]))) && p.push([l(m), l(o[m])]);
        return h;
      }
      case En:
        return i([a, o.toISOString()], o);
      case wn: {
        const { source: p, flags: h } = o;
        return i([a, { source: p, flags: h }], o);
      }
      case Cn: {
        const p = [], h = i([a, p], o);
        for (const [m, d] of o)
          (e || !(ht(Ze(m)) || ht(Ze(d)))) && p.push([l(m), l(d)]);
        return h;
      }
      case Tn: {
        const p = [], h = i([a, p], o);
        for (const m of o)
          (e || !ht(Ze(m))) && p.push(l(m));
        return h;
      }
    }
    const { message: c } = o;
    return i([a, { name: s, message: c }], o);
  };
  return l;
}, gr = (e, { json: t, lossy: n } = {}) => {
  const r = [];
  return dc(!(t || n), !!t, /* @__PURE__ */ new Map(), r)(e), r;
}, wt = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, t) => t && ("json" in t || "lossy" in t) ? mr(gr(e, t)) : structuredClone(e)
) : (e, t) => mr(gr(e, t));
function hc(e, t) {
  const n = [{ type: "text", value: "↩" }];
  return t > 1 && n.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(t) }]
  }), n;
}
function fc(e, t) {
  return "Back to reference " + (e + 1) + (t > 1 ? "-" + t : "");
}
function mc(e) {
  const t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", n = e.options.footnoteBackContent || hc, r = e.options.footnoteBackLabel || fc, i = e.options.footnoteLabel || "Footnotes", l = e.options.footnoteLabelTagName || "h2", o = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, a = [];
  let s = -1;
  for (; ++s < e.footnoteOrder.length; ) {
    const c = e.footnoteById.get(
      e.footnoteOrder[s]
    );
    if (!c)
      continue;
    const p = e.all(c), h = String(c.identifier).toUpperCase(), m = Ge(h.toLowerCase());
    let d = 0;
    const y = [], b = e.footnoteCounts.get(h);
    for (; b !== void 0 && ++d <= b; ) {
      y.length > 0 && y.push({ type: "text", value: " " });
      let T = typeof n == "string" ? n : n(s, d);
      typeof T == "string" && (T = { type: "text", value: T }), y.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + t + "fnref-" + m + (d > 1 ? "-" + d : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof r == "string" ? r : r(s, d),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(T) ? T : [T]
      });
    }
    const C = p[p.length - 1];
    if (C && C.type === "element" && C.tagName === "p") {
      const T = C.children[C.children.length - 1];
      T && T.type === "text" ? T.value += " " : C.children.push({ type: "text", value: " " }), C.children.push(...y);
    } else
      p.push(...y);
    const S = {
      type: "element",
      tagName: "li",
      properties: { id: t + "fn-" + m },
      children: e.wrap(p, !0)
    };
    e.patch(c, S), a.push(S);
  }
  if (a.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: l,
          properties: {
            ...wt(o),
            id: "footnote-label"
          },
          children: [{ type: "text", value: i }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(a, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const Ai = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(e) {
    if (e == null)
      return Sc;
    if (typeof e == "function")
      return At(e);
    if (typeof e == "object")
      return Array.isArray(e) ? gc(e) : yc(e);
    if (typeof e == "string")
      return xc(e);
    throw new Error("Expected function, string, or object as test");
  }
);
function gc(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = Ai(e[n]);
  return At(r);
  function r(...i) {
    let l = -1;
    for (; ++l < t.length; )
      if (t[l].apply(this, i)) return !0;
    return !1;
  }
}
function yc(e) {
  const t = (
    /** @type {Record<string, unknown>} */
    e
  );
  return At(n);
  function n(r) {
    const i = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let l;
    for (l in e)
      if (i[l] !== t[l]) return !1;
    return !0;
  }
}
function xc(e) {
  return At(t);
  function t(n) {
    return n && n.type === e;
  }
}
function At(e) {
  return t;
  function t(n, r, i) {
    return !!(bc(n) && e.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      i || void 0
    ));
  }
}
function Sc() {
  return !0;
}
function bc(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const Ri = [], kc = !0, yr = !1, Ec = "skip";
function wc(e, t, n, r) {
  let i;
  typeof t == "function" && typeof n != "function" ? (r = n, n = t) : i = t;
  const l = Ai(i), o = r ? -1 : 1;
  a(e, void 0, [])();
  function a(s, c, p) {
    const h = (
      /** @type {Record<string, unknown>} */
      s && typeof s == "object" ? s : {}
    );
    if (typeof h.type == "string") {
      const d = (
        // `hast`
        typeof h.tagName == "string" ? h.tagName : (
          // `xast`
          typeof h.name == "string" ? h.name : void 0
        )
      );
      Object.defineProperty(m, "name", {
        value: "node (" + (s.type + (d ? "<" + d + ">" : "")) + ")"
      });
    }
    return m;
    function m() {
      let d = Ri, y, b, C;
      if ((!t || l(s, c, p[p.length - 1] || void 0)) && (d = Cc(n(s, p)), d[0] === yr))
        return d;
      if ("children" in s && s.children) {
        const S = (
          /** @type {UnistParent} */
          s
        );
        if (S.children && d[0] !== Ec)
          for (b = (r ? S.children.length : -1) + o, C = p.concat(S); b > -1 && b < S.children.length; ) {
            const T = S.children[b];
            if (y = a(T, b, C)(), y[0] === yr)
              return y;
            b = typeof y[1] == "number" ? y[1] : b + o;
          }
      }
      return d;
    }
  }
}
function Cc(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [kc, e] : e == null ? Ri : [e];
}
function ji(e, t, n, r) {
  let i, l, o;
  typeof t == "function" && typeof n != "function" ? (l = void 0, o = t, i = n) : (l = t, o = n, i = r), wc(e, l, a, i);
  function a(s, c) {
    const p = c[c.length - 1], h = p ? p.children.indexOf(s) : void 0;
    return o(s, h, p);
  }
}
const tn = {}.hasOwnProperty, Tc = {};
function Ic(e, t) {
  const n = t || Tc, r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), l = /* @__PURE__ */ new Map(), o = { ...sc, ...n.handlers }, a = {
    all: c,
    applyData: _c,
    definitionById: r,
    footnoteById: i,
    footnoteCounts: l,
    footnoteOrder: [],
    handlers: o,
    one: s,
    options: n,
    patch: vc,
    wrap: Rc
  };
  return ji(e, function(p) {
    if (p.type === "definition" || p.type === "footnoteDefinition") {
      const h = p.type === "definition" ? r : i, m = String(p.identifier).toUpperCase();
      h.has(m) || h.set(m, p);
    }
  }), a;
  function s(p, h) {
    const m = p.type, d = a.handlers[m];
    if (tn.call(a.handlers, m) && d)
      return d(a, p, h);
    if (a.options.passThrough && a.options.passThrough.includes(m)) {
      if ("children" in p) {
        const { children: b, ...C } = p, S = wt(C);
        return S.children = a.all(p), S;
      }
      return wt(p);
    }
    return (a.options.unknownHandler || Ac)(a, p, h);
  }
  function c(p) {
    const h = [];
    if ("children" in p) {
      const m = p.children;
      let d = -1;
      for (; ++d < m.length; ) {
        const y = a.one(m[d], p);
        if (y) {
          if (d && m[d - 1].type === "break" && (!Array.isArray(y) && y.type === "text" && (y.value = xr(y.value)), !Array.isArray(y) && y.type === "element")) {
            const b = y.children[0];
            b && b.type === "text" && (b.value = xr(b.value));
          }
          Array.isArray(y) ? h.push(...y) : h.push(y);
        }
      }
    }
    return h;
  }
}
function vc(e, t) {
  e.position && (t.position = ca(e));
}
function _c(e, t) {
  let n = t;
  if (e && e.data) {
    const r = e.data.hName, i = e.data.hChildren, l = e.data.hProperties;
    if (typeof r == "string")
      if (n.type === "element")
        n.tagName = r;
      else {
        const o = "children" in n ? n.children : [n];
        n = { type: "element", tagName: r, properties: {}, children: o };
      }
    n.type === "element" && l && Object.assign(n.properties, wt(l)), "children" in n && n.children && i !== null && i !== void 0 && (n.children = i);
  }
  return n;
}
function Ac(e, t) {
  const n = t.data || {}, r = "value" in t && !(tn.call(n, "hProperties") || tn.call(n, "hChildren")) ? { type: "text", value: t.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function Rc(e, t) {
  const n = [];
  let r = -1;
  for (t && n.push({ type: "text", value: `
` }); ++r < e.length; )
    r && n.push({ type: "text", value: `
` }), n.push(e[r]);
  return t && e.length > 0 && n.push({ type: "text", value: `
` }), n;
}
function xr(e) {
  let t = 0, n = e.charCodeAt(t);
  for (; n === 9 || n === 32; )
    t++, n = e.charCodeAt(t);
  return e.slice(t);
}
function Sr(e, t) {
  const n = Ic(e, t), r = n.one(e, void 0), i = mc(n), l = Array.isArray(r) ? { type: "root", children: r } : r || { type: "root", children: [] };
  return i && l.children.push({ type: "text", value: `
` }, i), l;
}
function jc(e, t) {
  return e && "run" in e ? async function(n, r) {
    const i = (
      /** @type {HastRoot} */
      Sr(n, { file: r, ...t })
    );
    await e.run(i, r);
  } : function(n, r) {
    return (
      /** @type {HastRoot} */
      Sr(n, { file: r, ...e || t })
    );
  };
}
function br(e) {
  if (e)
    throw e;
}
var gt = Object.prototype.hasOwnProperty, Pi = Object.prototype.toString, kr = Object.defineProperty, Er = Object.getOwnPropertyDescriptor, wr = function(t) {
  return typeof Array.isArray == "function" ? Array.isArray(t) : Pi.call(t) === "[object Array]";
}, Cr = function(t) {
  if (!t || Pi.call(t) !== "[object Object]")
    return !1;
  var n = gt.call(t, "constructor"), r = t.constructor && t.constructor.prototype && gt.call(t.constructor.prototype, "isPrototypeOf");
  if (t.constructor && !n && !r)
    return !1;
  var i;
  for (i in t)
    ;
  return typeof i > "u" || gt.call(t, i);
}, Tr = function(t, n) {
  kr && n.name === "__proto__" ? kr(t, n.name, {
    enumerable: !0,
    configurable: !0,
    value: n.newValue,
    writable: !0
  }) : t[n.name] = n.newValue;
}, Ir = function(t, n) {
  if (n === "__proto__")
    if (gt.call(t, n)) {
      if (Er)
        return Er(t, n).value;
    } else return;
  return t[n];
}, Pc = function e() {
  var t, n, r, i, l, o, a = arguments[0], s = 1, c = arguments.length, p = !1;
  for (typeof a == "boolean" && (p = a, a = arguments[1] || {}, s = 2), (a == null || typeof a != "object" && typeof a != "function") && (a = {}); s < c; ++s)
    if (t = arguments[s], t != null)
      for (n in t)
        r = Ir(a, n), i = Ir(t, n), a !== i && (p && i && (Cr(i) || (l = wr(i))) ? (l ? (l = !1, o = r && wr(r) ? r : []) : o = r && Cr(r) ? r : {}, Tr(a, { name: n, newValue: e(p, o, i) })) : typeof i < "u" && Tr(a, { name: n, newValue: i }));
  return a;
};
const Ft = /* @__PURE__ */ Br(Pc);
function nn(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function Lc() {
  const e = [], t = { run: n, use: r };
  return t;
  function n(...i) {
    let l = -1;
    const o = i.pop();
    if (typeof o != "function")
      throw new TypeError("Expected function as last argument, not " + o);
    a(null, ...i);
    function a(s, ...c) {
      const p = e[++l];
      let h = -1;
      if (s) {
        o(s);
        return;
      }
      for (; ++h < i.length; )
        (c[h] === null || c[h] === void 0) && (c[h] = i[h]);
      i = c, p ? Oc(p, a)(...c) : o(null, ...c);
    }
  }
  function r(i) {
    if (typeof i != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + i
      );
    return e.push(i), t;
  }
}
function Oc(e, t) {
  let n;
  return r;
  function r(...o) {
    const a = e.length > o.length;
    let s;
    a && o.push(i);
    try {
      s = e.apply(this, o);
    } catch (c) {
      const p = (
        /** @type {Error} */
        c
      );
      if (a && n)
        throw p;
      return i(p);
    }
    a || (s && s.then && typeof s.then == "function" ? s.then(l, i) : s instanceof Error ? i(s) : l(s));
  }
  function i(o, ...a) {
    n || (n = !0, t(o, ...a));
  }
  function l(o) {
    i(null, o);
  }
}
const Se = { basename: Dc, dirname: Nc, extname: Fc, join: Mc, sep: "/" };
function Dc(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  ct(e);
  let n = 0, r = -1, i = e.length, l;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; i--; )
      if (e.codePointAt(i) === 47) {
        if (l) {
          n = i + 1;
          break;
        }
      } else r < 0 && (l = !0, r = i + 1);
    return r < 0 ? "" : e.slice(n, r);
  }
  if (t === e)
    return "";
  let o = -1, a = t.length - 1;
  for (; i--; )
    if (e.codePointAt(i) === 47) {
      if (l) {
        n = i + 1;
        break;
      }
    } else
      o < 0 && (l = !0, o = i + 1), a > -1 && (e.codePointAt(i) === t.codePointAt(a--) ? a < 0 && (r = i) : (a = -1, r = o));
  return n === r ? r = o : r < 0 && (r = e.length), e.slice(n, r);
}
function Nc(e) {
  if (ct(e), e.length === 0)
    return ".";
  let t = -1, n = e.length, r;
  for (; --n; )
    if (e.codePointAt(n) === 47) {
      if (r) {
        t = n;
        break;
      }
    } else r || (r = !0);
  return t < 0 ? e.codePointAt(0) === 47 ? "/" : "." : t === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, t);
}
function Fc(e) {
  ct(e);
  let t = e.length, n = -1, r = 0, i = -1, l = 0, o;
  for (; t--; ) {
    const a = e.codePointAt(t);
    if (a === 47) {
      if (o) {
        r = t + 1;
        break;
      }
      continue;
    }
    n < 0 && (o = !0, n = t + 1), a === 46 ? i < 0 ? i = t : l !== 1 && (l = 1) : i > -1 && (l = -1);
  }
  return i < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
  l === 0 || // The (right-most) trimmed path component is exactly `..`.
  l === 1 && i === n - 1 && i === r + 1 ? "" : e.slice(i, n);
}
function Mc(...e) {
  let t = -1, n;
  for (; ++t < e.length; )
    ct(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
  return n === void 0 ? "." : zc(n);
}
function zc(e) {
  ct(e);
  const t = e.codePointAt(0) === 47;
  let n = Uc(e, !t);
  return n.length === 0 && !t && (n = "."), n.length > 0 && e.codePointAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function Uc(e, t) {
  let n = "", r = 0, i = -1, l = 0, o = -1, a, s;
  for (; ++o <= e.length; ) {
    if (o < e.length)
      a = e.codePointAt(o);
    else {
      if (a === 47)
        break;
      a = 47;
    }
    if (a === 47) {
      if (!(i === o - 1 || l === 1)) if (i !== o - 1 && l === 2) {
        if (n.length < 2 || r !== 2 || n.codePointAt(n.length - 1) !== 46 || n.codePointAt(n.length - 2) !== 46) {
          if (n.length > 2) {
            if (s = n.lastIndexOf("/"), s !== n.length - 1) {
              s < 0 ? (n = "", r = 0) : (n = n.slice(0, s), r = n.length - 1 - n.lastIndexOf("/")), i = o, l = 0;
              continue;
            }
          } else if (n.length > 0) {
            n = "", r = 0, i = o, l = 0;
            continue;
          }
        }
        t && (n = n.length > 0 ? n + "/.." : "..", r = 2);
      } else
        n.length > 0 ? n += "/" + e.slice(i + 1, o) : n = e.slice(i + 1, o), r = o - i - 1;
      i = o, l = 0;
    } else a === 46 && l > -1 ? l++ : l = -1;
  }
  return n;
}
function ct(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const Bc = { cwd: Hc };
function Hc() {
  return "/";
}
function rn(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function $c(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!rn(e)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return qc(e);
}
function qc(e) {
  if (e.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const t = e.pathname;
  let n = -1;
  for (; ++n < t.length; )
    if (t.codePointAt(n) === 37 && t.codePointAt(n + 1) === 50) {
      const r = t.codePointAt(n + 2);
      if (r === 70 || r === 102) {
        const i = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw i.code = "ERR_INVALID_FILE_URL_PATH", i;
      }
    }
  return decodeURIComponent(t);
}
const Mt = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class Li {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let n;
    t ? rn(t) ? n = { path: t } : typeof t == "string" || Vc(t) ? n = { value: t } : n = t : n = {}, this.cwd = "cwd" in n ? "" : Bc.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let r = -1;
    for (; ++r < Mt.length; ) {
      const l = Mt[r];
      l in n && n[l] !== void 0 && n[l] !== null && (this[l] = l === "history" ? [...n[l]] : n[l]);
    }
    let i;
    for (i in n)
      Mt.includes(i) || (this[i] = n[i]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? Se.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(t) {
    Ut(t, "basename"), zt(t, "basename"), this.path = Se.join(this.dirname || "", t);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? Se.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(t) {
    vr(this.basename, "dirname"), this.path = Se.join(t || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? Se.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(t) {
    if (zt(t, "extname"), vr(this.dirname, "extname"), t) {
      if (t.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = Se.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(t) {
    rn(t) && (t = $c(t)), Ut(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? Se.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(t) {
    Ut(t, "stem"), zt(t, "stem"), this.path = Se.join(this.dirname || "", t + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, n, r) {
    const i = this.message(t, n, r);
    throw i.fatal = !0, i;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, n, r) {
    const i = this.message(t, n, r);
    return i.fatal = void 0, i;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, n, r) {
    const i = new se(
      // @ts-expect-error: the overloads are fine.
      t,
      n,
      r
    );
    return this.path && (i.name = this.path + ":" + i.name, i.file = this.path), i.fatal = !1, this.messages.push(i), i;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(t || void 0).decode(this.value);
  }
}
function zt(e, t) {
  if (e && e.includes(Se.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + Se.sep + "`"
    );
}
function Ut(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function vr(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function Vc(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const Yc = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  function(e) {
    const r = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), i = r[e], l = function() {
      return i.apply(l, arguments);
    };
    return Object.setPrototypeOf(l, r), l;
  }
), Gc = {}.hasOwnProperty;
class In extends Yc {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = Lc();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const t = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new In()
    );
    let n = -1;
    for (; ++n < this.attachers.length; ) {
      const r = this.attachers[n];
      t.use(...r);
    }
    return t.data(Ft(!0, {}, this.namespace)), t;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(t, n) {
    return typeof t == "string" ? arguments.length === 2 ? ($t("data", this.frozen), this.namespace[t] = n, this) : Gc.call(this.namespace, t) && this.namespace[t] || void 0 : t ? ($t("data", this.frozen), this.namespace = t, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const t = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [n, ...r] = this.attachers[this.freezeIndex];
      if (r[0] === !1)
        continue;
      r[0] === !0 && (r[0] = void 0);
      const i = n.call(t, ...r);
      typeof i == "function" && this.transformers.use(i);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(t) {
    this.freeze();
    const n = ft(t), r = this.parser || this.Parser;
    return Bt("parse", r), r(String(n), n);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(t, n) {
    const r = this;
    return this.freeze(), Bt("process", this.parser || this.Parser), Ht("process", this.compiler || this.Compiler), n ? i(void 0, n) : new Promise(i);
    function i(l, o) {
      const a = ft(t), s = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        r.parse(a)
      );
      r.run(s, a, function(p, h, m) {
        if (p || !h || !m)
          return c(p);
        const d = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          h
        ), y = r.stringify(d, m);
        Xc(y) ? m.value = y : m.result = y, c(
          p,
          /** @type {VFileWithOutput<CompileResult>} */
          m
        );
      });
      function c(p, h) {
        p || !h ? o(p) : l ? l(h) : n(void 0, h);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(t) {
    let n = !1, r;
    return this.freeze(), Bt("processSync", this.parser || this.Parser), Ht("processSync", this.compiler || this.Compiler), this.process(t, i), Ar("processSync", "process", n), r;
    function i(l, o) {
      n = !0, br(l), r = o;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(t, n, r) {
    _r(t), this.freeze();
    const i = this.transformers;
    return !r && typeof n == "function" && (r = n, n = void 0), r ? l(void 0, r) : new Promise(l);
    function l(o, a) {
      const s = ft(n);
      i.run(t, s, c);
      function c(p, h, m) {
        const d = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          h || t
        );
        p ? a(p) : o ? o(d) : r(void 0, d, m);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(t, n) {
    let r = !1, i;
    return this.run(t, n, l), Ar("runSync", "run", r), i;
    function l(o, a) {
      br(o), i = a, r = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(t, n) {
    this.freeze();
    const r = ft(n), i = this.compiler || this.Compiler;
    return Ht("stringify", i), _r(t), i(t, r);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(t, ...n) {
    const r = this.attachers, i = this.namespace;
    if ($t("use", this.frozen), t != null) if (typeof t == "function")
      s(t, n);
    else if (typeof t == "object")
      Array.isArray(t) ? a(t) : o(t);
    else
      throw new TypeError("Expected usable value, not `" + t + "`");
    return this;
    function l(c) {
      if (typeof c == "function")
        s(c, []);
      else if (typeof c == "object")
        if (Array.isArray(c)) {
          const [p, ...h] = (
            /** @type {PluginTuple<Array<unknown>>} */
            c
          );
          s(p, h);
        } else
          o(c);
      else
        throw new TypeError("Expected usable value, not `" + c + "`");
    }
    function o(c) {
      if (!("plugins" in c) && !("settings" in c))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      a(c.plugins), c.settings && (i.settings = Ft(!0, i.settings, c.settings));
    }
    function a(c) {
      let p = -1;
      if (c != null) if (Array.isArray(c))
        for (; ++p < c.length; ) {
          const h = c[p];
          l(h);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + c + "`");
    }
    function s(c, p) {
      let h = -1, m = -1;
      for (; ++h < r.length; )
        if (r[h][0] === c) {
          m = h;
          break;
        }
      if (m === -1)
        r.push([c, ...p]);
      else if (p.length > 0) {
        let [d, ...y] = p;
        const b = r[m][1];
        nn(b) && nn(d) && (d = Ft(!0, b, d)), r[m] = [c, d, ...y];
      }
    }
  }
}
const Wc = new In().freeze();
function Bt(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function Ht(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function $t(e, t) {
  if (t)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function _r(e) {
  if (!nn(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function Ar(e, t, n) {
  if (!n)
    throw new Error(
      "`" + e + "` finished async. Use `" + t + "` instead"
    );
}
function ft(e) {
  return Qc(e) ? e : new Li(e);
}
function Qc(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function Xc(e) {
  return typeof e == "string" || Jc(e);
}
function Jc(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const Kc = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", Rr = [], jr = { allowDangerousHtml: !0 }, Zc = /^(https?|ircs?|mailto|xmpp)$/i, ep = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function tp(e) {
  const t = e.allowedElements, n = e.allowElement, r = e.children || "", i = e.className, l = e.components, o = e.disallowedElements, a = e.rehypePlugins || Rr, s = e.remarkPlugins || Rr, c = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...jr } : jr, p = e.skipHtml, h = e.unwrapDisallowed, m = e.urlTransform || np, d = Wc().use(Nu).use(s).use(jc, c).use(a), y = new Li();
  typeof r == "string" && (y.value = r);
  for (const T of ep)
    Object.hasOwn(e, T.from) && ("" + T.from + (T.to ? "use `" + T.to + "` instead" : "remove it") + Kc + T.id, void 0);
  const b = d.parse(y);
  let C = d.runSync(b, y);
  return i && (C = {
    type: "element",
    tagName: "div",
    properties: { className: i },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      C.type === "root" ? C.children : [C]
    )
  }), ji(C, S), ma(C, {
    Fragment: f.Fragment,
    // @ts-expect-error
    // React components are allowed to return numbers,
    // but not according to the types in hast-util-to-jsx-runtime
    components: l,
    ignoreInvalidStyle: !0,
    jsx: f.jsx,
    jsxs: f.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function S(T, E, v) {
    if (T.type === "raw" && v && typeof E == "number")
      return p ? v.children.splice(E, 1) : v.children[E] = { type: "text", value: T.value }, E;
    if (T.type === "element") {
      let j;
      for (j in Ot)
        if (Object.hasOwn(Ot, j) && Object.hasOwn(T.properties, j)) {
          const k = T.properties[j], O = Ot[j];
          (O === null || O.includes(T.tagName)) && (T.properties[j] = m(String(k || ""), j, T));
        }
    }
    if (T.type === "element") {
      let j = t ? !t.includes(T.tagName) : o ? o.includes(T.tagName) : !1;
      if (!j && n && typeof E == "number" && (j = !n(T, E, v)), j && v && typeof E == "number")
        return h && T.children ? v.children.splice(E, 1, ...T.children) : v.children.splice(E, 1), E;
    }
  }
}
function np(e) {
  const t = e.indexOf(":"), n = e.indexOf("?"), r = e.indexOf("#"), i = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    t === -1 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    i !== -1 && t > i || n !== -1 && t > n || r !== -1 && t > r || // It is a protocol, it should be allowed.
    Zc.test(e.slice(0, t)) ? e : ""
  );
}
const rp = Tt.p`
  color: ${({ theme: e }) => e.palette.textColor.label};
  font-size: 12px;
`, ip = Tt.a`
  color: ${({ theme: e }) => e.palette.primary.main};
  font-weight: bold;
  font-size: 12px;
`, lp = (e) => e.filter((t) => t.analysisTypes.includes("STRATEGUS")), op = on((e) => {
  const { studyTypes: t, onClose: n, onFinish: r } = e, [i, l] = J(!1), [o, a] = J(!1), [s, c] = J(), [p, h] = J(), [m, d] = J(), { enqueueSnackbar: y } = Ct(), b = Ae(async () => {
    l(!0);
    try {
      let T = new FormData();
      T.append("file", m);
      const E = await K.post(
        `/studies/strategus/create?type=${s}`,
        T
      );
      r(E), y({
        message: "Study created successfully",
        variant: "success"
      }), l(!1);
    } catch {
      l(!1), y({
        message: "Study was not created",
        variant: "error"
      });
    }
  }, [p, s]), C = (T) => {
    try {
      if (T) {
        const E = JSON.parse(T);
        h(E), a(!1);
      } else
        h(void 0), a(!1);
    } catch {
      a(!0);
    }
  }, S = at(() => !o && p && s, [p, o, s]);
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx(H, { item: !0, xs: 6, children: /* @__PURE__ */ f.jsx(et, { name: "type", textLabel: "Type", required: !0, children: /* @__PURE__ */ f.jsx(
      it,
      {
        className: "",
        name: "type",
        fullWidth: !0,
        id: "type",
        options: lp(t),
        value: s,
        placeholder: "Select type",
        onChange: (T, E) => {
          c(E.id);
        },
        getOptionLabel: (T) => T.name
      }
    ) }) }),
    /* @__PURE__ */ f.jsx(H, { item: !0, xs: 12, children: /* @__PURE__ */ f.jsx(
      pl,
      {
        titleButton: "Upload json",
        onChange: (T, E) => {
          h(T), d(E);
        }
      }
    ) }),
    /* @__PURE__ */ f.jsx(H, { item: !0, xs: 12, children: /* @__PURE__ */ f.jsx(
      dl,
      {
        data: p || "",
        height: "63vh",
        fileName: `Study.${Date.now()}`,
        language: Gi(Nn.JSON),
        onChange: C,
        readOnly: !0,
        fileExtension: Nn.JSON,
        contentType: hl.APPLICATION_JSON
      }
    ) }),
    o && /* @__PURE__ */ f.jsx(H, { item: !0, xs: 12, children: /* @__PURE__ */ f.jsx(ve, { fontSize: 14, fontWeight: 700, color: "#FF335B", children: "Invalid json" }) }),
    /* @__PURE__ */ f.jsx(H, { item: !0, xs: 12, children: /* @__PURE__ */ f.jsxs(Nr, { children: [
      /* @__PURE__ */ f.jsx(
        ke,
        {
          variant: "outlined",
          onClick: n,
          startIcon: /* @__PURE__ */ f.jsx(Fe, { iconName: "deactivate" }),
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ f.jsx(
        ke,
        {
          disabled: i || !S,
          onClick: b,
          variant: "contained",
          color: "success",
          startIcon: i ? /* @__PURE__ */ f.jsx(st, { size: 16 }) : /* @__PURE__ */ f.jsx(Fe, { iconName: "submit" }),
          children: "Create"
        }
      )
    ] }) })
  ] });
});
var yt = /* @__PURE__ */ ((e) => (e.PROMETHEUS = "PROMETHEUS", e.STRATEGUS = "STRATEGUS", e))(yt || {});
const ap = (e) => [
  {
    value: "PROMETHEUS",
    title: "New study",
    onTabClick: e
  },
  {
    value: "STRATEGUS",
    title: "OHDSI Strategus Study",
    onTabClick: e
  }
], Oi = on((e) => {
  var O, $, F, z, A, _, q, Y, D, te, ee, oe;
  const { onClose: t, onSubmit: n, createMethod: r, studyTypes: i } = e, [l, o] = J(!1), [a, s] = J({
    title: "",
    type: null,
    requireUserConsent: !1,
    requireUserConsentMessage: "",
    studyId: ""
  }), { enqueueSnackbar: c } = Ct(), [p, h] = J(
    yt.PROMETHEUS
  ), { settings: m } = Vt(
    (P) => P.user.data
  ), d = ($ = (O = m == null ? void 0 : m["external-study"]) == null ? void 0 : O.autocomplete) == null ? void 0 : $.enabled, y = (z = (F = m == null ? void 0 : m.features) == null ? void 0 : F.studyId) == null ? void 0 : z.enabled, b = (_ = (A = m == null ? void 0 : m.features) == null ? void 0 : A.studyId) == null ? void 0 : _.fieldLabel, C = (Y = (q = m == null ? void 0 : m.features) == null ? void 0 : q.studyId) == null ? void 0 : Y.autocomplete, S = (te = (D = m == null ? void 0 : m.features) == null ? void 0 : D.studyId) == null ? void 0 : te.autocompleteHint;
  function T(P) {
    return /* @__PURE__ */ f.jsx(ip, { href: P.href, target: "_blank", rel: "noreferrer", children: P.children });
  }
  const { state: E, status: v } = d && C ? Ol(uo, "") : { state: [], status: "" }, j = {
    ERROR_CREATE_STUDY: "Something went wrong. Try again.",
    SUCCESS_CREATE_STUDY: "Study created successfully",
    ERROR_GET_STUDY_TYPES: "Couldn't get Study Types"
  }, k = Ae(async () => {
    o(!0);
    try {
      const P = await r({
        title: a.title,
        type: { id: a.type.id },
        studyId: a.studyId
      });
      n(P), c({
        message: j.SUCCESS_CREATE_STUDY,
        variant: "success"
      });
    } catch (P) {
      c({
        message: j.ERROR_CREATE_STUDY,
        variant: "error"
      }), console.error("STUDY CREATE ERROR", P);
    }
    o(!1);
  }, [a]);
  return ae(() => {
    var P;
    (P = a.type) != null && P.consent ? Gr(a.type.id).then((u) => {
      s((R) => ({
        ...R,
        requireUserConsentMessage: u.text
      }));
    }) : s((u) => ({
      ...u,
      requireUserConsentMessage: ""
    }));
  }, [a.type]), /* @__PURE__ */ f.jsx(H, { container: !0, p: 2, children: /* @__PURE__ */ f.jsxs(tl, { children: [
    /* @__PURE__ */ f.jsx(
      cn,
      {
        tabs: ap(h),
        active: p,
        secondary: !0
      }
    ),
    /* @__PURE__ */ f.jsx(sn, {}),
    l ? /* @__PURE__ */ f.jsx(fl, {}) : /* @__PURE__ */ f.jsxs(H, { container: !0, spacing: 2, p: 2, children: [
      p == yt.PROMETHEUS && /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
        /* @__PURE__ */ f.jsx(H, { item: !0, xs: 12, children: /* @__PURE__ */ f.jsx(et, { name: "title", textLabel: "Title", required: !0, children: /* @__PURE__ */ f.jsx(
          xt,
          {
            id: "title",
            name: "title",
            type: "text",
            size: "medium",
            placeholder: "Enter title",
            value: a.title,
            onChange: (P) => {
              s((u) => ({ ...u, title: P.target.value }));
            },
            fullWidth: !0,
            required: !0
          }
        ) }) }),
        /* @__PURE__ */ f.jsx(H, { item: !0, xs: 6, children: /* @__PURE__ */ f.jsx(et, { name: "type", textLabel: "Type", required: !0, children: /* @__PURE__ */ f.jsx(
          it,
          {
            className: "",
            name: "type",
            fullWidth: !0,
            id: "type",
            options: i,
            value: a.type,
            placeholder: "Select type",
            onChange: (P, u) => {
              s((R) => ({ ...R, type: u }));
            },
            getOptionLabel: (P) => P.name
          }
        ) }) }),
        y && /* @__PURE__ */ f.jsxs(H, { item: !0, xs: 12, children: [
          /* @__PURE__ */ f.jsx(
            et,
            {
              name: "studyId",
              textLabel: b ?? "Study ID",
              required: !0,
              children: d && C ? /* @__PURE__ */ f.jsx(
                it,
                {
                  name: "studyId",
                  id: "studyId",
                  options: E || [],
                  getOptionDisabled: (P) => !P.accessibleByCurrentUser,
                  getOptionLabel: (P) => {
                    if (typeof P == "string") {
                      const u = E == null ? void 0 : E.find(
                        (R) => R.id === P
                      );
                      return u ? u.id : "";
                    } else
                      return P ? P.id : "";
                  },
                  value: a.studyId || null,
                  placeholder: "Select study...",
                  fullWidth: !0,
                  isOptionEqualToValue: (P, u) => P.id === u,
                  onChange: (P, u) => {
                    const R = i.find(
                      (U) => U.name === (u == null ? void 0 : u.type)
                    );
                    s((U) => ({
                      ...U,
                      studyId: u == null ? void 0 : u.id,
                      title: u == null ? void 0 : u.name,
                      type: R || null
                    }));
                  },
                  filterOptions: {
                    stringify: (P) => P.id + P.name + P.author
                  },
                  OptionComponent: (P, u, { selected: R }) => /* @__PURE__ */ f.jsx(
                    Dr,
                    {
                      text: /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
                        /* @__PURE__ */ f.jsx("strong", { children: "ID:" }),
                        " ",
                        u.id,
                        " ",
                        /* @__PURE__ */ f.jsx("br", {}),
                        /* @__PURE__ */ f.jsx("strong", { children: "Type:" }),
                        " ",
                        u.type,
                        " ",
                        /* @__PURE__ */ f.jsx("br", {}),
                        /* @__PURE__ */ f.jsx("strong", { children: "Name:" }),
                        " ",
                        u.name,
                        " ",
                        /* @__PURE__ */ f.jsx("br", {}),
                        /* @__PURE__ */ f.jsx("strong", { children: "Author:" }),
                        " ",
                        u.author,
                        " ",
                        /* @__PURE__ */ f.jsx("br", {}),
                        /* @__PURE__ */ f.jsx("strong", { children: "Created:" }),
                        " ",
                        u.createdDate
                      ] }),
                      children: /* @__PURE__ */ f.jsxs(qt, { ...P, children: [
                        /* @__PURE__ */ f.jsx(H, { item: !0, xs: 2, children: /* @__PURE__ */ f.jsx("strong", { children: u.id }) }),
                        /* @__PURE__ */ f.jsx(
                          H,
                          {
                            item: !0,
                            xs: 8,
                            sx: {
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis"
                            },
                            children: /* @__PURE__ */ f.jsx("strong", { children: u.name })
                          }
                        ),
                        /* @__PURE__ */ f.jsx(H, { item: !0, xs: 2, children: u.author })
                      ] })
                    },
                    P.key
                  )
                }
              ) : /* @__PURE__ */ f.jsx(
                xt,
                {
                  id: "studyId",
                  name: "studyId",
                  type: "text",
                  size: "medium",
                  placeholder: "Enter Study ID",
                  value: a.studyId,
                  onChange: (P) => {
                    s((u) => ({
                      ...u,
                      studyId: P.target.value
                    }));
                  },
                  fullWidth: !0,
                  required: !0
                }
              )
            }
          ),
          /* @__PURE__ */ f.jsx(
            tp,
            {
              components: {
                a: T,
                p: rp
              },
              children: S
            }
          )
        ] }),
        ((ee = a.type) == null ? void 0 : ee.consent) && /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
          /* @__PURE__ */ f.jsx(H, { item: !0, xs: 12, children: /* @__PURE__ */ f.jsx(et, { name: "consent", textLabel: "Consent Form", children: /* @__PURE__ */ f.jsx(
            nl,
            {
              id: "consent",
              name: "consent",
              value: a.requireUserConsentMessage,
              onChange: (P) => {
                s((u) => ({
                  ...u,
                  requireUserConsentMessage: P
                }));
              },
              maxRows: 25,
              minRows: 5,
              readOnly: !0,
              disableHorizontalResize: !0,
              placeholder: "Enter consent form"
            },
            a.requireUserConsentMessage
          ) }) }),
          /* @__PURE__ */ f.jsx(H, { item: !0, xs: 12, children: /* @__PURE__ */ f.jsxs("label", { children: [
            /* @__PURE__ */ f.jsx(
              rl,
              {
                name: "createNew",
                onChange: () => {
                  s((P) => ({
                    ...P,
                    requireUserConsent: !P.requireUserConsent
                  }));
                },
                checked: a.requireUserConsent
              }
            ),
            /* @__PURE__ */ f.jsx(ve, { sx: { ml: 1 }, variant: "caption", children: "I confirm that I have read, understood, and will follow the agreement outlined in the consent form." })
          ] }) })
        ] }),
        /* @__PURE__ */ f.jsx(H, { item: !0, xs: 12, children: /* @__PURE__ */ f.jsxs(Nr, { children: [
          /* @__PURE__ */ f.jsx(
            ke,
            {
              variant: "outlined",
              disabled: l,
              onClick: t,
              startIcon: /* @__PURE__ */ f.jsx(Fe, { iconName: "deactivate" }),
              name: "cancel",
              children: "Cancel"
            }
          ),
          /* @__PURE__ */ f.jsx(
            ke,
            {
              disabled: l || !a.title || !a.type || y && !a.studyId || ((oe = a.type) == null ? void 0 : oe.consent) && !a.requireUserConsent,
              onClick: k,
              variant: "contained",
              color: "success",
              startIcon: /* @__PURE__ */ f.jsx(Fe, { iconName: "submit" }),
              name: "save",
              children: "Create"
            }
          )
        ] }) })
      ] }),
      p == yt.STRATEGUS && /* @__PURE__ */ f.jsx(
        op,
        {
          studyTypes: i,
          onFinish: n
        }
      )
    ] })
  ] }) });
}), Di = (e) => {
  const t = Ve(), { openModal: n, closeModal: r } = Ne(zr), { types: i } = Wr(), l = () => {
    n(
      () => /* @__PURE__ */ f.jsx(
        Oi,
        {
          studyTypes: i,
          createMethod: Vr,
          onSubmit: (o) => {
            const a = pn(o);
            a && Hr(() => {
              t(`/study-manager/${a}`);
            }), r();
          },
          onClose: r
        }
      ),
      "Create study",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: r
      }
    );
  };
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsx(
    ke,
    {
      onClick: () => l(),
      variant: "contained",
      color: "info",
      startIcon: /* @__PURE__ */ f.jsx(Fe, { iconName: "add" }),
      name: "save",
      children: "Create"
    }
  ) });
}, sp = (e) => {
  const t = Ve();
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsx(
    ml,
    {
      title: "Studies",
      onClick: () => t("/study-manager"),
      description: `
        Studies are projects that allow a group of people to 
        collaborate on scientific research and store 
        all study related artifacts, designs, analysis and outcomes.`,
      iconName: "study",
      actions: /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
        /* @__PURE__ */ f.jsx(Di, {}),
        /* @__PURE__ */ f.jsx(
          ke,
          {
            onClick: () => t("/study-manager"),
            variant: "outlined",
            name: "save",
            sx: { ml: 1 },
            children: "View all"
          }
        )
      ] }),
      children: /* @__PURE__ */ f.jsx(H, { item: !0, xs: 12, container: !0, pt: 2, children: /* @__PURE__ */ f.jsx(Jr, {}) })
    }
  ) });
}, up = 120, cp = "__load_more_studies__", pp = ({ onChange: e, studyInitialId: t }) => {
  const {
    studies: n,
    status: r,
    currentStudy: i,
    setCurrentStudy: l,
    loadMore: o,
    hasMore: a,
    isLoadingMore: s,
    searchTerm: c,
    setSearchTerm: p
  } = xo(t), h = at(() => {
    const d = n;
    return !s && !a ? d : [
      ...d,
      {
        id: cp,
        title: s ? "Loading more studies..." : "Scroll to load more",
        __meta: "load-more"
      }
    ];
  }, [n, s, a]), m = Ae(
    (d) => {
      const y = d.currentTarget;
      y.scrollHeight - y.scrollTop - y.clientHeight <= up && a && o();
    },
    [a, o]
  );
  return /* @__PURE__ */ f.jsx(
    it,
    {
      className: "",
      name: "user-studies",
      id: "user-studies",
      value: i,
      placeholder: r === Z.IN_PROGRESS ? "Loading study list..." : "Select study...",
      fullWidth: !0,
      isOptionEqualToValue: (d, y) => d.id === (y == null ? void 0 : y.id),
      ListboxProps: {
        onScroll: m,
        sx: {
          pb: 0
        }
      },
      options: h,
      getOptionDisabled: (d) => d.__meta === "load-more",
      filterOptions: (d) => d,
      OptionComponent: (d, y) => y.__meta === "load-more" ? /* @__PURE__ */ f.jsxs(
        qt,
        {
          component: "li",
          ...d,
          sx: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
            py: 1.5,
            px: 2,
            position: "sticky",
            bottom: 0,
            minHeight: 48,
            backgroundColor: "#ffffff",
            borderTop: "1px solid",
            borderColor: "#d7e3f4",
            boxShadow: "0 -4px 12px rgba(13, 27, 64, 0.08)",
            zIndex: 2,
            pointerEvents: "none",
            opacity: "1 !important",
            ".MuiTypography-root": {
              opacity: "1 !important"
            }
          },
          children: [
            s && /* @__PURE__ */ f.jsx(st, { size: 16 }),
            /* @__PURE__ */ f.jsx(
              ve,
              {
                variant: "body2",
                sx: {
                  color: "text.secondary",
                  fontWeight: 600,
                  lineHeight: 1.2
                },
                children: y.title
              }
            )
          ]
        }
      ) : /* @__PURE__ */ f.jsx(qt, { component: "li", ...d, children: y.title }),
      onChange: function(d, y) {
        !y || y.__meta === "load-more" || (l(y), e(y));
      },
      getOptionKey: (d) => d.id,
      loading: r === Z.IN_PROGRESS || s,
      loadingText: "Loading study list...",
      onInputChange: (d) => {
        const y = d.target.value;
        y !== c && p(y);
      },
      getOptionLabel: (d) => d.title || ""
    }
  );
}, dp = on((e) => {
  const { name: t, path: n, config: r } = e;
  return /* @__PURE__ */ f.jsxs(ot.Fragment, { children: [
    t === "user-studies-list" && /* @__PURE__ */ f.jsx(
      pp,
      {
        onChange: r.onChange,
        studyInitialId: r.studyInitialId
      }
    ),
    t === "studies-list-select" && /* @__PURE__ */ f.jsx(
      So,
      {
        onChange: r.onChange,
        studyInitialId: r.studyInitialId,
        analysisMode: r.analysisMode,
        pureControl: r.pureControl,
        config: {}
      }
    ),
    t === "studies-list-favorites" && /* @__PURE__ */ f.jsx(Jr, {}),
    t === "create-study-button" && /* @__PURE__ */ f.jsx(Di, {}),
    t === "home-study" && /* @__PURE__ */ f.jsx(sp, { ...e })
  ] });
}), hp = {
  createCrudEntity: (e, t) => Wi(
    e,
    t,
    Wl,
    qr,
    Xl
  )
}, fp = (e, t) => [
  { title: "Study", value: "", iconName: "study", end: !0 },
  // this is needed to exact match specific paths
  {
    title: /* @__PURE__ */ f.jsx(
      He,
      {
        count: e == null ? void 0 : e.conceptSets,
        status: t,
        title: "Concept Sets"
      }
    ),
    value: "concept-sets",
    iconName: "conceptSets"
  },
  {
    title: /* @__PURE__ */ f.jsx(
      He,
      {
        count: e == null ? void 0 : e.cohorts,
        status: t,
        title: "Cohorts"
      }
    ),
    value: "cohorts",
    iconName: "cohort"
  },
  {
    title: /* @__PURE__ */ f.jsx(
      He,
      {
        count: e == null ? void 0 : e.analyses,
        status: t,
        title: "Analytics"
      }
    ),
    value: "analyses",
    iconName: "analysis"
  }
], mp = {
  messages: {
    confirmDeleteMessage: "Are you sure you want to delete this study?"
  }
}, gp = {
  entityBreadcrumb: (e, t, n) => [
    {
      name: "Studies",
      path: `/${e}`
    },
    {
      name: n == null ? void 0 : n.title,
      path: `/${e}/${t}`
    }
  ]
}, yp = (e, t, n) => [
  {
    title: /* @__PURE__ */ f.jsx(
      He,
      {
        title: "Participants",
        count: t == null ? void 0 : t.participants,
        status: n
      }
    ),
    value: "participants",
    iconName: "participants",
    onTabClick: e
  },
  {
    title: /* @__PURE__ */ f.jsx(
      He,
      {
        title: "Data Sources",
        count: t == null ? void 0 : t.datasources,
        status: n
      }
    ),
    value: "data-sources",
    iconName: "dataSources",
    onTabClick: e
  },
  {
    title: /* @__PURE__ */ f.jsx(
      He,
      {
        title: "Documents",
        count: t == null ? void 0 : t.documents,
        status: n
      }
    ),
    value: "documents",
    iconName: "documents",
    onTabClick: e
  }
], xp = {
  fields: [],
  status: Z.INITIAL
}, Sp = (e, t) => an(e, (n) => {
  switch (t.type) {
    case "GET_LIST":
      n.status = Z.IN_PROGRESS;
      break;
    case "GET_LIST_DONE":
      n.status = Z.SUCCESS, n.fields = t.payload;
      break;
    case "CREATE_FIELD":
      n.fields.push(t.payload);
      break;
    case "CREATE_FIELD_DONE":
      n.fields.splice(n.fields.length - 1, 1, t.payload);
      break;
    case "UPDATE_FIELD":
      n.fields.splice(t.payload.index, 1, t.payload.field);
      break;
    case "DELETE_FIELD":
      n.fields.splice(t.payload, 1);
      break;
  }
}), bp = (e) => {
  const [t, n] = ln(Sp, xp), r = Ae(async () => {
    n({
      type: "GET_LIST"
      /* GET_LIST */
    });
    try {
      const a = await ro(e);
      n({
        type: "GET_LIST_DONE",
        payload: a
      });
    } catch {
    }
  }, []), i = async (a) => {
    n({
      type: "CREATE_FIELD",
      payload: a
    });
    try {
      const s = await io(e, a);
      n({
        type: "CREATE_FIELD_DONE",
        payload: s
      });
    } catch (s) {
      console.log(s);
    }
  }, l = async (a, s) => {
    n({
      type: "UPDATE_FIELD",
      payload: {
        index: a,
        field: s
      }
    });
    try {
      await lo(e, s.id, s);
    } catch (c) {
      console.log(c);
    }
  }, o = async (a, s) => {
    n({
      type: "DELETE_FIELD",
      payload: a
    });
    try {
      await oo(e, s.id);
    } catch (c) {
      console.log(c);
    }
  };
  return ae(() => {
    r();
  }, []), {
    ...t,
    createField: i,
    updateField: l,
    removeField: o
  };
}, kp = Tt.div`
  position: relative;
  padding: 6px;
  border-radius: 4px;

  &:hover {
    background: ${({ theme: e, viewMode: t }) => t ? "teansparent" : e.palette.backgroundColor.dark};

    .close-button-hover {
      visibility: visible;
    }
  }
  p.link {
    text-overflow: ellipsis;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
  }

  .regular-link {
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
`, Ep = Tt.div`
  visibility: hidden;
  position: absolute;
  top: 0;
  right: 0;
`, wp = (e) => {
  const { studyId: t, viewMode: n } = e;
  zl();
  const [r, i] = ot.useState(null), [l, o] = J(null), a = !!r, { fields: s, createField: c, updateField: p, removeField: h } = bp(t), m = (C) => {
    C.stopPropagation(), i(C.currentTarget);
  }, d = () => {
    i(null);
  }, y = () => {
    l.id ? p(l.index, l) : c(l), o(null), d();
  }, b = (C) => {
    let S;
    try {
      S = new URL(C);
    } catch {
      return !1;
    }
    return S.protocol === "http:" || S.protocol === "https:";
  };
  return /* @__PURE__ */ f.jsxs(H, { container: !0, spacing: 1, p: 1, children: [
    !n && /* @__PURE__ */ f.jsx(H, { item: !0, xs: 12, textAlign: "right", mt: 1, children: /* @__PURE__ */ f.jsx(
      ke,
      {
        onClick: (C) => {
          o(null), m(C);
        },
        className: "create-field",
        size: "small",
        startIcon: /* @__PURE__ */ f.jsx(Fe, { iconName: "add" }),
        color: "info",
        children: "Create New Field"
      }
    ) }),
    s == null ? void 0 : s.map((C, S) => {
      const T = b(C.value);
      return /* @__PURE__ */ f.jsx(H, { item: !0, xs: 6, children: /* @__PURE__ */ f.jsxs(kp, { viewMode: n, children: [
        /* @__PURE__ */ f.jsx(ve, { variant: "subtitle1", component: "label", children: C.name }),
        /* @__PURE__ */ f.jsx(Dr, { text: T ? C.value : "", children: /* @__PURE__ */ f.jsx(
          ve,
          {
            variant: "body2",
            component: "p",
            className: T ? "link" : "",
            children: T ? /* @__PURE__ */ f.jsx(
              "a",
              {
                className: "regular-link",
                href: C.value,
                target: "_blank",
                children: C.value
              }
            ) : C.value
          }
        ) }),
        !n && /* @__PURE__ */ f.jsxs(Ep, { className: "close-button-hover", children: [
          /* @__PURE__ */ f.jsx(
            gl,
            {
              iconSize: 14,
              onEdit: (E) => {
                o({ ...C, index: S }), m(E);
              }
            }
          ),
          /* @__PURE__ */ f.jsx(
            yl,
            {
              iconSize: 14,
              onRemove: () => {
                h(S, C);
              },
              withConfirmation: !0,
              confirmationMessage: "Are you sure?"
            }
          )
        ] })
      ] }) });
    }),
    /* @__PURE__ */ f.jsx(
      il,
      {
        id: "popover",
        anchorEl: r,
        open: a,
        onClose: d,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "right"
        },
        sx: { ".MuiPaper-root": { ml: 3 } },
        children: /* @__PURE__ */ f.jsx(ll, { className: "invitations-list", children: /* @__PURE__ */ f.jsxs(H, { container: !0, p: 2, spacing: 2, children: [
          /* @__PURE__ */ f.jsxs(H, { item: !0, xs: 12, children: [
            /* @__PURE__ */ f.jsx(ve, { variant: "subtitle1", component: "label", children: "Title" }),
            /* @__PURE__ */ f.jsx(
              xt,
              {
                id: "title",
                name: "title",
                type: "text",
                size: "medium",
                placeholder: "Enter name",
                value: l == null ? void 0 : l.name,
                onChange: (C) => {
                  o((S) => ({
                    ...S,
                    name: C.target.value
                  }));
                },
                fullWidth: !0
              }
            )
          ] }),
          /* @__PURE__ */ f.jsxs(H, { item: !0, xs: 12, children: [
            /* @__PURE__ */ f.jsx(ve, { variant: "subtitle1", component: "label", children: "Value" }),
            /* @__PURE__ */ f.jsx(
              xt,
              {
                id: "value",
                name: "value",
                type: "text",
                size: "medium",
                placeholder: "Enter value",
                value: l == null ? void 0 : l.value,
                onChange: (C) => {
                  o((S) => ({
                    ...S,
                    value: C.target.value
                  }));
                },
                fullWidth: !0
              }
            )
          ] }),
          /* @__PURE__ */ f.jsx(H, { item: !0, xs: 12, children: /* @__PURE__ */ f.jsx(
            ke,
            {
              onClick: y,
              variant: "contained",
              size: "small",
              color: "success",
              startIcon: /* @__PURE__ */ f.jsx(Fe, { iconName: "submit" }),
              name: "save",
              disabled: !(l != null && l.name) || !(l != null && l.value),
              children: "Save"
            }
          ) })
        ] }) })
      }
    )
  ] });
}, Cp = (e) => {
  const { id: t, entity: n, actions: r, updateEntity: i, summary: l, summaryStatus: o } = e;
  Ve();
  const a = Mr(), [s, c] = J("participants"), { showDialog: p, hideDialog: h } = Ne(Ur), { subModules: m, path: d, config: y } = Ne(
    Rt
  ), { entityBreadcrumb: b } = gp, C = ot.useMemo(
    () => yp(c, l, o),
    [l, o]
  ), S = !r.update || r["consent.accept"];
  return ae(() => (n && a(Nl(b(d, t, n))), () => {
    a(Fl());
  }), [n]), /* @__PURE__ */ f.jsxs(xl, { children: [
    /* @__PURE__ */ f.jsx(H, { item: !0, xs: 6, md: 6.5, lg: 7, xl: 8, p: 3, pl: 6, children: /* @__PURE__ */ f.jsxs(H, { container: !0, spacing: 2, children: [
      /* @__PURE__ */ f.jsx(
        Sl,
        {
          entity: n,
          actions: r,
          studyTypes: y.studyTypes,
          onSubmit: i
        }
      ),
      /* @__PURE__ */ f.jsx(wp, { studyId: t, viewMode: S }),
      /* @__PURE__ */ f.jsx(bl, { getList: () => no(t) })
    ] }) }),
    /* @__PURE__ */ f.jsx(
      H,
      {
        item: !0,
        xs: 6,
        md: 5.5,
        lg: 5,
        xl: 4,
        p: 3,
        pr: 6,
        bgcolor: "backgroundColor.dark",
        children: /* @__PURE__ */ f.jsxs(ol, { elevation: 0, sx: { minHeight: 300 }, children: [
          /* @__PURE__ */ f.jsx(cn, { secondary: !0, active: s, tabs: C }),
          /* @__PURE__ */ f.jsx(sn, {}),
          s === "participants" && /* @__PURE__ */ f.jsx(
            m.users,
            {
              type: "component",
              name: "widget-info",
              path: `/${d}/${t}/participants`,
              subModules: m,
              viewMode: S,
              config: {
                parentId: t,
                typeContainer: Ie.STUDY
              }
            }
          ),
          s === "data-sources" && /* @__PURE__ */ f.jsx(
            m.datasources,
            {
              type: "component",
              name: "widget-info",
              path: `/${d}/${t}/datasource`,
              subModules: m,
              viewMode: S,
              config: {
                parentId: t,
                typeContainer: Ie.STUDY
              }
            }
          ),
          s === "documents" && /* @__PURE__ */ f.jsx(
            m.documents,
            {
              type: "component",
              name: "widget-info",
              path: `/${d}/${t}/documents`,
              subModules: m,
              viewMode: S,
              config: {
                parentId: t,
                typeContainer: Ie.STUDY
              }
            }
          )
        ] })
      }
    )
  ] });
}, Tp = ({ parentId: e, parentName: t, isFavorite: n, size: r, viewMode: i = !1 }) => {
  const [l, o] = J(n), { enqueueSnackbar: a } = Ct(), s = (p) => ({
    success: /* @__PURE__ */ f.jsxs("span", { children: [
      /* @__PURE__ */ f.jsxs("b", { children: [
        " ",
        t || "Study",
        " "
      ] }),
      p ? /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
        "was successfully marked as ",
        /* @__PURE__ */ f.jsx("b", { children: "favorite" })
      ] }) : /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
        "was successfully ",
        /* @__PURE__ */ f.jsx("b", { children: "removed from favorites" })
      ] })
    ] }),
    error: "Something went wrong, try again"
  }), c = async () => {
    try {
      const p = { favorite: !l };
      await Yr(e, p), o(p.favorite), a({
        message: s(p.favorite).success
      });
    } catch (p) {
      a({
        message: s().error,
        variant: "error"
      }), console.error("ERROR ADDING TO FAVORITE", p);
    }
  };
  return ae(() => {
    o(n);
  }, [n]), /* @__PURE__ */ f.jsx(
    un,
    {
      isFavorite: l,
      onClick: c,
      size: r,
      viewMode: i
    }
  );
}, Ip = () => {
  const { id: e } = Pl(), t = Mr(), n = Ve(), r = Vt((D) => D.invitations.count), [i, l] = J(!1), { path: o, subModules: a, initStorage: s, storage: c, config: p, rootSettings: h } = Ne(
    Rt
  ), { showDialog: m, hideDialog: d } = Ne(Ur), { data: y, status: b } = Vt(
    (D) => D.summary
  );
  ae(() => {
    e && t(Fn(Ie.STUDY, e));
  }, [e, r]), ae(() => () => {
    t(Ml());
  }, []);
  const { createCrudEntity: C } = hp, { messages: S } = mp, T = at(() => C(null, null), []), {
    status: E,
    entity: v,
    actions: j,
    deleteEntity: k,
    updateEntity: O,
    noPersistUpdate: $,
    error: F,
    getEntity: z
  } = Dl(
    {
      get: T.getMethod,
      delete: T.deleteMethod,
      update: T.upsertMethod
    },
    e,
    "Study"
  ), A = j && j["consent.accept"] && (j.update || (v == null ? void 0 : v.myRoles.includes("Data Set Owner")) || (v == null ? void 0 : v.myRoles.includes("Contributor")) || (v == null ? void 0 : v.myRoles.includes("Lead Investigator"))), _ = () => {
    m(Il, {
      onSubmit: async () => {
        await k(), t(Fn(Ie.STUDY, e)), n("..");
      },
      onClose: d,
      text: S.confirmDeleteMessage,
      confirmButtonText: "DELETE",
      variant: "error"
    });
  }, q = () => {
    Gr(v == null ? void 0 : v.type.id).then((D) => {
      m(Tl, {
        onSubmit: async () => {
          try {
            await Jl(v == null ? void 0 : v.id, v == null ? void 0 : v.type.consent), n(location.pathname, { replace: !0 }), l(!1), $({
              ...v,
              actions: {
                ...j,
                consent: { accept: !1 }
              }
            });
          } catch {
          }
        },
        onClose: () => {
          d(), l(!0);
        },
        text: D.text
      });
    });
  }, Y = ot.useMemo(
    () => fp(y, b),
    [y, b]
  );
  return ae(() => {
    A && q();
  }, [A]), ae(() => () => {
    d();
  }, []), E === Z.INITIAL || E === Z.IN_PROGRESS ? /* @__PURE__ */ f.jsx(St, { children: /* @__PURE__ */ f.jsx(st, { size: 32 }) }) : E === Z.ERROR ? /* @__PURE__ */ f.jsx(St, { children: /* @__PURE__ */ f.jsx(kl, { ...F == null ? void 0 : F.response, path: o }) }) : v ? /* @__PURE__ */ f.jsxs(El, { children: [
    /* @__PURE__ */ f.jsxs(wl, { children: [
      /* @__PURE__ */ f.jsx(
        Cl,
        {
          entity: v,
          actions: j,
          onDelete: _,
          onSubmit: O,
          alerts: i ? /* @__PURE__ */ f.jsxs(al, { severity: "error", sx: { py: 0, height: 36 }, children: [
            "This study type requires participants to accept consent form to be able to make any changes.",
            /* @__PURE__ */ f.jsx(ke, { size: "small", color: "error", onClick: q, children: "Click here" }),
            " ",
            "to see the consent form."
          ] }) : void 0,
          AdditionalActions: /* @__PURE__ */ f.jsx(
            Tp,
            {
              isFavorite: v.favorite,
              parentId: e,
              parentName: v.title
            }
          )
        }
      ),
      /* @__PURE__ */ f.jsx(sn, {}),
      /* @__PURE__ */ f.jsx(cn, { tabs: Y, withRouting: !0 })
    ] }),
    /* @__PURE__ */ f.jsxs(Fr, { children: [
      /* @__PURE__ */ f.jsx(
        Pe,
        {
          path: "analyses/*",
          element: /* @__PURE__ */ f.jsx(
            a.analyses,
            {
              name: "analyses",
              iconName: "analyses",
              path: `${o}/${e}/analyses`,
              title: "Analyses",
              subModules: a,
              initStorage: s,
              storage: c,
              rootSettings: h,
              isMainMenu: !1,
              config: {
                ...p,
                parentId: e,
                parentTitle: v.title,
                typeContainer: Ie.STUDY,
                onReload: z,
                analysisTypes: v.analysisTypes,
                viewMode: j["consent.accept"]
              }
            }
          )
        }
      ),
      /* @__PURE__ */ f.jsx(
        Pe,
        {
          path: "cohorts/*",
          element: /* @__PURE__ */ f.jsx(
            a.cohort,
            {
              name: "cohorts",
              iconName: "cohorts",
              path: `${o}/${e}/cohorts`,
              title: "Cohorts",
              subModules: a,
              initStorage: s,
              storage: c,
              rootSettings: h,
              isMainMenu: !1,
              config: {
                ...p,
                parentId: e,
                parentTitle: v.title,
                typeContainer: Ie.STUDY,
                analysisTypes: v.analysisTypes,
                viewMode: j["consent.accept"]
              }
            }
          )
        }
      ),
      /* @__PURE__ */ f.jsx(
        Pe,
        {
          path: "concept-sets/*",
          element: /* @__PURE__ */ f.jsx(
            a.concept,
            {
              name: "concept-sets",
              iconName: "concept-sets",
              path: `${o}/${e}/concept-sets`,
              title: "Concept sets",
              subModules: a,
              initStorage: s,
              storage: c,
              rootSettings: h,
              viewMode: j["consent.accept"],
              isMainMenu: !1,
              config: {
                ...p,
                parentId: e,
                parentTitle: v.title,
                typeContainer: Ie.STUDY,
                analysisTypes: v.analysisTypes
              }
            }
          )
        }
      ),
      /* @__PURE__ */ f.jsx(
        Pe,
        {
          path: "documents/*",
          element: /* @__PURE__ */ f.jsx(
            a.documents,
            {
              name: "documents",
              iconName: "documents",
              path: `${o}/${e}/documents`,
              title: "Documents",
              subModules: a,
              initStorage: s,
              storage: c,
              rootSettings: h,
              isMainMenu: !1,
              config: {
                ...p,
                parentId: e,
                parentTitle: v.title,
                typeContainer: Ie.STUDY,
                viewMode: j["consent.accept"]
              }
            }
          )
        }
      ),
      /* @__PURE__ */ f.jsx(
        Pe,
        {
          index: !0,
          element: /* @__PURE__ */ f.jsx(
            Cp,
            {
              id: e,
              entity: v,
              actions: j,
              updateEntity: O,
              summary: y,
              summaryStatus: b
            }
          )
        }
      )
    ] })
  ] }) : /* @__PURE__ */ f.jsx(f.Fragment, {});
}, vp = [
  {
    id: pt.INITIATE,
    shortcut: 1,
    name: "Initiate"
  },
  {
    id: pt.ACTIVE,
    shortcut: 2,
    name: "Active"
  },
  {
    id: pt.COMPLETED,
    shortcut: 3,
    name: "Completed"
  },
  {
    id: pt.ARCHIVED,
    shortcut: 4,
    name: "Archived"
  }
], Pr = {
  rowId: "id",
  loadingMessage: "Loading studies...",
  addButtonTitle: "Add study",
  tableTitle: "Studies",
  importButtonTitle: "Add strategus study",
  iconName: "study",
  listInitialSort: { id: "modified.timestamp", desc: !0 },
  createEntityModal: {
    name: "create-study",
    title: "Add study",
    createMethodApi: (e, t) => Ki(e, t, Vr)
  },
  createCrudMethod: (e, t) => Ji(
    e,
    t,
    $r,
    qr
  ),
  createFiltersPanel: (e, t) => Xi(
    e,
    t,
    Yl
  ),
  createSortingMethod(e) {
    return Qi(e, {
      getSorting: Gl
    });
  },
  cols: [
    {
      header: "",
      accessorKey: "favorite",
      id: "actions",
      enableHiding: !1,
      size: 70,
      meta: {
        skeletonKind: "double-icon"
      },
      cell: ({ row: e, renderValue: t }) => /* @__PURE__ */ f.jsx(
        Xr,
        {
          isFavorite: t(),
          isPrivate: e.original.privacy,
          parent: e.original,
          size: 18
        }
      ),
      enableSorting: !1,
      enableResizing: !1
    },
    vl(),
    _l({
      header: "Title",
      accessorKey: "title",
      id: "title",
      size: 320
    }),
    {
      header: "Lead",
      accessorKey: "leads",
      id: "leads",
      cell: Dn,
      size: 150,
      maxSize: 240,
      enableSorting: !1
    },
    {
      header: "My Role",
      accessorKey: "myRoles",
      id: "myRoles",
      cell: Dn,
      disableSortBy: !0,
      size: 160,
      maxSize: 170
    },
    Al(),
    Rl(),
    {
      header: "Type",
      accessorKey: "type.name",
      id: "type",
      meta: {
        skeletonKind: "text"
      },
      cell: (e) => /* @__PURE__ */ f.jsx("span", { children: e.renderValue() }, "type" + e.cell.row.id),
      maxSize: 210,
      enableSorting: !1
    },
    {
      header: "Status",
      accessorKey: "status",
      id: "status",
      size: 60,
      enableSorting: !1,
      enableResizing: !1,
      enableHiding: !1,
      meta: {
        align: "center",
        skeletonKind: "type-icon"
      },
      cell: ({ renderValue: e }) => {
        var n;
        const t = vp.find((r) => r.id === e());
        return /* @__PURE__ */ f.jsx(
          Or,
          {
            tooltipText: t == null ? void 0 : t.name,
            iconName: (n = t == null ? void 0 : t.id) == null ? void 0 : n.toLowerCase()
          }
        );
      }
    }
  ]
}, _p = () => {
  const [e, t] = J(Ln()), n = Ve(), { openModal: r, closeModal: i } = Ne(zr), l = Ne(
    Rt
  ), o = l == null ? void 0 : l.config, { createEntityModal: a } = Pr, s = at(() => a.createMethodApi(), []), c = () => {
    r(
      () => /* @__PURE__ */ f.jsx(
        Oi,
        {
          subModules: l.subModules,
          studyTypes: o.studyTypes,
          createMethod: s == null ? void 0 : s.create,
          onSubmit: (p) => {
            const h = pn(p);
            h ? (Hr(() => {
              n(`/study-manager/${h}`);
            }), i()) : (i(), t(Ln()));
          },
          onClose: i
        }
      ),
      a.title,
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: i
      }
    );
  };
  return /* @__PURE__ */ f.jsx(
    jl,
    {
      isImport: !1,
      onCreate: c,
      reloadId: e,
      moduleConfig: l,
      listConfig: Pr,
      variant: "primary",
      hiddenColumns: { "created.timestamp": !1 }
    }
  );
}, Rt = Vi(null), Ap = (e) => {
  const { path: t, title: n, name: r, storage: i, rootSettings: l, initStorage: o } = e, [a, s] = J(l), [c, p] = J(!0);
  return ae(() => {
    document.title = "Prometheus - Studies", l || s({
      rootPath: t,
      rootTitle: n
    }), p(!1);
  }, []), c ? /* @__PURE__ */ f.jsx(St, { children: /* @__PURE__ */ f.jsx(st, { size: 32 }) }) : /* @__PURE__ */ f.jsx(Rt.Provider, { value: { ...e, rootSettings: a }, children: /* @__PURE__ */ f.jsxs(Fr, { children: [
    /* @__PURE__ */ f.jsx(Pe, { path: ":id/*", element: /* @__PURE__ */ f.jsx(Ip, {}) }),
    /* @__PURE__ */ f.jsx(Pe, { index: !0, element: /* @__PURE__ */ f.jsx(_p, {}) })
  ] }) });
}, Hp = (e) => {
  const { type: t, config: n, ...r } = e, { types: i } = Wr();
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    !t && /* @__PURE__ */ f.jsx(
      Ap,
      {
        type: t,
        ...r,
        config: { ...n, studyTypes: i }
      }
    ),
    t === "component" && /* @__PURE__ */ f.jsx(dp, { ...e })
  ] });
};
export {
  Hp as Study
};
//# sourceMappingURL=study-manager.js.map
